/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/ 		if(executeModules) {
/******/ 			for(i=0; i < executeModules.length; i++) {
/******/ 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
/******/ 			}
/******/ 		}
/******/ 		return result;
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		3: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + ({"1":"vendors","2":"index"}[chunkId]||chunkId) + "." + {"0":"52c7fb5e","1":"018b09c5","2":"5b6edf6d"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "//hd.huya.com/liveoperation/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 445);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(229);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getIterator2=__webpack_require__(227);var _getIterator3=_interopRequireDefault(_getIterator2);var _promise=__webpack_require__(231);var _promise2=_interopRequireDefault(_promise);var _jquery=__webpack_require__(14);var _jquery2=_interopRequireDefault(_jquery);var _openApp=__webpack_require__(212);var _openApp2=_interopRequireDefault(_openApp);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var _ua=navigator.userAgent;var utils={isDebug: true?false:true,isWap:/Mobile/i.test(_ua),isWx:/MicroMessenger/i.test(_ua.toLowerCase()),isQQBrowser:_ua.indexOf('QQBrowser')>-1,//QQ浏览器打开
isAndroid:_ua.indexOf('Android')>-1||_ua.indexOf('Adr')>-1,isIOS:!!_ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),iosVer:_ua.match(/os\s+(\d+)/i)&&_ua.match(/os\s+(\d+)/i)[1]-0,iosVer2:_ua.match(/os\s+(\d+)/i)&&_ua.match(/os\s+(\d+)_(\d+)/i)[2]-0,/**
	 * 异步加载js
	 * @param url
	 * @returns {Promise}
	 */load:function load(url){return new _promise2.default(function(resolve,reject){var script=document.createElement('script');script.type='text/javascript';script.async=true;script.src=url;script.onload=resolve;script.onerror=reject;document.head.appendChild(script);});},/**
     * 数组去重
     * @param arr {Array} 需去重的数组
     */unique:function unique(arr,key){var newArr=[],map={};for(var i=0,len=arr.length;i<len;i++){var item=arr[i];if(!map[item[key]]){newArr.push(item);map[item[key]]=true;}}return newArr;},/**
     * 微信浏览器判断
     * @param callback {Function} 非微信浏览器的回调处理
     */isWxBrowser:function isWxBrowser(callback){if(!this.isWx){callback&&callback({type:'fail',txt:'请在微信中打开本页面'});return false;}return true;},/**
     * 事件绑定 移动端click会转为touchstart,规避click冒泡失效的问题
     * @param obj {DOM} 事件绑定对象
     * @param type {String} 事件名称
     * @param fn   {Function} 方法
     */addEvent:function addEvent(obj,type,fn){if(type==='click'){if("ontouchstart"in document){type='touchstart';}}obj.addEventListener(type,fn,false);},/**
     * 事件解绑 移动端click会转为touchstart,对应addEvent处理
     * @param obj {DOM} 事件移除对象
     * @param type {String} 事件名称
     * @param fn   {Function} 方法
     */removeEvent:function removeEvent(obj,type,fn){if(type==='click'){if("ontouchstart"in document){type='touchstart';}}obj.removeEventListener(type,fn,false);},/**
     * 函数节流方法
     * @param {Function} fn 延时调用函数
     * @param {Number} delay 延迟多长时间
     * @param {Number} atleast 至少多长时间触发一次
     * @return {Function} 延迟执行的方法
     */throttle:function throttle(fn,delay,atleast){var timer=null;var previous=null;return function(){var now=+new Date();if(!previous)previous=now;if(now-previous>atleast){fn();// 重置上一次开始时间为本次结束时间
previous=now;}else{clearTimeout(timer);timer=setTimeout(function(){fn();},delay);}};},/**
     * 数字格式化(以万为基准)
     * @param val    {Number} 需格式化的数值
     * @param ...args   {Number||String} 不定参[保留小数位置|单位]  单位[默认：w]
     */formatNumber:function formatNumber(val){var base=10000,dig=2,unit="w";for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=(0,_getIterator3.default)(args),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var arg=_step.value;if(typeof arg==='string'){unit=arg;}else if(typeof arg==='number'){dig=arg;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}if(val<base){return val;}else{return(val/10000*100).toFixed(dig)/100+unit;}},createIframe:function createIframe(url,callback){var oIframe=document.querySelector("iframeHide");if(!document.querySelector("iframeHide")){var iframe=document.createElement("iframe");iframe.setAttribute("src",url);iframe.style.display="none";document.body.appendChild(iframe);}else{oIframe.onload=function(){callback&&callback();};oIframe.setAttribute("src",url);}},/**
     * 请求封装
     * @param options {Object} 请求相关参数
     * @return 请求句柄  {Deferred}
     */jsonp:function jsonp(options){return _jquery2.default.ajax(_jquery2.default.extend({dataType:'jsonp',cache:true},options));},/**
     * query参数格式化
     * @param query    {String} 不带?的query参数
     * @return 格式化后的query  {Object}
     */parseQuery:function parseQuery(query){if(!!query){var reg=/([^=&\s]+)[=\s]*([^=&\s]*)/g;var obj={};while(reg.exec(query)){obj[RegExp.$1]=RegExp.$2;}return obj;}return null;},/**
     * 设置页面标题
     * @param newTitle {string} 新名字
     */setDocTitle:function setDocTitle(newTitle){document.title=newTitle||'虎牙直播-高颜值美女现场';},/**
     *  跳转app
     */openApp:function openApp(){(0,_openApp2.default)();},/**
     * 开启onerror
     */openOnerror:function openOnerror(){if(this.isDebug){window.onerror=function(errorMessage,scriptURI,lineNumber,columnNumber,errorObj){console.log("错误信息：",errorMessage);alert(["出错文件："+scriptURI,"出错行号："+lineNumber," 出错列号："+columnNumber,"错误详情："+errorObj]);};}},/**
     *  要打印
     * @param {string} msg 要打印的信息
     * @color {string} color 颜色
     */log:function log(msg,color){if(this.isWap){var debug=document.getElementById('debugger');if(!debug){debug=document.createElement('div');debug.id="debugger";debug.style.cssText="position:absolute;top:50%;left:0;right:0;padding:10px;color:red;font-size:0.5rem;z-index:200;word-break:break-all;";document.body.appendChild(debug);}debug.innerHTML+='['+msg+']';}else{color=color||'#fff';console.log('%c '+msg,'background:#000;color:'+color);}},/**
     * wap需要cookie时
     */setDebuggerCookie:function setDebuggerCookie(cookie){setcookieByStr(cookie);},/**
     * 清除cookie
     */clearCookie:function clearCookie(cookie){setcookieByStr(cookie,-1);}};function setcookieByStr(str,expire){(str.split(';')||[]).forEach(function(item){setcookie(item,expire);});}function setcookie(namevalue,expire){var arr=namevalue.split('='),name=arr[0],value=arr[1];var d=new Date();if(expire){d.setTime(d.getTime()+expire);}else{d.setTime(d.getTime()+100*365*24*60*60*1000);}var expires='expires='+d.toUTCString();value=encodeURI(value);document.cookie=name+'='+value+'; '+expires+';domain=.huya.com;path=/';}var queryParams=utils.parseQuery(window.location.search.substr(1))||{};utils.appId=queryParams['promoter']||queryParams['channel']||'huya_h5_10';//获得渠道号
utils.hideHeader=!!+(queryParams['hideHeader']||queryParams['hideheader']||0);//隐藏头尾
utils.hideGift=!!+(queryParams['hideGift']||queryParams['hidegift']||0);//隐藏充值和礼物入口
utils.gid=queryParams['gid']||-2;//获得gid
utils.tid=queryParams['tid']||0;//获得tid
utils.hcol=queryParams['hcol']||3;//获得首页列数
utils.openOnerror();exports.default=utils;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval( code, doc, node ) {
		doc = doc || document;

		var i,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {
				if ( node[ i ] ) {
					script[ i ] = node[ i ];
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.3.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		div.style.position = "absolute";
		scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5
		) );
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),
		val = curCSS( elem, dimension, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox;

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = valueIsBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ dimension ] );

	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	if ( val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

		val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

		// offsetWidth/offsetHeight provide border-box values
		valueIsBorderBox = true;
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),
				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra && boxModelAdjustment(
					elem,
					dimension,
					extra,
					isBorderBox,
					styles
				);

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && support.scrollboxSize() === styles.position ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 15 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(89)('wks');
var uid = __webpack_require__(70);
var Symbol = __webpack_require__(15).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var pubsub=function(){var q={},topics={},subUid=-1;//发布消息
q.publish=function(topic,args){if(!topics[topic]){return;}var subs=topics[topic],len=subs.length;while(len--){subs[len].func(topic,args);}return this;};//订阅事件
q.subscribe=function(topic,func){topics[topic]=topics[topic]?topics[topic]:[];var token=(++subUid).toString();topics[topic].push({token:token,func:func});return token;};// 称除事件
q.remove=function(topic,token){if(topics[topic]&&topics[topic].length>0){topics[topic].forEach(function(item,index){if(item.token===token){topics[topic].splice(index,1);}});}};return q;}();exports.default=pubsub;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _utils=__webpack_require__(12);var _utils2=_interopRequireDefault(_utils);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var logger=function(utils){var logger;if(!!utils.isDebug){logger=console;}else{logger={log:function log(){},info:function info(){},error:function error(){},warn:function warn(){}};}return logger;}(_utils2.default);/**
 * 日志打印
 */exports.default=logger;

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _query=__webpack_require__(50);var _query2=_interopRequireDefault(_query);var _store=__webpack_require__(51);var _store2=_interopRequireDefault(_store);var _udb=__webpack_require__(120);var _udb2=_interopRequireDefault(_udb);var _pubsub=__webpack_require__(18);var _pubsub2=_interopRequireDefault(_pubsub);var _utils=__webpack_require__(12);var _utils2=_interopRequireDefault(_utils);var _h5sdkApi=__webpack_require__(197);var _h5sdkApi2=_interopRequireDefault(_h5sdkApi);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * 登录工具类
 */var Login=function(){function Login(){(0,_classCallCheck3.default)(this,Login);this.searchStr=_query2.default.value;// 获取用户登录信息
this.userInfo=this.getUserInfo();this.udbUtils=new _udb2.default();}(0,_createClass3.default)(Login,[{key:'getUserInfo',value:function getUserInfo(){return{uid:_store2.default.cookie.get('yyuid')||_store2.default.cookie.get('udb_uid'),token:_store2.default.cookie.get('udb_biztoken'),origin:_store2.default.cookie.get('udb_origin'),version:_store2.default.cookie.get('udb_version'),passport:_store2.default.cookie.get('udb_passport'),nickname:_store2.default.cookie.get('nickname'),openid:_store2.default.cookie.get('partner_uid')};}},{key:'refreshUserInfo',value:function refreshUserInfo(){this.userInfo=this.getUserInfo();}/**
     * 登录状态获取
     * @returns {boolean}
     */},{key:'isLogin',value:function isLogin(){var passport=this.userInfo.passport;// 正则判断确保是通过微信账号登录
if(_utils2.default.isWx){if(this.userInfo.uid&&passport&&/^qq_.*/g.test(passport)){return true;}}else{if(this.userInfo.uid){return true;}}return false;}/**
     * 登录唤起,并返回登录态
     */},{key:'toLogin',value:function toLogin(){if(!this.isLogin()){if(_utils2.default.isWx){this.wechat();}else{_pubsub2.default.publish("showLogin");}return false;}return true;}},{key:'wechat',value:function wechat(){var sHref=window.location.href;var params={busiurl:sHref+'#redirectlogin',channel:this.searchStr.promoter||this.searchStr.channel||''};this.udbUtils.wechat(params);}},{key:'thirdLogin',value:function thirdLogin(params){this.udbUtils.third(params);}},{key:'accountLogin',value:function accountLogin(params){this.udbUtils.account(params);}},{key:'verifyPhone',value:function verifyPhone(params){this.udbUtils.verifyPhone(params);}},{key:'getCode',value:function getCode(params){this.udbUtils.code(params);}},{key:'register',value:function register(params){this.udbUtils.register(params);}},{key:'logout',value:function logout(fn){_store2.default.cookie.del('udb_uid');_store2.default.cookie.del('yyuid');this.udbUtils.logout(fn);fn&&fn();}},{key:'addCallback',value:function addCallback(type,fn){if(type==='reg'){this.udbUtils.addRegCallback(fn);}else{this.udbUtils.addLoginCallback(fn);}}},{key:'clearCallback',value:function clearCallback(type){this.udbUtils.claer(type);}},{key:'user',get:function get(){return this.userInfo;}}]);return Login;}();exports.default=new Login();

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var conf={/**
     * 共用链接
     */links:{// app下载链接
downLoad:'http://a.app.qq.com/o/simple.jsp?pkgname=com.duowan.kiwi',universal:''},/**
     * 数据上报
     */report:{'home':'首页','zhibo/gift':'直播间/送礼'},/**
     * 数据接口地址
     */dataUrls:{// 首页分类数据接口
indexTypes:"//open.huya.com"+'/cache.php?m=InterModal&do=getGameInfo',// 首页分类对应直播列表数据接口
indexTypeLiveData:"//open.huya.com"+'/cache.php?m=InterModal&do=getLiveListByGamePage',// 首页某分类下的所有标签
indexTypeTags:"//open.huya.com"+'/cache.php?m=Tag&do=getTagInfo',// 首页分类对应直播列表数据接口
indexTagLiveData:"//open.huya.com"+'/cache.php?m=LiveList&do=getLiveListByPage',// 首页周贡榜数据接口
indexWeekRankData:"//open.huya.com"+'/cache.php?m=InterModal&do=getWeekRank',// 首页热门推荐
indexHotRecData:"//open.huya.com"+'/cache.php?m=Home&do=getHotRecommendModule',// 订阅列表接口
subscribeList:"//open.huya.com"+'/cache.php?m=InterModalUser&do=getSubscribeList',// 直播间信息
roomInfo:"//www.huya.com"+'/cache.php?m=WechatpubH5Api&do=ajaxGetLiveData',// 订阅
subscribe:"//www.huya.com"+'/member/index.php?m=WechatpubH5Api&do=jsonpSubU',// 支付相关
pay:"https://pay.huya.com"+'/index.php?m=PayGoldbeanWechat',// 支付相关
payUn:"https://pay.huya.com"+'/index.php?m=HuyaPayBean'},gid:{xingxiu:1663,//1663,
yanzhi:2168},/**
     * 共用文案
     */tips:{// 列表滚动到底部的下载提示文案
nomore:'到底啦~去虎牙APP，观看更多美女直播~'},gift:{list:[1,10,30,66,188,520,1314],des:{1314:'一生一世',520:'我爱你',188:'要抱抱',66:'一切顺利',30:'想你',10:'十全十美',1:'一心一意'}},/**
     * 充值套餐定义
     * defautVal 默认套餐
     * base  基准金豆数
     * price 每万金豆价格（元）[ price * list[index] = 实际金额]
     * list  套餐内容 [ 实际金豆数 = base * list[index]]
     */topupInfo:{defautVal:1,base:10000,price:12,list:[0.1,1,5,30,100,200]},shareInfo:['热舞八卦深情唱，颜值才艺集一身，%s等你来撩-虎牙直播','点开直播间，找回初恋般的感觉~-虎牙直播','更青春 更校园 来与高颜值的灵魂一起Freestyle~-虎牙直播','性感清纯帅气，总有你所爱，一起来撩主播呀~-虎牙直播','颜值有料，上虎牙就够了！-虎牙直播','颜值炸了？女神男神遍地是，抓紧撩吧！-虎牙直播']};exports.default=conf;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(32);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(15);
var core = __webpack_require__(13);
var ctx = __webpack_require__(54);
var hide = __webpack_require__(36);
var has = __webpack_require__(35);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(40)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(23);
var IE8_DOM_DEFINE = __webpack_require__(129);
var toPrimitive = __webpack_require__(92);
var dP = Object.defineProperty;

exports.f = __webpack_require__(31) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Queue=function(){function Queue(){(0,_classCallCheck3.default)(this,Queue);this.q=[];}(0,_createClass3.default)(Queue,[{key:'add',value:function add(func){if(typeof func!=='function'){console.error('%c<queue add> not function:','color:gray;',func);return false;}this.q.push(func);}},{key:'run',value:function run(param){if(!this.q.length){return false;}for(var i=0;i<this.q.length;i++){this.q[i](param);}}},{key:'clear',value:function clear(){if(!this.q.length){return false;}this.q=[];}}]);return Queue;}();exports.default=Queue;

/***/ }),
/* 35 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(33);
var createDesc = __webpack_require__(68);
module.exports = __webpack_require__(31) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(238), __esModule: true };

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(130);
var defined = __webpack_require__(82);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _utils=__webpack_require__(12);var _utils2=_interopRequireDefault(_utils);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Query=function(){function Query(){(0,_classCallCheck3.default)(this,Query);this.oVal=_utils2.default.parseQuery(window.location.search.substr(1))||{};}(0,_createClass3.default)(Query,[{key:'value',get:function get(){return this.oVal;}}]);return Query;}();exports.default=new Query();

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var _typeof2=__webpack_require__(52);var _typeof3=_interopRequireDefault(_typeof2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}(function(root,factory){if(( false?'undefined':(0,_typeof3.default)(module))==='object'&&module.exports){module.exports=factory();}else{root.store=factory();}})(undefined,function(){function isLocalUseable(){try{var storage=window.localStorage;var x='__storage_test__';storage.setItem(x,1);storage.removeItem(x);return true;}catch(e){return false;}}var store={set:function set(name,value,expire){if(isLocalUseable()){this.local.set(name,value);}else{this.cookie.set(name,value,expire);}},get:function get(name){if(isLocalUseable()){return this.local.get(name);}return this.cookie.get(name);},cookie:{set:function set(name,value,expire){var d=new Date();if(expire){d.setTime(d.getTime()+expire);}else{d.setTime(d.getTime()+100*365*24*60*60*1000);}var expires='expires='+d.toUTCString();value=encodeURI(value);document.cookie=name+'='+value+'; '+expires+';domain=.huya.com;path=/';},get:function get(name){var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");if(arr=document.cookie.match(reg))return decodeURI(arr[2]);else return'';},del:function del(name){// 删除
var exp=new Date();exp.setTime(exp.getTime()-1);var cval=this.get(name);if(cval){this.set(name,'',exp);//document.cookie = name + '=' + cval + ';domain=.yaoguo.com;expires=' + exp.toGMTString();
}}},local:{set:function set(name,value){localStorage.setItem(name,value);},get:function get(name){return localStorage.getItem(name);},del:function del(name){localStorage.removeItem(name);}}};return store;});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(442)(module)))

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(233);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(232);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(65);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _assign=__webpack_require__(39);var _assign2=_interopRequireDefault(_assign);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _queue=__webpack_require__(34);var _queue2=_interopRequireDefault(_queue);var _utils=__webpack_require__(12);var _utils2=_interopRequireDefault(_utils);var _conf=__webpack_require__(22);var _conf2=_interopRequireDefault(_conf);var _logger=__webpack_require__(19);var _logger2=_interopRequireDefault(_logger);var _icoHuya=__webpack_require__(324);var _icoHuya2=_interopRequireDefault(_icoHuya);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WxApi=function(){function WxApi(){(0,_classCallCheck3.default)(this,WxApi);this.jssdkUrl="//res.wx.qq.com/open/js/jweixin-1.2.0.js";this.inited=false;this.queue=new _queue2.default();}/**
     * 微信JSSDK初始化配置
     * @param params {Object} 签名等初始化信息
     */(0,_createClass3.default)(WxApi,[{key:'setWXConfig',value:function setWXConfig(params){var self=this;if(!_utils2.default.isWx){return;}if(window.wx){self.initWX(params);}else{_utils2.default.load(this.jssdkUrl).then(function(){self.initWX(params);_logger2.default.log('wx jssdk load success');}).catch(function(res){_logger2.default.log('wx jssdk load error');});}}},{key:'initWX',value:function initWX(params){var self=this;wx.config({debug:false,//utils.isDebug,
appId:params.appId,timestamp:params.timestamp,nonceStr:params.nonceStr,signature:params.signature,jsApiList:['chooseWXPay','onMenuShareQZone','onMenuShareQQ','onMenuShareAppMessage','onMenuShareTimeline','getNetworkType','getLocation','openLocation']});wx.ready(function(res){_logger2.default.log('微信初始化完成');params.callback&&params.callback();self.inited=true;self.queue.run();});wx.error(function(res){_logger2.default.log('微信初始化失败',res);});}/**
     * 设置分享信息
     */},{key:'setWXShareInfo',value:function setWXShareInfo(shareInfo){if(this.inited){this.callSetWXShareInfo(shareInfo);}else{this.queue.add(function(){this.callSetWXShareInfo(shareInfo);}.bind(this));}}/**
     * 设置分享信息
     */},{key:'callSetWXShareInfo',value:function callSetWXShareInfo(shareInfo){shareInfo=shareInfo||{};wx.ready(function(){var shareData={title:shareInfo.title||'高颜值萝莉等你来撩-虎牙直播',// 分享标题
desc:shareInfo.desc||'颜值美女，英雄大神，顶尖赛事尽在虎牙直播！',// 分享描述
link:shareInfo.link||window.location.href.replace('/subscriber',''),// 分享链接
imgUrl:shareInfo.imgUrl||'http://hd.huya.com/'+_icoHuya2.default,// 分享图标
type:'',// 分享类型,music、video或link，不填默认为link
dataUrl:'',// 如果type是music或video，则要提供数据链接，默认为空
success:function success(){shareInfo.success&&shareInfo.success();},cancel:function cancel(){// 用户取消分享后执行的回调函数
shareInfo.cancel&&shareInfo.cancel();}};var shareTimelineData=(0,_assign2.default)({},shareData);if(shareInfo.page==='room'){shareTimelineData.title+='-虎牙直播';};wx.onMenuShareTimeline(shareTimelineData);//分享到朋友圈”
wx.onMenuShareAppMessage(shareData);//“分享给朋友”
wx.onMenuShareQQ(shareData);//“分享到QQ朋友”
wx.onMenuShareQZone(shareData);//分享到QQ空间”
wx.onMenuShareWeibo(shareData);//“分享到腾讯微博”
});}/**
     * 初始化微信JSSDK
     * @param ready {Function} 微信初始后的调用
     */},{key:'init',value:function init(ready){var oCallback={},self=this;if(!_utils2.default.isWx||this.inited){return;}if(typeof ready==='function'){oCallback.callback=ready;}this.getJsapiSignPackage(function(){self.setWXConfig((0,_assign2.default)(oCallback,self.wxSignInfo));});}/**
     * 获取微信初始化所需信息
     * @param callback 回调函数
     */},{key:'getJsapiSignPackage',value:function getJsapiSignPackage(callback){var self=this;_utils2.default.jsonp({url:_conf2.default.dataUrls.pay,data:{do:'getJsapiSignPackage'}}).done(function(res){if(res.status===200){self.wxSignInfo=res.data.jsapiSignPackage;callback&&callback(self.wxSignInfo);}});}/**
     * 获取网络状态
     */},{key:'getNetWorkType',value:function getNetWorkType(fn){if(this.inited){this.callWxGetNetWorkType(fn);}else{this.queue.add(function(){this.callWxGetNetWorkType(fn);}.bind(this));}}/**
     * 调用wx接口获取网络状态
     * @param fn
     */},{key:'callWxGetNetWorkType',value:function callWxGetNetWorkType(fn){wx.getNetworkType({success:function success(res){fn&&fn();/* var networkType = res.networkType; // 返回网络类型2g，3g，4g，wifi
                if(networkType === 'wifi') {
                    fn && fn();
                }*/}});}/**
     * 获取地址位置
     */},{key:'getLocation',value:function getLocation(fn){if(this.inited){this.callWxGetLocation(fn);}else{this.queue.add(function(){this.callWxGetLocation(fn);}.bind(this));}}/**
     * 微信获取地址位置接口
     * @param fn
     */},{key:'callWxGetLocation',value:function callWxGetLocation(fn){wx.getLocation({type:'wgs84',success:function success(res){res._returnCode=1;fn&&fn(res);},fail:function fail(){fn&&fn({_returnCode:-1,description:'获取地理位置失败'});},cancel:function cancel(){fn&&fn({_returnCode:0,description:'用户拒绝授权获取地理位置'});}});}}]);return WxApi;}();/*eslint-disable no-undef */exports.default=new WxApi();

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(135);
var enumBugKeys = __webpack_require__(84);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(33).f;
var has = __webpack_require__(35);
var TAG = __webpack_require__(17)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(32);
var document = __webpack_require__(15).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(65);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(23);
var dPs = __webpack_require__(261);
var enumBugKeys = __webpack_require__(84);
var IE_PROTO = __webpack_require__(88)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(83)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(128).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 87 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(89)('keys');
var uid = __webpack_require__(70);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(13);
var global = __webpack_require__(15);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(56) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 90 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(82);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(32);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(15);
var core = __webpack_require__(13);
var LIBRARY = __webpack_require__(56);
var wksExt = __webpack_require__(94);
var defineProperty = __webpack_require__(33).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(17);


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(267)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(131)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(271);
var global = __webpack_require__(15);
var hide = __webpack_require__(36);
var Iterators = __webpack_require__(55);
var TO_STRING_TAG = __webpack_require__(17)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof2=__webpack_require__(52);var _typeof3=_interopRequireDefault(_typeof2);var _jquery=__webpack_require__(14);var _jquery2=_interopRequireDefault(_jquery);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*eslint-disable */var Taf=Taf||{};Taf.INT8=function(){this._clone=function(){return 0;};this._write=function(os,tag,val){return os.writeInt8(tag,val);};this._read=function(is,tag,def){return is.readInt8(tag,true,def);};this._className=function(){return Taf.CHAR;};};Taf.INT16=function(){this._clone=function(){return 0;};this._write=function(os,tag,val){return os.writeInt16(tag,val);};this._read=function(is,tag,def){return is.readInt16(tag,true,def);};this._className=function(){return Taf.SHORT;};};Taf.INT32=function(){this._clone=function(){return 0;};this._write=function(os,tag,val){return os.writeInt32(tag,val);};this._read=function(is,tag,def){return is.readInt32(tag,true,def);};this._className=function(){return Taf.INT32;};};Taf.INT64=function(){this._clone=function(){return 0;};this._write=function(os,tag,val){return os.writeInt64(tag,val);};this._read=function(is,tag,def){return is.readInt64(tag,true,def);};this._className=function(){return Taf.INT64;};};Taf.UINT8=function(){this._clone=function(){return 0;};this._write=function(os,tag,val){return os.writeInt16(tag,val);};this._read=function(is,tag,def){return is.readInt16(tag,true,def);};this._className=function(){return Taf.SHORT;};};Taf.UInt16=function(){this._clone=function(){return 0;};this._write=function(os,tag,val){return os.writeInt32(tag,val);};this._read=function(is,tag,def){return is.readInt32(tag,true,def);};this._className=function(){return Taf.INT32;};};Taf.UInt32=function(){this._clone=function(){return 0;};this._write=function(os,tag,val){return os.writeInt64(tag,val);};this._read=function(is,tag,def){return is.readInt64(tag,true,def);};this._className=function(){return Taf.INT64;};};Taf.Float=function(){this._clone=function(){return 0;};this._write=function(os,tag,val){return os.writeFloat(tag,val);};this._read=function(is,tag,def){return is.readFloat(tag,true,def);};this._className=function(){return Taf.FLOAT;};};Taf.Double=function(){this._clone=function(){return 0;};this._write=function(os,tag,val){return os.writeDouble(tag,val);};this._read=function(is,tag,def){return is.readDouble(tag,true,def);};this._className=function(){return Taf.DOUBLE;};};Taf.STRING=function(){this._clone=function(){return 0;};this._write=function(os,tag,val){return os.writeString(tag,val);};this._read=function(is,tag,def){return is.readString(tag,true,def);};this._className=function(){return Taf.STRING;};};Taf.BOOLEAN=function(){this._clone=function(){return false;};this._write=function(os,tag,val){return os.writeBoolean(tag,val);};this._read=function(is,tag,def){return is.readBoolean(tag,true,def);};this._className=function(){return Taf.BOOLEAN;};};Taf.ENUM=function(){this._clone=function(){return 0;};this._write=function(os,tag,val){return os.writeInt32(tag,val);};this._read=function(is,tag,def){return is.readInt32(tag,true,def);};};/**
 * TAFVECTOR实现类
 */Taf.Vector=function(proto){this.proto=proto;this.value=new Array();};Taf.Vector.prototype._clone=function(){return new Taf.Vector(this.proto);};Taf.Vector.prototype._write=function(os,tag,val){return os.writeVector(tag,val);};Taf.Vector.prototype._read=function(is,tag,def){return is.readVector(tag,true,def);};Taf.Vector.prototype._className=function(){return Taf.TypeHelp.VECTOR.replace("$t",this.proto._className());};/**
 * TAFMAP实现类
 */Taf.Map=function(kproto,vproto){this.kproto=kproto;this.vproto=vproto;this.value=new Object();};Taf.Map.prototype._clone=function(){return new Taf.Map(this.kproto,this.vproto);};Taf.Map.prototype._write=function(os,tag,val){return os.writeMap(tag,val);};Taf.Map.prototype._read=function(is,tag,def){return is.readMap(tag,true,def);};Taf.Map.prototype.put=function(key,value){this.value[key]=value;};Taf.Map.prototype.get=function(key){return this.value[key];};Taf.Map.prototype.remove=function(key){delete this.value[key];};Taf.Map.prototype.clear=function(){this.value=new Object();};Taf.Map.prototype.size=function(){var anum=0;for(var key in this.value){anum++;}return anum;};Taf.Vector.prototype._className=function(){return Taf.TypeHelp.Map.replace("$k",this.kproto._className()).replace("$v",this.vproto._className());};var Taf=Taf||{};/**
 * KevinTian@tencent.com
 *
 * JCE编解码底层辅助类
 */Taf.DataHelp={EN_INT8:0,EN_INT16:1,EN_INT32:2,EN_INT64:3,EN_FLOAT:4,EN_DOUBLE:5,EN_STRING1:6,EN_STRING4:7,EN_MAP:8,EN_LIST:9,EN_STRUCTBEGIN:10,EN_STRUCTEND:11,EN_ZERO:12,EN_SIMPLELIST:13};Taf.TypeHelp={BOOLEAN:"bool",CHAR:"char",SHORT:"short",INT32:"int32",INT64:"int64",FLOAT:"float",DOUBLE:"double",STRING:"string",VECTOR:"list<$t>",MAP:"map<$k, $v>"};/**
 * 二进制Buffer类
 */Taf.BinBuffer=function(buffer){this.buf=null;this.vew=null;this.len=0;this.position=0;if(buffer!=null&&buffer!=undefined&&buffer instanceof Taf.BinBuffer){this.buf=buffer.buf;this.vew=new DataView(this.buf);this.len=buffer.length;this.position=buffer.position;}if(buffer!=null&&buffer!=undefined&&buffer instanceof ArrayBuffer){this.buf=buffer;this.vew=new DataView(this.buf);this.len=this.vew.byteLength;this.position=0;}this.__defineGetter__("length",function(){return this.len;});this.__defineGetter__("buffer",function(){return this.buf;});};Taf.BinBuffer.prototype._write=function(os,tag,val){return os.writeBytes(tag,val);};Taf.BinBuffer.prototype._read=function(os,tag,def){return os.readBytes(tag,true,def);};Taf.BinBuffer.prototype._clone=function(){return new Taf.BinBuffer();};Taf.BinBuffer.prototype.allocate=function(uiLength){uiLength=this.position+uiLength;if(this.buf!=null&&this.buf.length>uiLength){return;}var temp=new ArrayBuffer(Math.max(256,uiLength*2));if(this.buf!=null){new Uint8Array(temp).set(new Uint8Array(this.buf));this.buf=undefined;}this.buf=temp;this.vew=undefined;this.vew=new DataView(this.buf);};Taf.BinBuffer.prototype.getBuffer=function(){var temp=new ArrayBuffer(this.len);new Uint8Array(temp).set(new Uint8Array(this.buf,0,this.len));return temp;};Taf.BinBuffer.prototype.memset=function(fbuf,offset,length){this.allocate(length);new Uint8Array(this.buf).set(new Uint8Array(fbuf,offset,length),this.position);};Taf.BinBuffer.prototype.writeInt8=function(value){this.allocate(1);this.vew.setInt8(this.position,value);this.position+=1;this.len=this.position;};Taf.BinBuffer.prototype.writeUInt8=function(value){this.allocate(1);this.vew.setUint8(this.position++,value);this.len=this.position;};Taf.BinBuffer.prototype.writeInt16=function(value){this.allocate(2);this.vew.setInt16(this.position,value);this.position+=2;this.len=this.position;};Taf.BinBuffer.prototype.writeUInt16=function(value){this.allocate(2);this.vew.setUint16(this.position,value);this.position+=2;this.len=this.position;};Taf.BinBuffer.prototype.writeInt32=function(value){this.allocate(4);this.vew.setInt32(this.position,value);this.position+=4;this.len=this.position;};Taf.BinBuffer.prototype.writeUInt32=function(value){this.allocate(4);this.vew.setUint32(this.position,value);this.position+=4;this.len=this.position;};Taf.BinBuffer.prototype.writeInt64=function(value){this.allocate(8);this.vew.setUint32(this.position,parseInt(value/4294967296));this.vew.setUint32(this.position+4,value%4294967296);this.position+=8;this.len=this.position;};Taf.BinBuffer.prototype.writeFloat=function(value){this.allocate(4);this.vew.setFloat32(this.position,value);this.position+=4;this.len=this.position;};Taf.BinBuffer.prototype.writeDouble=function(value){this.allocate(8);this.vew.setFloat64(this.position,value);this.position+=8;this.len=this.position;};Taf.BinBuffer.prototype.writeString=function(value){for(var arr=[],i=0;i<value.length;i++){arr.push(value.charCodeAt(i)&0xFF);}this.allocate(arr.length);new Uint8Array(this.buf).set(new Uint8Array(arr),this.position);this.position+=arr.length;this.len=this.position;};Taf.BinBuffer.prototype.writeBytes=function(value){if(value.length==0||value.buf==null)return;this.allocate(value.length);new Uint8Array(this.buf).set(new Uint8Array(value.buf,0,value.length),this.position);this.position+=value.length;this.len=this.position;};Taf.BinBuffer.prototype.readInt8=function(){return this.vew.getInt8(this.position++);};Taf.BinBuffer.prototype.readInt16=function(){this.position+=2;return this.vew.getInt16(this.position-2);};Taf.BinBuffer.prototype.readInt32=function(){this.position+=4;return this.vew.getInt32(this.position-4);};Taf.BinBuffer.prototype.readUInt8=function(){this.position+=1;return this.vew.getUint8(this.position-1);};Taf.BinBuffer.prototype.readUInt16=function(){this.position+=2;return this.vew.getUint16(this.position-2);};Taf.BinBuffer.prototype.readUInt32=function(){this.position+=4;return this.vew.getUint32(this.position-4);};Taf.BinBuffer.prototype.readInt64=function(){var H4=this.vew.getUint32(this.position);var L4=this.vew.getUint32(this.position+4);this.position+=8;return H4*4294967296+L4;};Taf.BinBuffer.prototype.readFloat=function(){var temp=this.vew.getFloat32(this.position);this.position+=4;return temp;};Taf.BinBuffer.prototype.readDouble=function(){var temp=this.vew.getFloat64(this.position);this.position+=8;return temp;};Taf.BinBuffer.prototype.readString=function(value){for(var arr=[],i=0;i<value;i++){arr.push(String.fromCharCode(this.vew.getUint8(this.position++)));}var result=arr.join("");try{result=decodeURIComponent(escape(result));}catch(e){}return result;};Taf.BinBuffer.prototype.readBytes=function(value){var temp=new Taf.BinBuffer();temp.allocate(value);temp.memset(this.buf,this.position,value);temp.position=0;temp.len=value;this.position=this.position+value;return temp;};/**
 * TAFJCE输出编解码包裹类
 *
 * KevinTian@tencent.com
 */Taf.JceOutputStream=function(){this.buf=new Taf.BinBuffer();this.getBinBuffer=function(){return this.buf;};this.getBuffer=function(){return this.buf.getBuffer();};};Taf.JceOutputStream.prototype.writeTo=function(tag,type){if(tag<15){this.buf.writeUInt8(tag<<4&0xF0|type);}else{this.buf.writeUInt16((0xF0|type)<<8|tag);}};Taf.JceOutputStream.prototype.writeBoolean=function(tag,value){this.writeInt8(tag,value==true?1:0);};Taf.JceOutputStream.prototype.writeInt8=function(tag,value){if(value==0){this.writeTo(tag,Taf.DataHelp.EN_ZERO);}else{this.writeTo(tag,Taf.DataHelp.EN_INT8);this.buf.writeInt8(value);}};Taf.JceOutputStream.prototype.writeInt16=function(tag,value){if(value>=-128&&value<=127){this.writeInt8(tag,value);}else{this.writeTo(tag,Taf.DataHelp.EN_INT16);this.buf.writeInt16(value);}};Taf.JceOutputStream.prototype.writeInt32=function(tag,value){if(value>=-32768&&value<=32767){this.writeInt16(tag,value);}else{this.writeTo(tag,Taf.DataHelp.EN_INT32);this.buf.writeInt32(value);}};Taf.JceOutputStream.prototype.writeInt64=function(tag,value){if(value>=-2147483648&&value<=2147483647){this.writeInt32(tag,value);}else{this.writeTo(tag,Taf.DataHelp.EN_INT64);this.buf.writeInt64(value);}};Taf.JceOutputStream.prototype.writeUInt8=function(tag,value){this.writeInt16(tag,value);};Taf.JceOutputStream.prototype.writeUInt16=function(tag,value){this.writeInt32(tag,value);};Taf.JceOutputStream.prototype.writeUInt32=function(tag,value){this.writeInt64(tag,value);};Taf.JceOutputStream.prototype.writeFloat=function(tag,value){if(value==0){this.writeTo(tag,Taf.DataHelp.EN_ZERO);}else{this.writeTo(tag,Taf.DataHelp.EN_FLOAT);this.buf.writeFloat(value);}};Taf.JceOutputStream.prototype.writeDouble=function(tag,value){if(value==0){this.writeTo(tag,Taf.DataHelp.EN_ZERO);}else{this.writeTo(tag,Taf.DataHelp.EN_DOUBLE);this.buf.writeDouble(value);}};Taf.JceOutputStream.prototype.writeStruct=function(tag,value){if(value.writeTo==undefined){throw Error("not defined writeTo Function");}this.writeTo(tag,Taf.DataHelp.EN_STRUCTBEGIN);value.writeTo(this);this.writeTo(0,Taf.DataHelp.EN_STRUCTEND);};Taf.JceOutputStream.prototype.writeString=function(tag,value){var str=value;try{str=unescape(encodeURIComponent(str));}catch(e){}if(str.length>255){this.writeTo(tag,Taf.DataHelp.EN_STRING4);this.buf.writeUInt32(str.length);}else{this.writeTo(tag,Taf.DataHelp.EN_STRING1);this.buf.writeUInt8(str.length);}this.buf.writeString(str);};Taf.JceOutputStream.prototype.writeBytes=function(tag,value){if(!(value instanceof Taf.BinBuffer)){throw Error("value not instanceof Taf.BinBuffer");}this.writeTo(tag,Taf.DataHelp.EN_SIMPLELIST);this.writeTo(0,Taf.DataHelp.EN_INT8);this.writeInt32(0,value.length);this.buf.writeBytes(value);};Taf.JceOutputStream.prototype.writeVector=function(tag,value){this.writeTo(tag,Taf.DataHelp.EN_LIST);this.writeInt32(0,value.value.length);for(var i=0;i<value.value.length;i++){value.proto._write(this,0,value.value[i]);}};Taf.JceOutputStream.prototype.writeMap=function(tag,value){this.writeTo(tag,Taf.DataHelp.EN_MAP);this.writeInt32(0,value.size());for(var temp in value.value){value.kproto._write(this,0,temp);value.vproto._write(this,1,value.value[temp]);}};/**
 * TAFJCE输入编解码包裹类
 *
 * KevinTian@tencent.com
 */Taf.JceInputStream=function(buffer){this.buf=new Taf.BinBuffer(buffer);};Taf.JceInputStream.prototype.readFrom=function(){var temp=this.buf.readUInt8();var tag=(temp&0xF0)>>4;var type=temp&0x0F;if(tag>=15)tag=this.buf.readUInt8();return{tag:tag,type:type};};Taf.JceInputStream.prototype.peekFrom=function(){var pos=this.buf.position;var head=this.readFrom();this.buf.position=pos;return{tag:head.tag,type:head.type,size:head.tag>=15?2:1};};Taf.JceInputStream.prototype.skipField=function(type){switch(type){case Taf.DataHelp.EN_INT8:this.buf.position+=1;break;case Taf.DataHelp.EN_INT16:this.buf.position+=2;break;case Taf.DataHelp.EN_INT32:this.buf.position+=4;break;case Taf.DataHelp.EN_INT64:this.buf.position+=8;break;case Taf.DataHelp.EN_STRING1:var a=this.buf.readUInt8();this.buf.position+=a;break;case Taf.DataHelp.EN_STRING4:var b=this.buf.readInt32();this.buf.position+=b;break;case Taf.DataHelp.EN_STRUCTBEGIN:this.skipToStructEnd();break;case Taf.DataHelp.EN_STRUCTEND:case Taf.DataHelp.EN_ZERO:break;case Taf.DataHelp.EN_MAP:{var size=this.readInt32(0,true);for(var i=0;i<size*2;++i){var head=this.readFrom();this.skipField(head.type);}break;}case Taf.DataHelp.EN_SIMPLELIST:{var head=this.readFrom();if(head.type!=Taf.DataHelp.EN_INT8){throw Error("skipField with invalid type, type value: "+type+","+head.type);}var a=this.readInt32(0,true);this.buf.position+=a;break;}case Taf.DataHelp.EN_LIST:{var size=this.readInt32(0,true);for(var i=0;i<size;++i){var head=this.readFrom();this.skipField(head.type);}break;}default:throw new Error("skipField with invalid type, type value: "+type);}};Taf.JceInputStream.prototype.skipToStructEnd=function(){for(;;){var head=this.readFrom();this.skipField(head.type);if(head.type==Taf.DataHelp.EN_STRUCTEND){return;}}};Taf.JceInputStream.prototype.skipToTag=function(tag,require){while(this.buf.position<this.buf.length){var head=this.peekFrom();if(tag<=head.tag||head.type==Taf.DataHelp.EN_STRUCTEND){// if ((head.type == Taf.DataHelp.EN_STRUCTEND || tag != head.tag) && require) {
//     break;
// }
// return true;
return head.type==Taf.DataHelp.EN_STRUCTEND?false:tag==head.tag;}this.buf.position+=head.size;this.skipField(head.type);}if(require)throw Error("require field not exist, tag:"+tag);return false;};Taf.JceInputStream.prototype.readBoolean=function(tag,require,def){return this.readInt8(tag,require,def)==1?true:false;};Taf.JceInputStream.prototype.readInt8=function(tag,require,def){if(this.skipToTag(tag,require)==false){return def;}var head=this.readFrom();switch(head.type){case Taf.DataHelp.EN_ZERO:return 0;case Taf.DataHelp.EN_INT8:return this.buf.readInt8();}throw Error("read int8 type mismatch, tag:"+tag+", get type:"+head.type);};Taf.JceInputStream.prototype.readInt16=function(tag,require,def){if(this.skipToTag(tag,require)==false){return def;}var head=this.readFrom();switch(head.type){case Taf.DataHelp.EN_ZERO:return 0;case Taf.DataHelp.EN_INT8:return this.buf.readInt8();case Taf.DataHelp.EN_INT16:return this.buf.readInt16();}throw Error("read int8 type mismatch, tag:"+tag+", get type:"+head.type);};Taf.JceInputStream.prototype.readInt32=function(tag,requrire,def){if(this.skipToTag(tag,requrire)==false){return def;}var head=this.readFrom();switch(head.type){case Taf.DataHelp.EN_ZERO:return 0;case Taf.DataHelp.EN_INT8:return this.buf.readInt8();case Taf.DataHelp.EN_INT16:return this.buf.readInt16();case Taf.DataHelp.EN_INT32:return this.buf.readInt32();}throw Error("read int8 type mismatch, tag:"+tag+", get type:"+head.type);};Taf.JceInputStream.prototype.readInt64=function(tag,require,def){if(this.skipToTag(tag,require)==false){return def;}var head=this.readFrom();switch(head.type){case Taf.DataHelp.EN_ZERO:return 0;case Taf.DataHelp.EN_INT8:return this.buf.readInt8();case Taf.DataHelp.EN_INT16:return this.buf.readInt16();case Taf.DataHelp.EN_INT32:return this.buf.readInt32();case Taf.DataHelp.EN_INT64:return this.buf.readInt64();}throw Error("read int64 type mismatch, tag:"+tag+", get type:"+h.type);};Taf.JceInputStream.prototype.readFloat=function(tag,require,def){if(this.skipToTag(tag,require)==false){return def;}var head=this.readFrom();switch(head.type){case Taf.DataHelp.EN_ZERO:return 0;case Taf.DataHelp.EN_FLOAT:return this.buf.readFloat();}throw Error("read float type mismatch, tag:"+tag+", get type:"+h.type);};Taf.JceInputStream.prototype.readDouble=function(tag,require,def){if(this.skipToTag(tag,require)==false){return def;}var head=this.readFrom();switch(head.type){case Taf.DataHelp.EN_ZERO:return 0;case Taf.DataHelp.EN_DOUBLE:return this.buf.readDouble();}throw Error("read double type mismatch, tag:"+tag+", get type:"+h.type);};Taf.JceInputStream.prototype.readUInt8=function(tag,require,def){return this.readInt16(tag,require,def);};Taf.JceInputStream.prototype.readUInt16=function(tag,require,def){return this.readInt32(tag,require,def);};Taf.JceInputStream.prototype.readUInt32=function(tag,require,def){return this.readInt64(tag,require,def);};Taf.JceInputStream.prototype.readStruct=function(tag,require,def){if(this.skipToTag(tag,require)==false){return def;}var head=this.readFrom();if(head.type!=Taf.DataHelp.EN_STRUCTBEGIN){throw Error("read struct type mismatch, tag: "+tag+", get type:"+head.type);}def.readFrom(this);this.skipToStructEnd();return def;};Taf.JceInputStream.prototype.readString=function(tag,require,def){if(this.skipToTag(tag,require)==false){return def;}var head=this.readFrom();if(head.type==Taf.DataHelp.EN_STRING1){return this.buf.readString(this.buf.readUInt8());}if(head.type==Taf.DataHelp.EN_STRING4){return this.buf.readString(this.buf.readUInt32());}throw Error("read 'string' type mismatch, tag: "+tag+", get type: "+head.type+".");};Taf.JceInputStream.prototype.readString2=function(tag,require,def){if(this.skipToTag(tag,require)==false){return def;}var head=this.readFrom();if(head.type==Taf.DataHelp.EN_STRING1){return this.buf.readBytes(this.buf.readUInt8());}if(head.type==Taf.DataHelp.EN_STRING4){return this.buf.readBytes(this.buf.readUInt32());}throw Error("read 'string' type mismatch, tag: "+tag+", get type: "+head.type+".");};Taf.JceInputStream.prototype.readBytes=function(tag,require,def){if(this.skipToTag(tag,require)==false){return def;}var head=this.readFrom();if(head.type==Taf.DataHelp.EN_SIMPLELIST){var temp=this.readFrom();if(temp.type!=Taf.DataHelp.EN_INT8){throw Error("type mismatch, tag:"+tag+",type:"+head.type+","+temp.type);}var size=this.readInt32(0,true);if(size<0){throw Error("invalid size, tag:"+tag+",type:"+head.type+","+temp.type);}return this.buf.readBytes(size);}if(head.type==Taf.DataHelp.EN_LIST){var size=this.readInt32(0,true);return this.buf.readBytes(size);}throw Error("type mismatch, tag:"+tag+",type:"+head.type);};Taf.JceInputStream.prototype.readVector=function(tag,require,def){if(this.skipToTag(tag,require)==false){return def;}var head=this.readFrom();if(head.type!=Taf.DataHelp.EN_LIST){throw Error("read 'vector' type mismatch, tag: "+tag+", get type: "+head.type);}var size=this.readInt32(0,true);if(size<0){throw Error("invalid size, tag: "+tag+", type: "+head.type+", size: "+size);}for(var i=0;i<size;++i){def.value.push(def.proto._read(this,0,def.proto._clone()));}return def;};Taf.JceInputStream.prototype.readMap=function(tag,require,def){if(this.skipToTag(tag,require)==false){return def;}var head=this.readFrom();if(head.type!=Taf.DataHelp.EN_MAP){throw Error("read 'map' type mismatch, tag: "+tag+", get type: "+head.type);}var size=this.readInt32(0,true);if(size<0){throw Error("invalid map, tag: "+tag+", size: "+size);}for(var i=0;i<size;i++){var key=def.kproto._read(this,0,def.kproto._clone());var val=def.vproto._read(this,1,def.vproto._clone());def.put(key,val);}return def;};var Taf=Taf||{};/**
 * WUP使用类
 *
 */Taf.Wup=function(){this.iVersion=3;this.cPacketType=0;this.iMessageType=0;this.iRequestId=0;this.sServantName='';this.sFuncName='';this.sBuffer=new Taf.BinBuffer();this.iTimeout=0;this.context=new Taf.Map(new Taf.STRING(),new Taf.STRING());this.status=new Taf.Map(new Taf.STRING(),new Taf.STRING());this.data=new Taf.Map(new Taf.STRING(),new Taf.Map(new Taf.STRING(),new Taf.BinBuffer()));this.newdata=new Taf.Map(new Taf.STRING(),new Taf.BinBuffer());};Taf.Wup.prototype.setVersion=function(value){this.iVersion=value;};Taf.Wup.prototype.getVersion=function(value){return this.iVersion;};Taf.Wup.prototype.setServant=function(value){this.sServantName=value;};Taf.Wup.prototype.setFunc=function(value){this.sFuncName=value;};Taf.Wup.prototype.setRequestId=function(value){this.iRequestId=value?value:++this.iRequestId;};Taf.Wup.prototype.getRequestId=function(){return this.iRequestId;};Taf.Wup.prototype.setTimeOut=function(value){this.iTimeout=value;};Taf.Wup.prototype.getTimeOut=function(){return this.iTimeout;};Taf.Wup.prototype.writeTo=function(){// body...
var os=new Taf.JceOutputStream();os.writeInt16(1,this.iVersion);os.writeInt8(2,this.cPacketType);os.writeInt32(3,this.iMessageType);os.writeInt32(4,this.iRequestId);os.writeString(5,this.sServantName);os.writeString(6,this.sFuncName);os.writeBytes(7,this.sBuffer);os.writeInt32(8,this.iTimeout);os.writeMap(9,this.context);os.writeMap(10,this.status);return new Taf.BinBuffer(os.getBuffer());};Taf.Wup.prototype.encode=function(){var os=new Taf.JceOutputStream();if(this.iVersion==3){os.writeMap(0,this.newdata);}else{os.writeMap(0,this.data);}this.sBuffer=os.getBinBuffer();var temp=new Taf.BinBuffer();temp=this.writeTo();var buf=new Taf.BinBuffer();buf.writeInt32(4+temp.len);buf.writeBytes(temp);return buf;};Taf.Wup.prototype.writeBoolean=function(name,value){var os=new Taf.JceOutputStream();os.writeBoolean(0,value);if(this.iVersion==3){this.newdata.put(name,new Taf.BinBuffer(os.getBuffer()));}else{var temp=this.data.get(name);var classType=TAF.TypeHelp.BOOLEAN;if(temp==undefined){var newNode=new Taf.Map(Taf.STRING,Taf.STRING);temp=newNode;}temp.put(classType,new Taf.BinBuffer(os.getBuffer()));this.data.put(name,temp);}};Taf.Wup.prototype.writeInt8=function(name,value){var os=new Taf.JceOutputStream();os.writeInt8(0,value);if(this.iVersion==3){this.newdata.put(name,new Taf.BinBuffer(os.getBuffer()));}else{var temp=this.data.get(name);var classType=TAF.TypeHelp.CHAR;if(temp==undefined){var newNode=new Taf.Map(Taf.STRING,Taf.STRING);temp=newNode;}temp.put(classType,new Taf.BinBuffer(os.getBuffer()));this.data.put(name,temp);}};Taf.Wup.prototype.writeInt16=function(name,value){var os=new Taf.JceOutputStream();os.writeInt16(0,value);if(this.iVersion==3){this.newdata.put(name,new Taf.BinBuffer(os.getBuffer()));}else{var temp=this.data.get(name);var classType=TAF.TypeHelp.SHORT;if(temp==undefined){var newNode=new Taf.Map(Taf.STRING,Taf.STRING);temp=newNode;}temp.put(classType,new Uint8Array(os.getBuffer()));this.data.put(name,temp);}};Taf.Wup.prototype.writeInt32=function(name,value){var os=new Taf.JceOutputStream();os.writeInt32(0,value);if(this.iVersion==3){this.newdata.put(name,new Taf.BinBuffer(os.getBuffer()));}else{var temp=this.data.get(name);var classType=TAF.TypeHelp.INT32;if(temp==undefined){var newNode=new Taf.Map(Taf.STRING,Taf.STRING);temp=newNode;}temp.put(classType,new Uint8Array(os.getBuffer()));this.data.put(name,temp);}};Taf.Wup.prototype.writeInt64=function(name,value){var os=new Taf.JceOutputStream();os.writeInt64(0,value);if(this.iVersion==3){this.newdata.put(name,new Taf.BinBuffer(os.getBuffer()));}else{var temp=this.data.get(name);var classType=TAF.TypeHelp.INT64;if(temp==undefined){var newNode=new Taf.Map(Taf.STRING,Taf.STRING);temp=newNode;}temp.put(classType,new Uint8Array(os.getBuffer()));this.data.put(name,temp);}};Taf.Wup.prototype.writeFloat=function(name,value){var os=new Taf.JceOutputStream();os.writeFloat(0,value);if(this.iVersion==3){this.newdata.put(name,new Taf.BinBuffer(os.getBuffer()));}else{var temp=this.data.get(name);var classType=TAF.TypeHelp.FLOAT;if(temp==undefined){var newNode=new Taf.Map(Taf.STRING,Taf.STRING);temp=newNode;}temp.put(classType,new Uint8Array(os.getBuffer()));this.data.put(name,temp);}};Taf.Wup.prototype.writeDouble=function(name,value){var os=new Taf.JceOutputStream();os.writeDouble(0,value);if(this.iVersion==3){this.newdata.put(name,new Taf.BinBuffer(os.getBuffer()));}else{var temp=this.data.get(name);var classType=TAF.TypeHelp.DOUBLE;if(temp==undefined){var newNode=new Taf.Map(Taf.STRING,Taf.STRING);temp=newNode;}temp.put(classType,new Uint8Array(os.getBuffer()));this.data.put(name,temp);}};Taf.Wup.prototype.writeString=function(name,value){var os=new Taf.JceOutputStream();os.writeString(0,value);if(this.iVersion==3){this.newdata.put(name,new Taf.BinBuffer(os.getBuffer()));}else{var temp=this.data.get(name);var classType=Taf.TypeHelp.STRING;if(temp==undefined){var newNode=new Taf.Map(Taf.STRING,Taf.STRING);temp=newNode;}temp.put(classType,new Uint8Array(os.getBuffer()));this.data.put(name,temp);}};Taf.Wup.prototype.writeVector=function(name,value){var os=new Taf.JceOutputStream();os.writeVector(0,value);if(this.iVersion==3){this.newdata.put(name,new Taf.BinBuffer(os.getBinBuffer()));}else{var temp=this.data.get(name);var classType=value._className();if(temp==undefined){var newNode=new Taf.Map(Taf.STRING,Taf.STRING);temp=newNode;}temp.put(classType,new Uint8Array(os.getBuffer()));this.data.put(name,temp);}};Taf.Wup.prototype.writeStruct=function(name,value){var os=new Taf.JceOutputStream();os.writeStruct(0,value);if(this.iVersion==3){this.newdata.put(name,new Taf.BinBuffer(os.getBuffer()));}else{var temp=this.data.get(name);//todo
var classType=" ";if(temp==undefined){var newNode=new Taf.Map(Taf.STRING,Taf.STRING);temp=newNode;}temp.put(classType,new Uint8Array(os.getBuffer()));this.data.put(name,temp);}};Taf.Wup.prototype.writeBytes=function(name,value){var os=new Taf.JceOutputStream();os.writeBytes(0,value);if(this.iVersion==3){this.newdata.put(name,new Taf.BinBuffer(os.getBuffer()));}else{var temp=this.data.get(name);var classType="vec";if(temp==undefined){var newNode=new Taf.Map(Taf.STRING,Taf.STRING);temp=newNode;}temp.put(classType,new Uint8Array(os.getBuffer()));this.data.put(name,temp);}};Taf.Wup.prototype.writeMap=function(name,value){var os=new Taf.JceOutputStream();os.writeMap(0,value);if(this.iVersion==3){this.newdata.put(name,new Taf.BinBuffer(os.getBuffer()));}else{var temp=this.data.get(name);var classType=Taf.Util.getClassType(value);if(temp==undefined){var newNode=new Taf.Map(Taf.STRING,Taf.STRING);temp=newNode;}temp.put(classType,new Uint8Array(os.getBuffer()));this.data.put(name,temp);}};Taf.Wup.prototype.readFrom=function(is){this.iVersion=is.readInt16(1,true);this.cPacketType=is.readInt8(2,true);this.iMessageType=is.readInt32(3,true);this.iRequestId=is.readInt32(4,true);this.sServantName=is.readString(5,true);this.sFuncName=is.readString(6,true);if(localStorage.__wup){console.info('%c@@@ '+this.sServantName+'.'+this.sFuncName,'color:white;background:black;',this);}this.sBuffer=is.readBytes(7,true);this.iTimeout=is.readInt32(8,true);this.context=is.readMap(9,true);this.status=is.readMap(10,true);};Taf.Wup.prototype.decode=function(buf){var is=new Taf.JceInputStream(buf);var len=is.buf.vew.getInt32(is.buf.position);if(len<4){throw Error("packet length too short");}// is.buf.length = len;
is.buf.position+=4;this.readFrom(is);is=new Taf.JceInputStream(this.sBuffer.getBuffer());if(this.iVersion==3){this.newdata.clear();is.readMap(0,true,this.newdata);}else{this.data.clear();is.readMap(0,true,this.newdata);}};Taf.Wup.prototype.readBoolean=function(name){var temp,def;if(this.iVersion==3){temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var is=new Taf.JceInputStream(temp.buffer);def=is.readBoolean(0,true,def);}else{temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var className=Taf.TypeHelp.BOOLEAN;var newNode=temp.get(className);if(newNode==undefined){throw Error("UniAttribute not found type:"+className);}var is=new Taf.JceInputStream(newNode);def=is.readBoolean(0,true,def);}return def;};Taf.Wup.prototype.readInt8=function(name){var temp,def;if(this.iVersion==3){temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var is=new Taf.JceInputStream(temp.buffer);def=is.readInt8(0,true,def);}else{temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var className=Taf.TypeHelp.CHAR;var newNode=temp.get(className);if(newNode==undefined){throw Error("UniAttribute not found type:"+className);}var is=new Taf.JceInputStream(newNode);def=is.readInt8(0,true,def);}return def;};Taf.Wup.prototype.readInt16=function(name){var temp,def;if(this.iVersion==3){temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var is=new Taf.JceInputStream(temp.buffer);def=is.readInt16(0,true,def);}else{temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var className=Taf.TypeHelp.SHORT;var newNode=temp.get(className);var is=new Taf.JceInputStream(newNode);if(newNode==undefined){throw Error("UniAttribute not found type:"+className);}def=is.readInt16(0,true,def);}return def;};Taf.Wup.prototype.readInt32=function(name){var temp,def;if(this.iVersion==3){temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var is=new Taf.JceInputStream(temp.buffer);def=is.readInt32(0,true,def);}else{temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var className=Taf.TypeHelp.INT32;var newNode=temp.get(className);if(newNode==undefined){throw Error("UniAttribute not found type:"+className);}var is=new Taf.JceInputStream(newNode);def=is.readInt32(0,true,def);}return def;};Taf.Wup.prototype.readInt64=function(name){var temp,def;if(this.iVersion==3){temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var is=new Taf.JceInputStream(temp.buffer);def=is.readInt64(0,true,def);}else{temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var className=Taf.TypeHelp.INT64;var newNode=temp.get(className);if(newNode==undefined){throw Error("UniAttribute not found type:"+className);}var is=new Taf.JceInputStream(newNode);def=is.readInt64(0,true,def);}return def;};Taf.Wup.prototype.readFloat=function(name){var temp,def;if(this.iVersion==3){temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var is=new Taf.JceInputStream(temp.buffer);def=is.readFloat(0,true,def);}else{temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var className=Taf.TypeHelp.FLOAT;var newNode=temp.get(className);if(newNode==undefined){throw Error("UniAttribute not found type:"+className);}var is=new Taf.JceInputStream(newNode);def=is.readFloat(0,true,def);}return def;};Taf.Wup.prototype.readDouble=function(name){var temp;if(this.iVersion==3){temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var is=new Taf.JceInputStream(temp.buffer);def=is.readDouble(0,true,def);}else{temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var className=Taf.TypeHelp.DOUBLE;var newNode=temp.get(className);if(newNode==undefined){throw Error("UniAttribute not found type:"+className);}var is=new Taf.JceInputStream(newNode);def=is.readDouble(0,true,def);}return def;};Taf.Wup.prototype.readVector=function(name,def,className){var temp;if(this.iVersion==3){temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var is=new Taf.JceInputStream(temp.buffer);def=is.readVector(0,true,def);}else{temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var newNode=temp.get(className);if(newNode==undefined){throw Error("UniAttribute not found type:"+className);}var is=new Taf.JceInputStream(newNode);def=is.readVector(0,true,def);}return def;};Taf.Wup.prototype.readStruct=function(name,def,className){var temp;if(this.iVersion==3){temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var is=new Taf.JceInputStream(temp.buffer);def=is.readStruct(0,true,def);}else{temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var newNode=temp.get(className);if(newNode==undefined){throw Error("UniAttribute not found type:"+className);}var is=new Taf.JceInputStream(newNode);def=is.readStruct(0,true,def);}return def;};Taf.Wup.prototype.readMap=function(name,def,className){var temp;if(this.iVersion==3){temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var is=new Taf.JceInputStream(temp.buffer);def=is.readMap(0,true,def);}else{temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var newNode=temp.get(className);if(newNode==undefined){throw Error("UniAttribute not found type:"+className);}var is=new Taf.JceInputStream(newNode);def=is.readMap(0,true,def);}return def;};Taf.Wup.prototype.readBytes=function(name,def,className){var temp;if(this.iVersion==3){temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var is=new Taf.JceInputStream(temp.buffer);def=is.readBytes(0,true,def);}else{temp=this.newdata.get(name);if(temp==undefined){throw Error("UniAttribute not found key:"+name);}var newNode=temp.get(className);if(newNode==undefined){throw Error("UniAttribute not found type:"+className);}var is=new Taf.JceInputStream(newNode);def=is.readBytes(0,true,def);}return def;};var Taf=Taf||{};Taf.Util=Taf.Util||{};Taf.Util.jcestream=function(value,col){if(value==null||value==undefined){console.log("Taf.Util.jcestream::value is null or undefined");return;}if(!(value instanceof ArrayBuffer)){console.log("Taf.Util.jcestream::value is not ArrayBuffer");return;}col=col||16;var view=new Uint8Array(value);var str="";for(var i=0;i<view.length;i++){if(i!=0&&i%col==0){str+="\n";}else if(i!=0){str+=" ";}str+=(view[i]>15?"":"0")+view[i].toString(16);}console.log(str.toUpperCase());};Taf.Util.str2ab=function(value){var idx,len=value.length,arr=new Array(len);for(idx=0;idx<len;++idx){arr[idx]=value.charCodeAt(idx);}return new Uint8Array(arr).buffer;};Taf.Util.ajax=function(sURL,oData,oSuccFunc,oFailFunc){var xmlobj=new XMLHttpRequest();xmlobj.overrideMimeType('text/plain; charset=x-user-defined');//必须的&&一定要设置
var handleStateChange=function handleStateChange(){if(xmlobj.readyState===4){if(xmlobj.status===200||xmlobj.status===304){oSuccFunc(Taf.Util.str2ab(xmlobj.response));}else{oFailFunc(xmlobj.status);}xmlobj.removeEventListener('readystatechange',handleStateChange);xmlobj=undefined;}};xmlobj.addEventListener('readystatechange',handleStateChange);xmlobj.open("post",sURL);xmlobj.send(oData);};;//This file depends on Taf.min.js
var HUYA=HUYA||{};HUYA.EWebSocketCommandType={EWSCmd_NULL:0,EWSCmd_RegisterReq:1,EWSCmd_RegisterRsp:2,EWSCmd_WupReq:3,EWSCmd_WupRsp:4,EWSCmdC2S_HeartBeat:5,EWSCmdS2C_HeartBeatAck:6,EWSCmdS2C_MsgPushReq:7,EWSCmdC2S_DeregisterReq:8,EWSCmdS2C_DeRegisterRsp:9,EWSCmdC2S_VerifyCookieReq:10,EWSCmdS2C_VerifyCookieRsp:11,EWSCmdC2S_VerifyHuyaTokenReq:12,EWSCmdS2C_VerifyHuyaTokenRsp:13};HUYA.ELiveSource={PC_YY:0,PC_HUYA:1,MOBILE_HUYA:2,WEB_HUYA:3};HUYA.EGender={MALE:0,FEMALE:1};HUYA.EClientTemplateType={TPL_PC:64,TPL_WEB:32,TPL_JIEDAI:16,TPL_TEXAS:8,TPL_MATCH:4,TPL_HUYAAPP:2,TPL_MIRROR:1};HUYA.TemplateType={PRIMARY:1,RECEPTION:2};HUYA.EStreamLineType={STREAM_LINE_OLD_YY:0,STREAM_LINE_WS:1,STREAM_LINE_NEW_YY:2,STREAM_LINE_AL:3,STREAM_LINE_HUYA:4,STREAM_LINE_TX:5,STREAM_LINE_CDN:8};HUYA.eUserOperation={USER_IN:1,USER_OUT:2,USER_MOVE:3};HUYA.WebSocketCommand=function(){this.iCmdType=0;this.vData=new Taf.BinBuffer();this.lRequestId=0;};HUYA.WebSocketCommand.prototype._clone=function(){return new HUYA.WebSocketCommand();};HUYA.WebSocketCommand.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.WebSocketCommand.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.WebSocketCommand.prototype.writeTo=function(os){os.writeInt32(0,this.iCmdType);os.writeBytes(1,this.vData);os.writeInt64(2,this.lRequestId);};HUYA.WebSocketCommand.prototype.readFrom=function(is){this.iCmdType=is.readInt32(0,false,this.iCmdType);this.vData=is.readBytes(1,false,this.vData);this.lRequestId=is.readInt64(2,false,this.lRequestId);};HUYA.WSRegisterRsp=function(){this.iResCode=0;this.lRequestId=0;this.sMessage="";this.sBCConnHost="";};HUYA.WSRegisterRsp.prototype._clone=function(){return new HUYA.WSRegisterRsp();};HUYA.WSRegisterRsp.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.WSRegisterRsp.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.WSRegisterRsp.prototype.writeTo=function(os){os.writeInt32(0,this.iResCode);os.writeInt64(1,this.lRequestId);os.writeString(2,this.sMessage);os.writeString(3,this.sBCConnHost);};HUYA.WSRegisterRsp.prototype.readFrom=function(is){this.iResCode=is.readInt32(0,false,this.iResCode);this.lRequestId=is.readInt64(1,false,this.lRequestId);this.sMessage=is.readString(2,false,this.sMessage);this.sBCConnHost=is.readString(3,false,this.sBCConnHost);};HUYA.WSPushMessage=function(){this.ePushType=0;this.iUri=0;this.sMsg=new Taf.BinBuffer();this.iProtocolType=0;};HUYA.WSPushMessage.prototype._clone=function(){return new HUYA.WSPushMessage();};HUYA.WSPushMessage.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.WSPushMessage.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.WSPushMessage.prototype.writeTo=function(os){os.writeInt32(0,this.ePushType);os.writeInt64(1,this.iUri);os.writeBytes(2,this.sMsg);os.writeInt32(3,this.iProtocolType);};HUYA.WSPushMessage.prototype.readFrom=function(is){this.ePushType=is.readInt32(0,false,this.ePushType);this.iUri=is.readInt64(1,false,this.iUri);this.sMsg=is.readBytes(2,false,this.sMsg);this.iProtocolType=is.readInt32(3,false,this.iProtocolType);};HUYA.WSHeartBeat=function(){this.iState=0;};HUYA.WSHeartBeat.prototype._clone=function(){return new HUYA.WSHeartBeat();};HUYA.WSHeartBeat.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.WSHeartBeat.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.WSHeartBeat.prototype.writeTo=function(os){os.writeInt32(0,this.iState);};HUYA.WSHeartBeat.prototype.readFrom=function(is){this.iState=is.readInt32(0,false,this.iState);};HUYA.WSUserInfo=function(){this.lUid=0;this.bAnonymous=true;this.sGuid="";this.sToken="";this.lTid=0;this.lSid=0;this.lGroupId=0;this.lGroupType=0;this.sAppId="";};HUYA.WSUserInfo.prototype._clone=function(){return new HUYA.WSUserInfo();};HUYA.WSUserInfo.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.WSUserInfo.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.WSUserInfo.prototype.writeTo=function(os){os.writeInt64(0,this.lUid);os.writeBoolean(1,this.bAnonymous);os.writeString(2,this.sGuid);os.writeString(3,this.sToken);os.writeInt64(4,this.lTid);os.writeInt64(5,this.lSid);os.writeInt64(6,this.lGroupId);os.writeInt64(7,this.lGroupType);os.writeString(8,this.sAppId);};HUYA.WSUserInfo.prototype.readFrom=function(is){this.lUid=is.readInt64(0,false,this.lUid);this.bAnonymous=is.readBoolean(1,false,this.bAnonymous);this.sGuid=is.readString(2,false,this.sGuid);this.sToken=is.readString(3,false,this.sToken);this.lTid=is.readInt64(4,false,this.lTid);this.lSid=is.readInt64(5,false,this.lSid);this.lGroupId=is.readInt64(6,false,this.lGroupId);this.lGroupType=is.readInt64(7,false,this.lGroupType);this.sAppId=is.readString(8,false,this.sAppId);};HUYA.WSVerifyCookieReq=function(){this.lUid=0;this.sUA="";this.sCookie="";};HUYA.WSVerifyCookieReq.prototype._clone=function(){return new HUYA.WSVerifyCookieReq();};HUYA.WSVerifyCookieReq.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.WSVerifyCookieReq.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.WSVerifyCookieReq.prototype.writeTo=function(os){os.writeInt64(0,this.lUid);os.writeString(1,this.sUA);os.writeString(2,this.sCookie);};HUYA.WSVerifyCookieReq.prototype.readFrom=function(is){this.lUid=is.readInt64(0,false,this.lUid);this.sUA=is.readString(1,false,this.sUA);this.sCookie=is.readString(2,false,this.sCookie);};HUYA.WSVerifyCookieRsp=function(){this.iValidate=0;};HUYA.WSVerifyCookieRsp.prototype._clone=function(){return new HUYA.WSVerifyCookieRsp();};HUYA.WSVerifyCookieRsp.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.WSVerifyCookieRsp.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.WSVerifyCookieRsp.prototype.writeTo=function(os){os.writeInt32(0,this.iValidate);};HUYA.WSVerifyCookieRsp.prototype.readFrom=function(is){this.iValidate=is.readInt32(0,false,this.iValidate);};HUYA.UserId=function(){this.lUid=0;this.sGuid="";this.sToken="";this.sHuYaUA="";this.sCookie="";this.iTokenType=0;};HUYA.UserId.prototype._clone=function(){return new HUYA.UserId();};HUYA.UserId.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.UserId.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.UserId.prototype.writeTo=function(os){os.writeInt64(0,this.lUid);os.writeString(1,this.sGuid);os.writeString(2,this.sToken);os.writeString(3,this.sHuYaUA);os.writeString(4,this.sCookie);os.writeInt32(5,this.iTokenType);};HUYA.UserId.prototype.readFrom=function(is){this.lUid=is.readInt64(0,false,this.lUid);this.sGuid=is.readString(1,false,this.sGuid);this.sToken=is.readString(2,false,this.sToken);this.sHuYaUA=is.readString(3,false,this.sHuYaUA);this.sCookie=is.readString(4,false,this.sCookie);this.iTokenType=is.readInt32(5,false,this.iTokenType);};HUYA.EnterChannelReq=function(){this.tUserId=new HUYA.UserId();this.lTid=0;this.lSid=0;this.iChannelType=0;};HUYA.EnterChannelReq.prototype._clone=function(){return new HUYA.EnterChannelReq();};HUYA.EnterChannelReq.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.EnterChannelReq.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.EnterChannelReq.prototype.writeTo=function(os){os.writeStruct(1,this.tUserId);os.writeInt64(2,this.lTid);os.writeInt64(3,this.lSid);os.writeInt32(4,this.iChannelType);};HUYA.EnterChannelReq.prototype.readFrom=function(is){this.tUserId=is.readStruct(1,false,this.tUserId);this.lTid=is.readInt64(2,false,this.lTid);this.lSid=is.readInt64(3,false,this.lSid);this.iChannelType=is.readInt32(4,false,this.iChannelType);};HUYA.UserEventReq=function(){this.tId=new HUYA.UserId();this.lTid=0;this.lSid=0;this.eOp=0;this.sChan="";this.eSource=0;this.lPid=0;this.bWatchVideo=false;this.bAnonymous=false;this.eTemplateType=HUYA.TemplateType.PRIMARY;this.sTraceSource="";};HUYA.UserEventReq.prototype._clone=function(){return new HUYA.UserEventReq();};HUYA.UserEventReq.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.UserEventReq.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.UserEventReq.prototype.writeTo=function(os){os.writeStruct(0,this.tId);os.writeInt64(1,this.lTid);os.writeInt64(2,this.lSid);os.writeInt32(4,this.eOp);os.writeString(5,this.sChan);os.writeInt32(6,this.eSource);os.writeInt64(7,this.lPid);os.writeBoolean(8,this.bWatchVideo);os.writeBoolean(9,this.bAnonymous);os.writeInt32(10,this.eTemplateType);os.writeString(11,this.sTraceSource);};HUYA.UserEventReq.prototype.readFrom=function(is){this.tId=is.readStruct(0,false,this.tId);this.lTid=is.readInt64(1,false,this.lTid);this.lSid=is.readInt64(2,false,this.lSid);this.eOp=is.readInt32(4,false,this.eOp);this.sChan=is.readString(5,false,this.sChan);this.eSource=is.readInt32(6,false,this.eSource);this.lPid=is.readInt64(7,false,this.lPid);this.bWatchVideo=is.readBoolean(8,false,this.bWatchVideo);this.bAnonymous=is.readBoolean(9,false,this.bAnonymous);this.eTemplateType=is.readInt32(10,false,this.eTemplateType);this.sTraceSource=is.readString(11,false,this.sTraceSource);};HUYA.UserEventRsp=function(){this.lTid=0;this.lSid=0;this.iUserHeartBeatInterval=60;this.iPresentHeartBeatInterval=60;};HUYA.UserEventRsp.prototype._clone=function(){return new HUYA.UserEventRsp();};HUYA.UserEventRsp.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.UserEventRsp.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.UserEventRsp.prototype.writeTo=function(os){os.writeInt64(0,this.lTid);os.writeInt64(1,this.lSid);os.writeInt32(2,this.iUserHeartBeatInterval);os.writeInt32(3,this.iPresentHeartBeatInterval);};HUYA.UserEventRsp.prototype.readFrom=function(is){this.lTid=is.readInt64(0,false,this.lTid);this.lSid=is.readInt64(1,false,this.lSid);this.iUserHeartBeatInterval=is.readInt32(2,false,this.iUserHeartBeatInterval);this.iPresentHeartBeatInterval=is.readInt32(3,false,this.iPresentHeartBeatInterval);};HUYA.UserHeartBeatReq=function(){this.tId=new HUYA.UserId();this.lTid=0;this.lSid=0;this.lPid=0;this.bWatchVideo=false;this.eLineType=HUYA.EStreamLineType.STREAM_LINE_OLD_YY;this.iFps=0;this.iAttendee=0;this.iBandwidth=0;this.iLastHeartElapseTime=0;};HUYA.UserHeartBeatReq.prototype._clone=function(){return new HUYA.UserHeartBeatReq();};HUYA.UserHeartBeatReq.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.UserHeartBeatReq.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.UserHeartBeatReq.prototype.writeTo=function(os){os.writeStruct(0,this.tId);os.writeInt64(1,this.lTid);os.writeInt64(2,this.lSid);os.writeInt64(4,this.lPid);os.writeBoolean(5,this.bWatchVideo);os.writeInt32(6,this.eLineType);os.writeInt32(7,this.iFps);os.writeInt32(8,this.iAttendee);os.writeInt32(9,this.iBandwidth);os.writeInt32(10,this.iLastHeartElapseTime);};HUYA.UserHeartBeatReq.prototype.readFrom=function(is){this.tId=is.readStruct(0,false,this.tId);this.lTid=is.readInt64(1,false,this.lTid);this.lSid=is.readInt64(2,false,this.lSid);this.lPid=is.readInt64(4,false,this.lPid);this.bWatchVideo=is.readBoolean(5,false,this.bWatchVideo);this.eLineType=is.readInt32(6,false,this.eLineType);this.iFps=is.readInt32(7,false,this.iFps);this.iAttendee=is.readInt32(8,false,this.iAttendee);this.iBandwidth=is.readInt32(9,false,this.iBandwidth);this.iLastHeartElapseTime=is.readInt32(10,false,this.iLastHeartElapseTime);};HUYA.UserHeartBeatRsp=function(){this.iRet=0;};HUYA.UserHeartBeatRsp.prototype._clone=function(){return new HUYA.UserHeartBeatRsp();};HUYA.UserHeartBeatRsp.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.UserHeartBeatRsp.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.UserHeartBeatRsp.prototype.writeTo=function(os){os.writeInt32(0,this.iRet);};HUYA.UserHeartBeatRsp.prototype.readFrom=function(is){this.iRet=is.readInt32(0,false,this.iRet);};HUYA.SendMessageReq=function(){this.tUserId=new HUYA.UserId();this.lTid=0;this.lSid=0;this.sContent="";this.iShowMode=0;this.tFormat=new HUYA.ContentFormat();this.tBulletFormat=new HUYA.BulletFormat();this.vAtSomeone=new Taf.Vector(new HUYA.UidNickName());this.lPid=0;};HUYA.SendMessageReq.prototype._clone=function(){return new HUYA.SendMessageReq();};HUYA.SendMessageReq.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.SendMessageReq.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.SendMessageReq.prototype.writeTo=function(os){os.writeStruct(0,this.tUserId);os.writeInt64(1,this.lTid);os.writeInt64(2,this.lSid);os.writeString(3,this.sContent);os.writeInt32(4,this.iShowMode);os.writeStruct(5,this.tFormat);os.writeStruct(6,this.tBulletFormat);os.writeVector(7,this.vAtSomeone);os.writeInt64(8,this.lPid);};HUYA.SendMessageReq.prototype.readFrom=function(is){this.tUserId=is.readStruct(0,false,this.tUserId);this.lTid=is.readInt64(1,false,this.lTid);this.lSid=is.readInt64(2,false,this.lSid);this.sContent=is.readString(3,false,this.sContent);this.iShowMode=is.readInt32(4,false,this.iShowMode);this.tFormat=is.readStruct(5,false,this.tFormat);this.tBulletFormat=is.readStruct(6,false,this.tBulletFormat);this.vAtSomeone=is.readVector(7,false,this.vAtSomeone);this.lPid=is.readInt64(8,false,this.lPid);};HUYA.SendMessageRsp=function(){this.iStatus=0;this.tNotice=new HUYA.MessageNotice();};HUYA.SendMessageRsp.prototype._clone=function(){return new HUYA.SendMessageRsp();};HUYA.SendMessageRsp.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.SendMessageRsp.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.SendMessageRsp.prototype.writeTo=function(os){os.writeInt32(0,this.iStatus);os.writeStruct(1,this.tNotice);};HUYA.SendMessageRsp.prototype.readFrom=function(is){this.iStatus=is.readInt32(0,false,this.iStatus);this.tNotice=is.readStruct(1,false,this.tNotice);};HUYA.MessageNotice=function(){this.tUserInfo=new HUYA.SenderInfo();this.lTid=0;this.lSid=0;this.sContent="";this.iShowMode=0;this.tFormat=new HUYA.ContentFormat();this.tBulletFormat=new HUYA.BulletFormat();this.iTermType=0;this.vDecorationPrefix=new Taf.Vector(new HUYA.DecorationInfo());this.vDecorationSuffix=new Taf.Vector(new HUYA.DecorationInfo());this.vAtSomeone=new Taf.Vector(new HUYA.UidNickName());this.lPid=0;};HUYA.MessageNotice.prototype._clone=function(){return new HUYA.MessageNotice();};HUYA.MessageNotice.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.MessageNotice.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.MessageNotice.prototype.writeTo=function(os){os.writeStruct(0,this.tUserInfo);os.writeInt64(1,this.lTid);os.writeInt64(2,this.lSid);os.writeString(3,this.sContent);os.writeInt32(4,this.iShowMode);os.writeStruct(5,this.tFormat);os.writeStruct(6,this.tBulletFormat);os.writeInt32(7,this.iTermType);os.writeVector(8,this.vDecorationPrefix);os.writeVector(9,this.vDecorationSuffix);os.writeVector(10,this.vAtSomeone);os.writeInt64(11,this.lPid);};HUYA.MessageNotice.prototype.readFrom=function(is){this.tUserInfo=is.readStruct(0,false,this.tUserInfo);this.lTid=is.readInt64(1,false,this.lTid);this.lSid=is.readInt64(2,false,this.lSid);this.sContent=is.readString(3,false,this.sContent);this.iShowMode=is.readInt32(4,false,this.iShowMode);this.tFormat=is.readStruct(5,false,this.tFormat);this.tBulletFormat=is.readStruct(6,false,this.tBulletFormat);this.iTermType=is.readInt32(7,false,this.iTermType);this.vDecorationPrefix=is.readVector(8,false,this.vDecorationPrefix);this.vDecorationSuffix=is.readVector(9,false,this.vDecorationSuffix);this.vAtSomeone=is.readVector(10,false,this.vAtSomeone);this.lPid=is.readInt64(11,false,this.lPid);};HUYA.ContentFormat=function(){this.iFontColor=-1;this.iFontSize=4;this.iPopupStyle=0;};HUYA.ContentFormat.prototype._clone=function(){return new HUYA.ContentFormat();};HUYA.ContentFormat.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.ContentFormat.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.ContentFormat.prototype.writeTo=function(os){os.writeInt32(0,this.iFontColor);os.writeInt32(1,this.iFontSize);os.writeInt32(2,this.iPopupStyle);};HUYA.ContentFormat.prototype.readFrom=function(is){this.iFontColor=is.readInt32(0,false,this.iFontColor);this.iFontSize=is.readInt32(1,false,this.iFontSize);this.iPopupStyle=is.readInt32(2,false,this.iPopupStyle);};HUYA.BulletFormat=function(){this.iFontColor=-1;this.iFontSize=4;this.iTextSpeed=0;this.iTransitionType=1;this.iPopupStyle=0;};HUYA.BulletFormat.prototype._clone=function(){return new HUYA.BulletFormat();};HUYA.BulletFormat.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.BulletFormat.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.BulletFormat.prototype.writeTo=function(os){os.writeInt32(0,this.iFontColor);os.writeInt32(1,this.iFontSize);os.writeInt32(2,this.iTextSpeed);os.writeInt32(3,this.iTransitionType);os.writeInt32(4,this.iPopupStyle);};HUYA.BulletFormat.prototype.readFrom=function(is){this.iFontColor=is.readInt32(0,false,this.iFontColor);this.iFontSize=is.readInt32(1,false,this.iFontSize);this.iTextSpeed=is.readInt32(2,false,this.iTextSpeed);this.iTransitionType=is.readInt32(3,false,this.iTransitionType);this.iPopupStyle=is.readInt32(4,false,this.iPopupStyle);};HUYA.UidNickName=function(){this.lUid=0;this.sNickName="";};HUYA.UidNickName.prototype._clone=function(){return new HUYA.UidNickName();};HUYA.UidNickName.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.UidNickName.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.UidNickName.prototype.writeTo=function(os){os.writeInt64(0,this.lUid);os.writeString(1,this.sNickName);};HUYA.UidNickName.prototype.readFrom=function(is){this.lUid=is.readInt64(0,false,this.lUid);this.sNickName=is.readString(1,false,this.sNickName);};HUYA.SenderInfo=function(){this.lUid=0;this.lImid=0;this.sNickName="";this.iGender=0;this.sAvatarUrl="";};HUYA.SenderInfo.prototype._clone=function(){return new HUYA.SenderInfo();};HUYA.SenderInfo.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.SenderInfo.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.SenderInfo.prototype.writeTo=function(os){os.writeInt64(0,this.lUid);os.writeInt64(1,this.lImid);os.writeString(2,this.sNickName);os.writeInt32(3,this.iGender);os.writeString(4,this.sAvatarUrl);};HUYA.SenderInfo.prototype.readFrom=function(is){this.lUid=is.readInt64(0,false,this.lUid);this.lImid=is.readInt64(1,false,this.lImid);this.sNickName=is.readString(2,false,this.sNickName);this.iGender=is.readInt32(3,false,this.iGender);this.sAvatarUrl=is.readString(4,false,this.sAvatarUrl);};HUYA.DecorationInfo=function(){this.iAppId=0;this.iViewType=0;this.vData=new Taf.BinBuffer();};HUYA.DecorationInfo.prototype._clone=function(){return new HUYA.DecorationInfo();};HUYA.DecorationInfo.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.DecorationInfo.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.DecorationInfo.prototype.writeTo=function(os){os.writeInt32(0,this.iAppId);os.writeInt32(1,this.iViewType);os.writeBytes(2,this.vData);};HUYA.DecorationInfo.prototype.readFrom=function(is){this.iAppId=is.readInt32(0,false,this.iAppId);this.iViewType=is.readInt32(1,false,this.iViewType);this.vData=is.readBytes(2,false,this.vData);};HUYA.EDecorationAppType={kDecorationAppTypeCommon:100,kDecorationAppTypeChannel:10000,kDecorationAppTypeAdmin:10100,kDecorationAppTypeDaiyanClub:10150,kDecorationAppTypeNoble:10200,kDecorationAppTypeGuard:10300,kDecorationAppTypeFans:10400,kDecorationAppTypeVIP:10500,kDecorationAppTypeUserProfile:10560,kDecorationAppTyperPurpleDiamond:10600,kDecorationAppTypeStamp:10700,KDecorationAppTypeNobleEmoticon:10800,KDecorationAppTypePresenter:10900,KDecorationAppTypeFirstRecharge:11000};HUYA.EDecorationViewType={kDecorationViewTypeCustomized:0,kDecorationViewTypeText:1,kDecorationViewTypeIcon:2};HUYA.MsgCommDecoChannelRoleInfo=function(){this.iLevel=0;};HUYA.MsgCommDecoChannelRoleInfo.prototype._clone=function(){return new HUYA.MsgCommDecoChannelRoleInfo();};HUYA.MsgCommDecoChannelRoleInfo.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.MsgCommDecoChannelRoleInfo.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.MsgCommDecoChannelRoleInfo.prototype.writeTo=function(os){os.writeInt32(0,this.iLevel);};HUYA.MsgCommDecoChannelRoleInfo.prototype.readFrom=function(is){this.iLevel=is.readInt32(0,false,this.iLevel);};HUYA.GetStampRsp=function(){this.lUid=0;this.lStampUid=0;this.sStampNick="";this.lStampTime=0;this.tStampInfo=new HUYA.StampInfo();this.lDeadline=0;};HUYA.GetStampRsp.prototype._clone=function(){return new HUYA.GetStampRsp();};HUYA.GetStampRsp.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.GetStampRsp.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.GetStampRsp.prototype.writeTo=function(os){os.writeInt64(0,this.lUid);os.writeInt64(1,this.lStampUid);os.writeString(2,this.sStampNick);os.writeInt64(3,this.lStampTime);os.writeStruct(4,this.tStampInfo);os.writeInt64(5,this.lDeadline);};HUYA.GetStampRsp.prototype.readFrom=function(is){this.lUid=is.readInt64(0,false,this.lUid);this.lStampUid=is.readInt64(1,false,this.lStampUid);this.sStampNick=is.readString(2,false,this.sStampNick);this.lStampTime=is.readInt64(3,false,this.lStampTime);this.tStampInfo=is.readStruct(4,false,this.tStampInfo);this.lDeadline=is.readInt64(5,false,this.lDeadline);};HUYA.StampInfo=function(){this.iId=0;this.sStamp="";this.iLevel=0;this.lStampPrice=0;this.iValidity=0;};HUYA.StampInfo.prototype._clone=function(){return new HUYA.StampInfo();};HUYA.StampInfo.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.StampInfo.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.StampInfo.prototype.writeTo=function(os){os.writeInt32(0,this.iId);os.writeString(1,this.sStamp);os.writeInt32(2,this.iLevel);os.writeInt64(3,this.lStampPrice);os.writeInt32(4,this.iValidity);};HUYA.StampInfo.prototype.readFrom=function(is){this.iId=is.readInt32(0,false,this.iId);this.sStamp=is.readString(1,false,this.sStamp);this.iLevel=is.readInt32(2,false,this.iLevel);this.lStampPrice=is.readInt64(3,false,this.lStampPrice);this.iValidity=is.readInt32(4,false,this.iValidity);};HUYA.MsgCommDecoIcon=function(){this.sUrl="";};HUYA.MsgCommDecoIcon.prototype._clone=function(){return new HUYA.MsgCommDecoIcon();};HUYA.MsgCommDecoIcon.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.MsgCommDecoIcon.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.MsgCommDecoIcon.prototype.writeTo=function(os){os.writeString(0,this.sUrl);};HUYA.MsgCommDecoIcon.prototype.readFrom=function(is){this.sUrl=is.readString(0,false,this.sUrl);};HUYA.MsgCommDecoText=function(){this.sText="";this.iColor=0;};HUYA.MsgCommDecoText.prototype._clone=function(){return new HUYA.MsgCommDecoText();};HUYA.MsgCommDecoText.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.MsgCommDecoText.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.MsgCommDecoText.prototype.writeTo=function(os){os.writeString(0,this.sText);os.writeInt32(1,this.iColor);};HUYA.MsgCommDecoText.prototype.readFrom=function(is){this.sText=is.readString(0,false,this.sText);this.iColor=is.readInt32(1,false,this.iColor);};HUYA.GetUserTypeRsp=function(){this.lUid=0;this.lPresenterUid=0;this.iType=0;this.tIsMutedRsp=new HUYA.IsMutedRsp();};HUYA.GetUserTypeRsp.prototype._clone=function(){return new HUYA.GetUserTypeRsp();};HUYA.GetUserTypeRsp.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.GetUserTypeRsp.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.GetUserTypeRsp.prototype.writeTo=function(os){os.writeInt64(0,this.lUid);os.writeInt64(1,this.lPresenterUid);os.writeInt32(3,this.iType);os.writeStruct(4,this.tIsMutedRsp);};HUYA.GetUserTypeRsp.prototype.readFrom=function(is){this.lUid=is.readInt64(0,false,this.lUid);this.lPresenterUid=is.readInt64(1,false,this.lPresenterUid);this.iType=is.readInt32(3,false,this.iType);this.tIsMutedRsp=is.readStruct(4,false,this.tIsMutedRsp);};HUYA.IsMutedRsp=function(){this.bMuted=false;this.iMutedTime=0;this.lAutoUnmutedTime=0;this.iMutedType=0;};HUYA.IsMutedRsp.prototype._clone=function(){return new HUYA.IsMutedRsp();};HUYA.IsMutedRsp.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.IsMutedRsp.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.IsMutedRsp.prototype.writeTo=function(os){os.writeBoolean(0,this.bMuted);os.writeInt32(1,this.iMutedTime);os.writeInt64(2,this.lAutoUnmutedTime);os.writeInt32(3,this.iMutedType);};HUYA.IsMutedRsp.prototype.readFrom=function(is){this.bMuted=is.readBoolean(0,false,this.bMuted);this.iMutedTime=is.readInt32(1,false,this.iMutedTime);this.lAutoUnmutedTime=is.readInt64(2,false,this.lAutoUnmutedTime);this.iMutedType=is.readInt32(3,false,this.iMutedType);};HUYA.MsgCommDecoGuardInfo=function(){this.iLevel=0;};HUYA.MsgCommDecoGuardInfo.prototype._clone=function(){return new HUYA.MsgCommDecoGuardInfo();};HUYA.MsgCommDecoGuardInfo.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.MsgCommDecoGuardInfo.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.MsgCommDecoGuardInfo.prototype.writeTo=function(os){os.writeInt32(0,this.iLevel);};HUYA.MsgCommDecoGuardInfo.prototype.readFrom=function(is){this.iLevel=is.readInt32(0,false,this.iLevel);};HUYA.PurpleVipInfo=function(){this.lUid=0;this.iIsSuper=0;this.iChargeType=0;this.iVipGrade=0;this.sIconUrl="";};HUYA.PurpleVipInfo.prototype._clone=function(){return new HUYA.PurpleVipInfo();};HUYA.PurpleVipInfo.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.PurpleVipInfo.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.PurpleVipInfo.prototype.writeTo=function(os){os.writeInt64(0,this.lUid);os.writeInt32(1,this.iIsSuper);os.writeInt32(2,this.iChargeType);os.writeInt32(3,this.iVipGrade);os.writeString(4,this.sIconUrl);};HUYA.PurpleVipInfo.prototype.readFrom=function(is){this.lUid=is.readInt64(0,false,this.lUid);this.iIsSuper=is.readInt32(1,false,this.iIsSuper);this.iChargeType=is.readInt32(2,false,this.iChargeType);this.iVipGrade=is.readInt32(3,false,this.iVipGrade);this.sIconUrl=is.readString(4,false,this.sIconUrl);};HUYA.BadgeInfo=function(){this.lUid=0;this.lBadgeId=0;this.sPresenterNickName="";this.sBadgeName="";this.iBadgeLevel=0;this.iRank=0;this.iScore=0;this.iNextScore=0;this.iQuotaUsed=0;this.iQuota=0;this.lQuotaTS=0;this.lOpenTS=0;this.iVFlag=0;this.sVLogo="";this.tChannelInfo=new HUYA.PresenterChannelInfo();this.sPresenterLogo="";this.lVExpiredTS=0;};HUYA.BadgeInfo.prototype._clone=function(){return new HUYA.BadgeInfo();};HUYA.BadgeInfo.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.BadgeInfo.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.BadgeInfo.prototype.writeTo=function(os){os.writeInt64(0,this.lUid);os.writeInt64(1,this.lBadgeId);os.writeString(2,this.sPresenterNickName);os.writeString(3,this.sBadgeName);os.writeInt32(4,this.iBadgeLevel);os.writeInt32(5,this.iRank);os.writeInt32(6,this.iScore);os.writeInt32(7,this.iNextScore);os.writeInt32(8,this.iQuotaUsed);os.writeInt32(9,this.iQuota);os.writeInt64(10,this.lQuotaTS);os.writeInt64(11,this.lOpenTS);os.writeInt32(12,this.iVFlag);os.writeString(13,this.sVLogo);os.writeStruct(14,this.tChannelInfo);os.writeString(15,this.sPresenterLogo);os.writeInt64(16,this.lVExpiredTS);};HUYA.BadgeInfo.prototype.readFrom=function(is){this.lUid=is.readInt64(0,false,this.lUid);this.lBadgeId=is.readInt64(1,false,this.lBadgeId);this.sPresenterNickName=is.readString(2,false,this.sPresenterNickName);this.sBadgeName=is.readString(3,false,this.sBadgeName);this.iBadgeLevel=is.readInt32(4,false,this.iBadgeLevel);this.iRank=is.readInt32(5,false,this.iRank);this.iScore=is.readInt32(6,false,this.iScore);this.iNextScore=is.readInt32(7,false,this.iNextScore);this.iQuotaUsed=is.readInt32(8,false,this.iQuotaUsed);this.iQuota=is.readInt32(9,false,this.iQuota);this.lQuotaTS=is.readInt64(10,false,this.lQuotaTS);this.lOpenTS=is.readInt64(11,false,this.lOpenTS);this.iVFlag=is.readInt32(12,false,this.iVFlag);this.sVLogo=is.readString(13,false,this.sVLogo);this.tChannelInfo=is.readStruct(14,false,this.tChannelInfo);this.sPresenterLogo=is.readString(15,false,this.sPresenterLogo);this.lVExpiredTS=is.readInt64(16,false,this.lVExpiredTS);};HUYA.GuardInfo=function(){this.lUid=0;this.lPid=0;this.iGuardLevel=0;this.lEndTime=0;};HUYA.GuardInfo.prototype._clone=function(){return new HUYA.GuardInfo();};HUYA.GuardInfo.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.GuardInfo.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.GuardInfo.prototype.writeTo=function(os){os.writeInt64(0,this.lUid);os.writeInt64(1,this.lPid);os.writeInt32(2,this.iGuardLevel);os.writeInt64(3,this.lEndTime);};HUYA.GuardInfo.prototype.readFrom=function(is){this.lUid=is.readInt64(0,false,this.lUid);this.lPid=is.readInt64(1,false,this.lPid);this.iGuardLevel=is.readInt32(2,false,this.iGuardLevel);this.lEndTime=is.readInt64(3,false,this.lEndTime);};HUYA.GetLivingInfoReq=function(){this.tId=new HUYA.UserId();this.lTopSid=0;this.lSubSid=0;this.lPresenterUid=0;this.sTraceSource="";};HUYA.GetLivingInfoReq.prototype._clone=function(){return new HUYA.GetLivingInfoReq();};HUYA.GetLivingInfoReq.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.GetLivingInfoReq.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.GetLivingInfoReq.prototype.writeTo=function(os){os.writeStruct(0,this.tId);os.writeInt64(1,this.lTopSid);os.writeInt64(2,this.lSubSid);os.writeInt64(3,this.lPresenterUid);os.writeString(4,this.sTraceSource);};HUYA.GetLivingInfoReq.prototype.readFrom=function(is){this.tId=is.readStruct(0,false,this.tId);this.lTopSid=is.readInt64(1,false,this.lTopSid);this.lSubSid=is.readInt64(2,false,this.lSubSid);this.lPresenterUid=is.readInt64(3,false,this.lPresenterUid);this.sTraceSource=is.readString(4,false,this.sTraceSource);};HUYA.GetLivingInfoRsp=function(){this.bIsLiving=0;this.tNotice=new HUYA.BeginLiveNotice();this.tStreamSettingNotice=new HUYA.StreamSettingNotice();this.bIsSelfLiving=0;};HUYA.GetLivingInfoRsp.prototype._clone=function(){return new HUYA.GetLivingInfoRsp();};HUYA.GetLivingInfoRsp.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.GetLivingInfoRsp.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.GetLivingInfoRsp.prototype.writeTo=function(os){os.writeInt32(0,this.bIsLiving);os.writeStruct(1,this.tNotice);os.writeStruct(2,this.tStreamSettingNotice);os.writeInt32(3,this.bIsSelfLiving);};HUYA.GetLivingInfoRsp.prototype.readFrom=function(is){this.bIsLiving=is.readInt32(0,false,this.bIsLiving);this.tNotice=is.readStruct(1,false,this.tNotice);this.tStreamSettingNotice=is.readStruct(2,false,this.tStreamSettingNotice);this.bIsSelfLiving=is.readInt32(3,false,this.bIsSelfLiving);};HUYA.BeginLiveNotice=function(){this.lPresenterUid=0;this.iGameId=0;this.sGameName="";this.iRandomRange=0;this.iStreamType=0;this.vStreamInfo=new Taf.Vector(new HUYA.StreamInfo());this.vCdnList=new Taf.Vector(new Taf.STRING());this.lLiveId=0;this.iPCDefaultBitRate=0;this.iWebDefaultBitRate=0;this.iMobileDefaultBitRate=0;this.lMultiStreamFlag=0;this.sNick="";this.lYYId=0;this.lAttendeeCount=0;this.iCodecType=0;this.iScreenType=0;this.vMultiStreamInfo=new Taf.Vector(new HUYA.MultiStreamInfo());this.sLiveDesc="";this.lLiveCompatibleFlag=0;this.sAvatarUrl="";this.iSourceType=0;this.sSubchannelName="";this.sVideoCaptureUrl="";this.iStartTime=0;this.lChannelId=0;this.lSubChannelId=0;this.sLocation="";this.iCdnPolicyLevel=0;this.iGameType=0;this.mMiscInfo=new Taf.Map(new Taf.STRING(),new Taf.STRING());this.iShortChannel=0;};HUYA.BeginLiveNotice.prototype._clone=function(){return new HUYA.BeginLiveNotice();};HUYA.BeginLiveNotice.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.BeginLiveNotice.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.BeginLiveNotice.prototype.writeTo=function(os){os.writeInt64(0,this.lPresenterUid);os.writeInt32(1,this.iGameId);os.writeString(2,this.sGameName);os.writeInt32(3,this.iRandomRange);os.writeInt32(4,this.iStreamType);os.writeVector(5,this.vStreamInfo);os.writeVector(6,this.vCdnList);os.writeInt64(7,this.lLiveId);os.writeInt32(8,this.iPCDefaultBitRate);os.writeInt32(9,this.iWebDefaultBitRate);os.writeInt32(10,this.iMobileDefaultBitRate);os.writeInt64(11,this.lMultiStreamFlag);os.writeString(12,this.sNick);os.writeInt64(13,this.lYYId);os.writeInt64(14,this.lAttendeeCount);os.writeInt32(15,this.iCodecType);os.writeInt32(16,this.iScreenType);os.writeVector(17,this.vMultiStreamInfo);os.writeString(18,this.sLiveDesc);os.writeInt64(19,this.lLiveCompatibleFlag);os.writeString(20,this.sAvatarUrl);os.writeInt32(21,this.iSourceType);os.writeString(22,this.sSubchannelName);os.writeString(23,this.sVideoCaptureUrl);os.writeInt32(24,this.iStartTime);os.writeInt64(25,this.lChannelId);os.writeInt64(26,this.lSubChannelId);os.writeString(27,this.sLocation);os.writeInt32(28,this.iCdnPolicyLevel);os.writeInt32(29,this.iGameType);os.writeMap(30,this.mMiscInfo);os.writeInt32(31,this.iShortChannel);};HUYA.BeginLiveNotice.prototype.readFrom=function(is){this.lPresenterUid=is.readInt64(0,false,this.lPresenterUid);this.iGameId=is.readInt32(1,false,this.iGameId);this.sGameName=is.readString(2,false,this.sGameName);this.iRandomRange=is.readInt32(3,false,this.iRandomRange);this.iStreamType=is.readInt32(4,false,this.iStreamType);this.vStreamInfo=is.readVector(5,false,this.vStreamInfo);this.vCdnList=is.readVector(6,false,this.vCdnList);this.lLiveId=is.readInt64(7,false,this.lLiveId);this.iPCDefaultBitRate=is.readInt32(8,false,this.iPCDefaultBitRate);this.iWebDefaultBitRate=is.readInt32(9,false,this.iWebDefaultBitRate);this.iMobileDefaultBitRate=is.readInt32(10,false,this.iMobileDefaultBitRate);this.lMultiStreamFlag=is.readInt64(11,false,this.lMultiStreamFlag);this.sNick=is.readString(12,false,this.sNick);this.lYYId=is.readInt64(13,false,this.lYYId);this.lAttendeeCount=is.readInt64(14,false,this.lAttendeeCount);this.iCodecType=is.readInt32(15,false,this.iCodecType);this.iScreenType=is.readInt32(16,false,this.iScreenType);this.vMultiStreamInfo=is.readVector(17,false,this.vMultiStreamInfo);this.sLiveDesc=is.readString(18,false,this.sLiveDesc);this.lLiveCompatibleFlag=is.readInt64(19,false,this.lLiveCompatibleFlag);this.sAvatarUrl=is.readString(20,false,this.sAvatarUrl);this.iSourceType=is.readInt32(21,false,this.iSourceType);this.sSubchannelName=is.readString(22,false,this.sSubchannelName);this.sVideoCaptureUrl=is.readString(23,false,this.sVideoCaptureUrl);this.iStartTime=is.readInt32(24,false,this.iStartTime);this.lChannelId=is.readInt64(25,false,this.lChannelId);this.lSubChannelId=is.readInt64(26,false,this.lSubChannelId);this.sLocation=is.readString(27,false,this.sLocation);this.iCdnPolicyLevel=is.readInt32(28,false,this.iCdnPolicyLevel);this.iGameType=is.readInt32(29,false,this.iGameType);this.mMiscInfo=is.readMap(30,false,this.mMiscInfo);this.iShortChannel=is.readInt32(31,false,this.iShortChannel);};HUYA.StreamInfo=function(){this.sCdnType="";this.iIsMaster=0;this.lChannelId=0;this.lSubChannelId=0;this.lPresenterUid=0;this.sStreamName="";this.sFlvUrl="";this.sFlvUrlSuffix="";this.sFlvAntiCode="";this.sHlsUrl="";this.sHlsUrlSuffix="";this.sHlsAntiCode="";this.iLineIndex=0;this.iIsMultiStream=0;this.iPCPriorityRate=0;this.iWebPriorityRate=0;this.iMobilePriorityRate=0;this.vFlvIPList=new Taf.Vector(new Taf.STRING());this.iIsP2PSupport=0;this.sP2pUrl="";this.sP2pUrlSuffix="";this.sP2pAntiCode="";this.lFreeFlag=0;};HUYA.StreamInfo.prototype._clone=function(){return new HUYA.StreamInfo();};HUYA.StreamInfo.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.StreamInfo.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.StreamInfo.prototype.writeTo=function(os){os.writeString(0,this.sCdnType);os.writeInt32(1,this.iIsMaster);os.writeInt64(2,this.lChannelId);os.writeInt64(3,this.lSubChannelId);os.writeInt64(4,this.lPresenterUid);os.writeString(5,this.sStreamName);os.writeString(6,this.sFlvUrl);os.writeString(7,this.sFlvUrlSuffix);os.writeString(8,this.sFlvAntiCode);os.writeString(9,this.sHlsUrl);os.writeString(10,this.sHlsUrlSuffix);os.writeString(11,this.sHlsAntiCode);os.writeInt32(12,this.iLineIndex);os.writeInt32(13,this.iIsMultiStream);os.writeInt32(14,this.iPCPriorityRate);os.writeInt32(15,this.iWebPriorityRate);os.writeInt32(16,this.iMobilePriorityRate);os.writeVector(17,this.vFlvIPList);os.writeInt32(18,this.iIsP2PSupport);os.writeString(19,this.sP2pUrl);os.writeString(20,this.sP2pUrlSuffix);os.writeString(21,this.sP2pAntiCode);os.writeInt64(22,this.lFreeFlag);};HUYA.StreamInfo.prototype.readFrom=function(is){this.sCdnType=is.readString(0,false,this.sCdnType);this.iIsMaster=is.readInt32(1,false,this.iIsMaster);this.lChannelId=is.readInt64(2,false,this.lChannelId);this.lSubChannelId=is.readInt64(3,false,this.lSubChannelId);this.lPresenterUid=is.readInt64(4,false,this.lPresenterUid);this.sStreamName=is.readString(5,false,this.sStreamName);this.sFlvUrl=is.readString(6,false,this.sFlvUrl);this.sFlvUrlSuffix=is.readString(7,false,this.sFlvUrlSuffix);this.sFlvAntiCode=is.readString(8,false,this.sFlvAntiCode);this.sHlsUrl=is.readString(9,false,this.sHlsUrl);this.sHlsUrlSuffix=is.readString(10,false,this.sHlsUrlSuffix);this.sHlsAntiCode=is.readString(11,false,this.sHlsAntiCode);this.iLineIndex=is.readInt32(12,false,this.iLineIndex);this.iIsMultiStream=is.readInt32(13,false,this.iIsMultiStream);this.iPCPriorityRate=is.readInt32(14,false,this.iPCPriorityRate);this.iWebPriorityRate=is.readInt32(15,false,this.iWebPriorityRate);this.iMobilePriorityRate=is.readInt32(16,false,this.iMobilePriorityRate);this.vFlvIPList=is.readVector(17,false,this.vFlvIPList);this.iIsP2PSupport=is.readInt32(18,false,this.iIsP2PSupport);this.sP2pUrl=is.readString(19,false,this.sP2pUrl);this.sP2pUrlSuffix=is.readString(20,false,this.sP2pUrlSuffix);this.sP2pAntiCode=is.readString(21,false,this.sP2pAntiCode);this.lFreeFlag=is.readInt64(22,false,this.lFreeFlag);};HUYA.MultiStreamInfo=function(){this.sDisplayName="";this.iBitRate=0;this.iCodecType=0;this.iCompatibleFlag=0;};HUYA.MultiStreamInfo.prototype._clone=function(){return new HUYA.MultiStreamInfo();};HUYA.MultiStreamInfo.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.MultiStreamInfo.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.MultiStreamInfo.prototype.writeTo=function(os){os.writeString(0,this.sDisplayName);os.writeInt32(1,this.iBitRate);os.writeInt32(2,this.iCodecType);os.writeInt32(3,this.iCompatibleFlag);};HUYA.MultiStreamInfo.prototype.readFrom=function(is){this.sDisplayName=is.readString(0,false,this.sDisplayName);this.iBitRate=is.readInt32(1,false,this.iBitRate);this.iCodecType=is.readInt32(2,false,this.iCodecType);this.iCompatibleFlag=is.readInt32(3,false,this.iCompatibleFlag);};HUYA.StreamSettingNotice=function(){this.lPresenterUid=0;this.iBitRate=0;this.iResolution=0;this.iFrameRate=0;this.lLiveId=0;this.sDisplayName="";};HUYA.StreamSettingNotice.prototype._clone=function(){return new HUYA.StreamSettingNotice();};HUYA.StreamSettingNotice.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.StreamSettingNotice.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.StreamSettingNotice.prototype.writeTo=function(os){os.writeInt64(0,this.lPresenterUid);os.writeInt32(1,this.iBitRate);os.writeInt32(2,this.iResolution);os.writeInt32(3,this.iFrameRate);os.writeInt64(4,this.lLiveId);os.writeString(5,this.sDisplayName);};HUYA.StreamSettingNotice.prototype.readFrom=function(is){this.lPresenterUid=is.readInt64(0,false,this.lPresenterUid);this.iBitRate=is.readInt32(1,false,this.iBitRate);this.iResolution=is.readInt32(2,false,this.iResolution);this.iFrameRate=is.readInt32(3,false,this.iFrameRate);this.lLiveId=is.readInt64(4,false,this.lLiveId);this.sDisplayName=is.readString(5,false,this.sDisplayName);};HUYA.LiveLaunchReq=function(){this.tId=new HUYA.UserId();this.tLiveUB=new HUYA.LiveUserbase();};HUYA.LiveLaunchReq.prototype._clone=function(){return new HUYA.LiveLaunchReq();};HUYA.LiveLaunchReq.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.LiveLaunchReq.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.LiveLaunchReq.prototype.writeTo=function(os){os.writeStruct(0,this.tId);os.writeStruct(1,this.tLiveUB);};HUYA.LiveLaunchReq.prototype.readFrom=function(is){this.tId=is.readStruct(0,false,this.tId);this.tLiveUB=is.readStruct(1,false,this.tLiveUB);};HUYA.LiveLaunchRsp=function(){this.sGuid="";this.iTime=0;this.vProxyList=new Taf.Vector(new HUYA.LiveProxyValue());this.eAccess=0;this.sClientIp="";};HUYA.LiveLaunchRsp.prototype._clone=function(){return new HUYA.LiveLaunchRsp();};HUYA.LiveLaunchRsp.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.LiveLaunchRsp.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.LiveLaunchRsp.prototype.writeTo=function(os){os.writeString(0,this.sGuid);os.writeInt32(1,this.iTime);os.writeVector(2,this.vProxyList);os.writeInt32(3,this.eAccess);os.writeString(4,this.sClientIp);};HUYA.LiveLaunchRsp.prototype.readFrom=function(is){this.sGuid=is.readString(0,false,this.sGuid);this.iTime=is.readInt32(1,false,this.iTime);this.vProxyList=is.readVector(2,false,this.vProxyList);this.eAccess=is.readInt32(3,false,this.eAccess);this.sClientIp=is.readString(4,false,this.sClientIp);};HUYA.LiveAppUAEx=function(){this.sIMEI="";this.sAPN="";this.sNetType="";this.sDeviceId="";};HUYA.LiveAppUAEx.prototype._clone=function(){return new HUYA.LiveAppUAEx();};HUYA.LiveAppUAEx.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.LiveAppUAEx.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.LiveAppUAEx.prototype.writeTo=function(os){os.writeString(1,this.sIMEI);os.writeString(2,this.sAPN);os.writeString(3,this.sNetType);os.writeString(4,this.sDeviceId);};HUYA.LiveAppUAEx.prototype.readFrom=function(is){this.sIMEI=is.readString(1,false,this.sIMEI);this.sAPN=is.readString(2,false,this.sAPN);this.sNetType=is.readString(3,false,this.sNetType);this.sDeviceId=is.readString(4,false,this.sDeviceId);};HUYA.LiveUserbase=function(){this.eSource=0;this.eType=0;this.tUAEx=new HUYA.LiveAppUAEx();};HUYA.LiveUserbase.prototype._clone=function(){return new HUYA.LiveUserbase();};HUYA.LiveUserbase.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.LiveUserbase.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.LiveUserbase.prototype.writeTo=function(os){os.writeInt32(0,this.eSource);os.writeInt32(1,this.eType);os.writeStruct(2,this.tUAEx);};HUYA.LiveUserbase.prototype.readFrom=function(is){this.eSource=is.readInt32(0,false,this.eSource);this.eType=is.readInt32(1,false,this.eType);this.tUAEx=is.readStruct(2,false,this.tUAEx);};HUYA.LiveProxyValue=function(){this.eProxyType=0;this.sProxy=new Taf.Vector(new Taf.STRING());};HUYA.LiveProxyValue.prototype._clone=function(){return new HUYA.LiveProxyValue();};HUYA.LiveProxyValue.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.LiveProxyValue.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.LiveProxyValue.prototype.writeTo=function(os){os.writeInt32(0,this.eProxyType);os.writeVector(1,this.sProxy);};HUYA.LiveProxyValue.prototype.readFrom=function(is){this.eProxyType=is.readInt32(0,false,this.eProxyType);this.sProxy=is.readVector(1,false,this.sProxy);};HUYA.SendCardPackageItemReq=function(){this.tId=new HUYA.UserId();this.lSid=0;this.lSubSid=0;this.iShowFreeitemInfo=0;this.iItemType=0;this.iItemCount=0;this.lPresenterUid=0;this.sPayId="";this.sSendContent="";this.sSenderNick="";this.sPresenterNick="";this.iPayPloy=0;this.iItemCountByGroup=0;this.iItemGroup=0;this.iSuperPupleLevel=0;this.iFromType=0;this.sExpand="";this.sToken="";this.iTemplateType=0;this.sTokencaKey="";this.sPassport="";this.iSenderShortSid=0;this.iPayByFreeItem=0;this.tExtUser=new HUYA.ExternalUser();this.iEventType=0;};HUYA.SendCardPackageItemReq.prototype._clone=function(){return new HUYA.SendCardPackageItemReq();};HUYA.SendCardPackageItemReq.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.SendCardPackageItemReq.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.SendCardPackageItemReq.prototype.writeTo=function(os){os.writeStruct(0,this.tId);os.writeInt64(1,this.lSid);os.writeInt64(2,this.lSubSid);os.writeInt32(3,this.iShowFreeitemInfo);os.writeInt32(4,this.iItemType);os.writeInt32(5,this.iItemCount);os.writeInt64(6,this.lPresenterUid);os.writeString(7,this.sPayId);os.writeString(9,this.sSendContent);os.writeString(10,this.sSenderNick);os.writeString(11,this.sPresenterNick);os.writeInt32(12,this.iPayPloy);os.writeInt32(13,this.iItemCountByGroup);os.writeInt32(14,this.iItemGroup);os.writeInt32(15,this.iSuperPupleLevel);os.writeInt32(16,this.iFromType);os.writeString(17,this.sExpand);os.writeString(18,this.sToken);os.writeInt32(19,this.iTemplateType);os.writeString(20,this.sTokencaKey);os.writeString(21,this.sPassport);os.writeInt64(22,this.iSenderShortSid);os.writeInt32(23,this.iPayByFreeItem);os.writeStruct(24,this.tExtUser);os.writeInt16(25,this.iEventType);};HUYA.SendCardPackageItemReq.prototype.readFrom=function(is){this.tId=is.readStruct(0,false,this.tId);this.lSid=is.readInt64(1,false,this.lSid);this.lSubSid=is.readInt64(2,false,this.lSubSid);this.iShowFreeitemInfo=is.readInt32(3,false,this.iShowFreeitemInfo);this.iItemType=is.readInt32(4,false,this.iItemType);this.iItemCount=is.readInt32(5,false,this.iItemCount);this.lPresenterUid=is.readInt64(6,false,this.lPresenterUid);this.sPayId=is.readString(7,false,this.sPayId);this.sSendContent=is.readString(9,false,this.sSendContent);this.sSenderNick=is.readString(10,false,this.sSenderNick);this.sPresenterNick=is.readString(11,false,this.sPresenterNick);this.iPayPloy=is.readInt32(12,false,this.iPayPloy);this.iItemCountByGroup=is.readInt32(13,false,this.iItemCountByGroup);this.iItemGroup=is.readInt32(14,false,this.iItemGroup);this.iSuperPupleLevel=is.readInt32(15,false,this.iSuperPupleLevel);this.iFromType=is.readInt32(16,false,this.iFromType);this.sExpand=is.readString(17,false,this.sExpand);this.sToken=is.readString(18,false,this.sToken);this.iTemplateType=is.readInt32(19,false,this.iTemplateType);this.sTokencaKey=is.readString(20,false,this.sTokencaKey);this.sPassport=is.readString(21,false,this.sPassport);this.iSenderShortSid=is.readInt64(22,false,this.iSenderShortSid);this.iPayByFreeItem=is.readInt32(23,false,this.iPayByFreeItem);this.tExtUser=is.readStruct(24,false,this.tExtUser);this.iEventType=is.readInt16(25,false,this.iEventType);};HUYA.SendCardPackageItemRsp=function(){this.iPayRespCode=0;this.iItemType=0;this.iItemCount=0;this.strPayId="";this.strPayConfirmUrl="";this.strSendContent="";this.iItemCountByGroup=0;this.iItemGroup=0;this.lPresenterUid=0;this.sExpand="";this.strPayItemInfo="";this.iPayType=0;};HUYA.SendCardPackageItemRsp.prototype._clone=function(){return new HUYA.SendCardPackageItemRsp();};HUYA.SendCardPackageItemRsp.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.SendCardPackageItemRsp.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.SendCardPackageItemRsp.prototype.writeTo=function(os){os.writeInt32(0,this.iPayRespCode);os.writeInt32(1,this.iItemType);os.writeInt32(2,this.iItemCount);os.writeString(3,this.strPayId);os.writeString(4,this.strPayConfirmUrl);os.writeString(5,this.strSendContent);os.writeInt32(6,this.iItemCountByGroup);os.writeInt32(7,this.iItemGroup);os.writeInt64(8,this.lPresenterUid);os.writeString(9,this.sExpand);os.writeString(10,this.strPayItemInfo);os.writeInt32(11,this.iPayType);};HUYA.SendCardPackageItemRsp.prototype.readFrom=function(is){this.iPayRespCode=is.readInt32(0,false,this.iPayRespCode);this.iItemType=is.readInt32(1,false,this.iItemType);this.iItemCount=is.readInt32(2,false,this.iItemCount);this.strPayId=is.readString(3,false,this.strPayId);this.strPayConfirmUrl=is.readString(4,false,this.strPayConfirmUrl);this.strSendContent=is.readString(5,false,this.strSendContent);this.iItemCountByGroup=is.readInt32(6,false,this.iItemCountByGroup);this.iItemGroup=is.readInt32(7,false,this.iItemGroup);this.lPresenterUid=is.readInt64(8,false,this.lPresenterUid);this.sExpand=is.readString(9,false,this.sExpand);this.strPayItemInfo=is.readString(10,false,this.strPayItemInfo);this.iPayType=is.readInt32(11,false,this.iPayType);};HUYA.SenderItem=function(){this.lSenderUid=0;this.lYYid=0;this.iSenderRole=0;this.iSenderGender=0;this.sSenderNick="";};HUYA.SenderItem.prototype._clone=function(){return new HUYA.SenderItem();};HUYA.SenderItem.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.SenderItem.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.SenderItem.prototype.writeTo=function(os){os.writeInt64(0,this.lSenderUid);os.writeInt64(1,this.lYYid);os.writeInt32(2,this.iSenderRole);os.writeInt32(3,this.iSenderGender);os.writeString(4,this.sSenderNick);};HUYA.SenderItem.prototype.readFrom=function(is){this.lSenderUid=is.readInt64(0,false,this.lSenderUid);this.lYYid=is.readInt64(1,false,this.lYYid);this.iSenderRole=is.readInt32(2,false,this.iSenderRole);this.iSenderGender=is.readInt32(3,false,this.iSenderGender);this.sSenderNick=is.readString(4,false,this.sSenderNick);};HUYA.FansItem=function(){this.iFansLevel=0;this.sFansNick="";this.sFansPresenterNick="";};HUYA.FansItem.prototype._clone=function(){return new HUYA.FansItem();};HUYA.FansItem.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.FansItem.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.FansItem.prototype.writeTo=function(os){os.writeInt32(0,this.iFansLevel);os.writeString(1,this.sFansNick);os.writeString(2,this.sFansPresenterNick);};HUYA.FansItem.prototype.readFrom=function(is){this.iFansLevel=is.readInt32(0,false,this.iFansLevel);this.sFansNick=is.readString(1,false,this.sFansNick);this.sFansPresenterNick=is.readString(2,false,this.sFansPresenterNick);};HUYA.VipSmileItem=function(){this.sVipSmileKey="";this.sVipSmilePath="";};HUYA.VipSmileItem.prototype._clone=function(){return new HUYA.VipSmileItem();};HUYA.VipSmileItem.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.VipSmileItem.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.VipSmileItem.prototype.writeTo=function(os){os.writeString(0,this.sVipSmileKey);os.writeString(1,this.sVipSmilePath);};HUYA.VipSmileItem.prototype.readFrom=function(is){this.sVipSmileKey=is.readString(0,false,this.sVipSmileKey);this.sVipSmilePath=is.readString(1,false,this.sVipSmilePath);};HUYA.StampItem=function(){this.sSealIconPath="";this.sKeyImg="";this.lStampTime=0;this.lStampEndTime=0;this.iValidity=0;this.sStampUserNick="";};HUYA.StampItem.prototype._clone=function(){return new HUYA.StampItem();};HUYA.StampItem.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.StampItem.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.StampItem.prototype.writeTo=function(os){os.writeString(0,this.sSealIconPath);os.writeString(1,this.sKeyImg);os.writeInt64(2,this.lStampTime);os.writeInt64(3,this.lStampEndTime);os.writeInt32(4,this.iValidity);os.writeString(5,this.sStampUserNick);};HUYA.StampItem.prototype.readFrom=function(is){this.sSealIconPath=is.readString(0,false,this.sSealIconPath);this.sKeyImg=is.readString(1,false,this.sKeyImg);this.lStampTime=is.readInt64(2,false,this.lStampTime);this.lStampEndTime=is.readInt64(3,false,this.lStampEndTime);this.iValidity=is.readInt32(4,false,this.iValidity);this.sStampUserNick=is.readString(5,false,this.sStampUserNick);};HUYA.MassItem=function(){this.iGoldHostLevel=0;this.iSuperPupleLevel=0;this.iVipLevel=0;this.iUserLevel=0;this.iIsVipRed=0;this.iAtSomebody=0;this.sAtSomebodyNick="";this.ibarrageColor=0;this.sDevSourceType="";};HUYA.MassItem.prototype._clone=function(){return new HUYA.MassItem();};HUYA.MassItem.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.MassItem.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.MassItem.prototype.writeTo=function(os){os.writeInt32(0,this.iGoldHostLevel);os.writeInt32(1,this.iSuperPupleLevel);os.writeInt32(2,this.iVipLevel);os.writeInt32(3,this.iUserLevel);os.writeInt32(4,this.iIsVipRed);os.writeInt32(5,this.iAtSomebody);os.writeString(6,this.sAtSomebodyNick);os.writeInt32(7,this.ibarrageColor);os.writeString(8,this.sDevSourceType);};HUYA.MassItem.prototype.readFrom=function(is){this.iGoldHostLevel=is.readInt32(0,false,this.iGoldHostLevel);this.iSuperPupleLevel=is.readInt32(1,false,this.iSuperPupleLevel);this.iVipLevel=is.readInt32(2,false,this.iVipLevel);this.iUserLevel=is.readInt32(3,false,this.iUserLevel);this.iIsVipRed=is.readInt32(4,false,this.iIsVipRed);this.iAtSomebody=is.readInt32(5,false,this.iAtSomebody);this.sAtSomebodyNick=is.readString(6,false,this.sAtSomebodyNick);this.ibarrageColor=is.readInt32(7,false,this.ibarrageColor);this.sDevSourceType=is.readString(8,false,this.sDevSourceType);};HUYA.EndLiveNotice=function(){this.lPresenterUid=0;this.iReason=0;this.lLiveId=0;this.sReason="";};HUYA.EndLiveNotice.prototype._clone=function(){return new HUYA.EndLiveNotice();};HUYA.EndLiveNotice.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.EndLiveNotice.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.EndLiveNotice.prototype.writeTo=function(os){os.writeInt64(0,this.lPresenterUid);os.writeInt32(1,this.iReason);os.writeInt64(2,this.lLiveId);os.writeString(3,this.sReason);};HUYA.EndLiveNotice.prototype.readFrom=function(is){this.lPresenterUid=is.readInt64(0,false,this.lPresenterUid);this.iReason=is.readInt32(1,false,this.iReason);this.lLiveId=is.readInt64(2,false,this.lLiveId);this.sReason=is.readString(3,false,this.sReason);};HUYA.NobleBase=function(){this.lUid=0;this.sNickName="";this.iLevel=0;this.sName="";this.iPet=0;this.lPid=0;this.lTid=0;this.lSid=0;this.lStartTime=0;this.lEndTime=0;this.iLeftDay=0;this.iStatus=0;this.iOpenFlag=0;this.iMonths=0;this.sPNickName="";};HUYA.NobleBase.prototype._clone=function(){return new HUYA.NobleBase();};HUYA.NobleBase.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.NobleBase.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.NobleBase.prototype.writeTo=function(os){os.writeInt64(0,this.lUid);os.writeString(1,this.sNickName);os.writeInt32(2,this.iLevel);os.writeString(3,this.sName);os.writeInt32(4,this.iPet);os.writeInt64(5,this.lPid);os.writeInt64(6,this.lTid);os.writeInt64(7,this.lSid);os.writeInt64(8,this.lStartTime);os.writeInt64(9,this.lEndTime);os.writeInt32(10,this.iLeftDay);os.writeInt32(11,this.iStatus);os.writeInt32(12,this.iOpenFlag);os.writeInt32(13,this.iMonths);os.writeString(14,this.sPNickName);};HUYA.NobleBase.prototype.readFrom=function(is){this.lUid=is.readInt64(0,false,this.lUid);this.sNickName=is.readString(1,false,this.sNickName);this.iLevel=is.readInt32(2,false,this.iLevel);this.sName=is.readString(3,false,this.sName);this.iPet=is.readInt32(4,false,this.iPet);this.lPid=is.readInt64(5,false,this.lPid);this.lTid=is.readInt64(6,false,this.lTid);this.lSid=is.readInt64(7,false,this.lSid);this.lStartTime=is.readInt64(8,false,this.lStartTime);this.lEndTime=is.readInt64(9,false,this.lEndTime);this.iLeftDay=is.readInt32(10,false,this.iLeftDay);this.iStatus=is.readInt32(11,false,this.iStatus);this.iOpenFlag=is.readInt32(12,false,this.iOpenFlag);this.iMonths=is.readInt32(13,false,this.iMonths);this.sPNickName=is.readString(14,false,this.sPNickName);};HUYA.GetPropsListReq=function(){this.tUserId=new HUYA.UserId();this.sMd5="";this.iTemplateType=128;this.sVersion="";this.iAppId=0;this.lPresenterUid=0;this.lSid=0;this.lSubSid=0;};HUYA.GetPropsListReq.prototype._clone=function(){return new HUYA.GetPropsListReq();};HUYA.GetPropsListReq.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.GetPropsListReq.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.GetPropsListReq.prototype.writeTo=function(os){os.writeStruct(1,this.tUserId);os.writeString(2,this.sMd5);os.writeInt32(3,this.iTemplateType);os.writeString(4,this.sVersion);os.writeInt32(5,this.iAppId);os.writeInt64(6,this.lPresenterUid);os.writeInt64(7,this.lSid);os.writeInt64(8,this.lSubSid);};HUYA.GetPropsListReq.prototype.readFrom=function(is){this.tUserId=is.readStruct(1,false,this.tUserId);this.sMd5=is.readString(2,false,this.sMd5);this.iTemplateType=is.readInt32(3,false,this.iTemplateType);this.sVersion=is.readString(4,false,this.sVersion);this.iAppId=is.readInt32(5,false,this.iAppId);this.lPresenterUid=is.readInt64(6,false,this.lPresenterUid);this.lSid=is.readInt64(7,false,this.lSid);this.lSubSid=is.readInt64(8,false,this.lSubSid);};HUYA.GetPropsListRsp=function(){this.vPropsItemList=new Taf.Vector(new HUYA.PropsItem());this.sMd5="";this.iNewEffectSwitch=0;this.iMirrorRoomShowNum=0;this.iGameRoomShowNum=0;};HUYA.GetPropsListRsp.prototype._clone=function(){return new HUYA.GetPropsListRsp();};HUYA.GetPropsListRsp.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.GetPropsListRsp.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.GetPropsListRsp.prototype.writeTo=function(os){os.writeVector(1,this.vPropsItemList);os.writeString(2,this.sMd5);os.writeInt16(3,this.iNewEffectSwitch);os.writeInt16(4,this.iMirrorRoomShowNum);os.writeInt16(5,this.iGameRoomShowNum);};HUYA.GetPropsListRsp.prototype.readFrom=function(is){this.vPropsItemList=is.readVector(1,false,this.vPropsItemList);this.sMd5=is.readString(2,false,this.sMd5);this.iNewEffectSwitch=is.readInt16(3,false,this.iNewEffectSwitch);this.iMirrorRoomShowNum=is.readInt16(4,false,this.iMirrorRoomShowNum);this.iGameRoomShowNum=is.readInt16(5,false,this.iGameRoomShowNum);};HUYA.PropsItem=function(){this.iPropsId=0;this.sPropsName="";this.iPropsYb=0;this.iPropsGreenBean=0;this.iPropsWhiteBean=0;this.iPropsGoldenBean=0;this.iPropsRed=0;this.iPropsPopular=0;this.iPropsExpendNum=-1;this.iPropsFansValue=-1;this.vPropsNum=new Taf.Vector(new Taf.INT32());this.iPropsMaxNum=0;this.iPropsBatterFlag=0;this.vPropsChannel=new Taf.Vector(new Taf.INT32());this.sPropsToolTip="";this.vPropsIdentity=new Taf.Vector(new HUYA.PropsIdentity());this.iPropsWeights=0;this.iPropsLevel=0;this.tDisplayInfo=new HUYA.DisplayInfo();this.tSpecialInfo=new HUYA.SpecialInfo();this.iPropsGrade=0;this.iPropsGroupNum=0;this.sPropsCommBannerResource="";this.sPropsOwnBannerResource="";this.iPropsShowFlag=0;this.iTemplateType=0;this.iShelfStatus=0;this.sAndroidLogo="";this.sIpadLogo="";this.sIphoneLogo="";this.sPropsCommBannerResourceEx="";this.sPropsOwnBannerResourceEx="";this.vPresenterUid=new Taf.Vector(new Taf.INT64());this.vPropView=new Taf.Vector(new HUYA.PropView());this.iFaceUSwitch=0;this.iDisplayCd=0;this.iCount=0;this.iVbCount=0;};HUYA.PropsItem.prototype._clone=function(){return new HUYA.PropsItem();};HUYA.PropsItem.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.PropsItem.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.PropsItem.prototype.writeTo=function(os){os.writeInt32(1,this.iPropsId);os.writeString(2,this.sPropsName);os.writeInt32(3,this.iPropsYb);os.writeInt32(4,this.iPropsGreenBean);os.writeInt32(5,this.iPropsWhiteBean);os.writeInt32(6,this.iPropsGoldenBean);os.writeInt32(7,this.iPropsRed);os.writeInt32(8,this.iPropsPopular);os.writeInt32(9,this.iPropsExpendNum);os.writeInt32(10,this.iPropsFansValue);os.writeVector(11,this.vPropsNum);os.writeInt32(12,this.iPropsMaxNum);os.writeInt32(13,this.iPropsBatterFlag);os.writeVector(14,this.vPropsChannel);os.writeString(15,this.sPropsToolTip);os.writeVector(16,this.vPropsIdentity);os.writeInt32(17,this.iPropsWeights);os.writeInt32(18,this.iPropsLevel);os.writeStruct(19,this.tDisplayInfo);os.writeStruct(20,this.tSpecialInfo);os.writeInt32(21,this.iPropsGrade);os.writeInt32(22,this.iPropsGroupNum);os.writeString(23,this.sPropsCommBannerResource);os.writeString(24,this.sPropsOwnBannerResource);os.writeInt32(25,this.iPropsShowFlag);os.writeInt32(26,this.iTemplateType);os.writeInt32(27,this.iShelfStatus);os.writeString(28,this.sAndroidLogo);os.writeString(29,this.sIpadLogo);os.writeString(30,this.sIphoneLogo);os.writeString(31,this.sPropsCommBannerResourceEx);os.writeString(32,this.sPropsOwnBannerResourceEx);os.writeVector(33,this.vPresenterUid);os.writeVector(34,this.vPropView);os.writeInt16(35,this.iFaceUSwitch);os.writeInt16(36,this.iDisplayCd);os.writeInt16(37,this.iCount);os.writeInt32(38,this.iVbCount);};HUYA.PropsItem.prototype.readFrom=function(is){this.iPropsId=is.readInt32(1,false,this.iPropsId);this.sPropsName=is.readString(2,false,this.sPropsName);this.iPropsYb=is.readInt32(3,false,this.iPropsYb);this.iPropsGreenBean=is.readInt32(4,false,this.iPropsGreenBean);this.iPropsWhiteBean=is.readInt32(5,false,this.iPropsWhiteBean);this.iPropsGoldenBean=is.readInt32(6,false,this.iPropsGoldenBean);this.iPropsRed=is.readInt32(7,false,this.iPropsRed);this.iPropsPopular=is.readInt32(8,false,this.iPropsPopular);this.iPropsExpendNum=is.readInt32(9,false,this.iPropsExpendNum);this.iPropsFansValue=is.readInt32(10,false,this.iPropsFansValue);this.vPropsNum=is.readVector(11,false,this.vPropsNum);this.iPropsMaxNum=is.readInt32(12,false,this.iPropsMaxNum);this.iPropsBatterFlag=is.readInt32(13,false,this.iPropsBatterFlag);this.vPropsChannel=is.readVector(14,false,this.vPropsChannel);this.sPropsToolTip=is.readString(15,false,this.sPropsToolTip);this.vPropsIdentity=is.readVector(16,false,this.vPropsIdentity);this.iPropsWeights=is.readInt32(17,false,this.iPropsWeights);this.iPropsLevel=is.readInt32(18,false,this.iPropsLevel);this.tDisplayInfo=is.readStruct(19,false,this.tDisplayInfo);this.tSpecialInfo=is.readStruct(20,false,this.tSpecialInfo);this.iPropsGrade=is.readInt32(21,false,this.iPropsGrade);this.iPropsGroupNum=is.readInt32(22,false,this.iPropsGroupNum);this.sPropsCommBannerResource=is.readString(23,false,this.sPropsCommBannerResource);this.sPropsOwnBannerResource=is.readString(24,false,this.sPropsOwnBannerResource);this.iPropsShowFlag=is.readInt32(25,false,this.iPropsShowFlag);this.iTemplateType=is.readInt32(26,false,this.iTemplateType);this.iShelfStatus=is.readInt32(27,false,this.iShelfStatus);this.sAndroidLogo=is.readString(28,false,this.sAndroidLogo);this.sIpadLogo=is.readString(29,false,this.sIpadLogo);this.sIphoneLogo=is.readString(30,false,this.sIphoneLogo);this.sPropsCommBannerResourceEx=is.readString(31,false,this.sPropsCommBannerResourceEx);this.sPropsOwnBannerResourceEx=is.readString(32,false,this.sPropsOwnBannerResourceEx);this.vPresenterUid=is.readVector(33,false,this.vPresenterUid);this.vPropView=is.readVector(34,false,this.vPropView);this.iFaceUSwitch=is.readInt16(35,false,this.iFaceUSwitch);this.iDisplayCd=is.readInt16(36,false,this.iDisplayCd);this.iCount=is.readInt16(37,false,this.iCount);this.iVbCount=is.readInt32(38,false,this.iVbCount);};HUYA.PropsIdentity=function(){this.iPropsIdType=0;this.sPropsPic18="";this.sPropsPic24="";this.sPropsPicGif="";this.sPropsBannerResource="";this.sPropsBannerSize="";this.sPropsBannerMaxTime="";this.sPropsChatBannerResource="";this.sPropsChatBannerSize="";this.sPropsChatBannerMaxTime="";this.iPropsChatBannerPos=0;this.iPropsChatBannerIsCombo=0;this.sPropsRollContent="";this.iPropsBannerAnimationstyle=0;this.sPropFaceu="";this.sPropH5Resource="";this.sPropsWeb="";this.sWitch=0;this.sCornerMark="";this.iPropViewId=0;this.sPropStreamerResource="";this.iStreamerFrameRate=0;this.sPropsPic108="";this.sPcBannerResource="";};HUYA.PropsIdentity.prototype._clone=function(){return new HUYA.PropsIdentity();};HUYA.PropsIdentity.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.PropsIdentity.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.PropsIdentity.prototype.writeTo=function(os){os.writeInt32(1,this.iPropsIdType);os.writeString(2,this.sPropsPic18);os.writeString(3,this.sPropsPic24);os.writeString(4,this.sPropsPicGif);os.writeString(5,this.sPropsBannerResource);os.writeString(6,this.sPropsBannerSize);os.writeString(7,this.sPropsBannerMaxTime);os.writeString(8,this.sPropsChatBannerResource);os.writeString(9,this.sPropsChatBannerSize);os.writeString(10,this.sPropsChatBannerMaxTime);os.writeInt32(11,this.iPropsChatBannerPos);os.writeInt32(12,this.iPropsChatBannerIsCombo);os.writeString(13,this.sPropsRollContent);os.writeInt32(14,this.iPropsBannerAnimationstyle);os.writeString(15,this.sPropFaceu);os.writeString(16,this.sPropH5Resource);os.writeString(17,this.sPropsWeb);os.writeInt32(18,this.sWitch);os.writeString(19,this.sCornerMark);os.writeInt32(20,this.iPropViewId);os.writeString(21,this.sPropStreamerResource);os.writeInt16(22,this.iStreamerFrameRate);os.writeString(23,this.sPropsPic108);os.writeString(24,this.sPcBannerResource);};HUYA.PropsIdentity.prototype.readFrom=function(is){this.iPropsIdType=is.readInt32(1,false,this.iPropsIdType);this.sPropsPic18=is.readString(2,false,this.sPropsPic18);this.sPropsPic24=is.readString(3,false,this.sPropsPic24);this.sPropsPicGif=is.readString(4,false,this.sPropsPicGif);this.sPropsBannerResource=is.readString(5,false,this.sPropsBannerResource);this.sPropsBannerSize=is.readString(6,false,this.sPropsBannerSize);this.sPropsBannerMaxTime=is.readString(7,false,this.sPropsBannerMaxTime);this.sPropsChatBannerResource=is.readString(8,false,this.sPropsChatBannerResource);this.sPropsChatBannerSize=is.readString(9,false,this.sPropsChatBannerSize);this.sPropsChatBannerMaxTime=is.readString(10,false,this.sPropsChatBannerMaxTime);this.iPropsChatBannerPos=is.readInt32(11,false,this.iPropsChatBannerPos);this.iPropsChatBannerIsCombo=is.readInt32(12,false,this.iPropsChatBannerIsCombo);this.sPropsRollContent=is.readString(13,false,this.sPropsRollContent);this.iPropsBannerAnimationstyle=is.readInt32(14,false,this.iPropsBannerAnimationstyle);this.sPropFaceu=is.readString(15,false,this.sPropFaceu);this.sPropH5Resource=is.readString(16,false,this.sPropH5Resource);this.sPropsWeb=is.readString(17,false,this.sPropsWeb);this.sWitch=is.readInt32(18,false,this.sWitch);this.sCornerMark=is.readString(19,false,this.sCornerMark);this.iPropViewId=is.readInt32(20,false,this.iPropViewId);this.sPropStreamerResource=is.readString(21,false,this.sPropStreamerResource);this.iStreamerFrameRate=is.readInt16(22,false,this.iStreamerFrameRate);this.sPropsPic108=is.readString(23,false,this.sPropsPic108);this.sPcBannerResource=is.readString(24,false,this.sPcBannerResource);};HUYA.PropView=function(){this.id=0;this.name="";this.uids=new Taf.Map(new Taf.INT64(),new Taf.INT16());this.tips="";};HUYA.PropView.prototype._clone=function(){return new HUYA.PropView();};HUYA.PropView.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.PropView.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.PropView.prototype.writeTo=function(os){os.writeInt32(0,this.id);os.writeString(1,this.name);os.writeMap(2,this.uids);os.writeString(3,this.tips);};HUYA.PropView.prototype.readFrom=function(is){this.id=is.readInt32(0,false,this.id);this.name=is.readString(1,false,this.name);this.uids=is.readMap(2,false,this.uids);this.tips=is.readString(3,false,this.tips);};HUYA.DisplayInfo=function(){this.iMarqueeScopeMin=0;this.iMarqueeScopeMax=0;this.iCurrentVideoNum=0;this.iCurrentVideoMin=0;this.iCurrentVideoMax=0;this.iAllVideoNum=0;this.iAllVideoMin=0;this.iAllVideoMax=0;this.iCurrentScreenNum=0;this.iCurrentScreenMin=0;this.iCurrentScreenMax=0;};HUYA.DisplayInfo.prototype._clone=function(){return new HUYA.DisplayInfo();};HUYA.DisplayInfo.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.DisplayInfo.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.DisplayInfo.prototype.writeTo=function(os){os.writeInt32(1,this.iMarqueeScopeMin);os.writeInt32(2,this.iMarqueeScopeMax);os.writeInt32(3,this.iCurrentVideoNum);os.writeInt32(4,this.iCurrentVideoMin);os.writeInt32(5,this.iCurrentVideoMax);os.writeInt32(6,this.iAllVideoNum);os.writeInt32(7,this.iAllVideoMin);os.writeInt32(8,this.iAllVideoMax);os.writeInt32(9,this.iCurrentScreenNum);os.writeInt32(10,this.iCurrentScreenMin);os.writeInt32(11,this.iCurrentScreenMax);};HUYA.DisplayInfo.prototype.readFrom=function(is){this.iMarqueeScopeMin=is.readInt32(1,false,this.iMarqueeScopeMin);this.iMarqueeScopeMax=is.readInt32(2,false,this.iMarqueeScopeMax);this.iCurrentVideoNum=is.readInt32(3,false,this.iCurrentVideoNum);this.iCurrentVideoMin=is.readInt32(4,false,this.iCurrentVideoMin);this.iCurrentVideoMax=is.readInt32(5,false,this.iCurrentVideoMax);this.iAllVideoNum=is.readInt32(6,false,this.iAllVideoNum);this.iAllVideoMin=is.readInt32(7,false,this.iAllVideoMin);this.iAllVideoMax=is.readInt32(8,false,this.iAllVideoMax);this.iCurrentScreenNum=is.readInt32(9,false,this.iCurrentScreenNum);this.iCurrentScreenMin=is.readInt32(10,false,this.iCurrentScreenMin);this.iCurrentScreenMax=is.readInt32(11,false,this.iCurrentScreenMax);};HUYA.SpecialInfo=function(){this.iFirstSingle=0;this.iFirstGroup=0;this.sFirstTips="";this.iSecondSingle=0;this.iSecondGroup=0;this.sSecondTips="";this.iThirdSingle=0;this.iThirdGroup=0;this.sThirdTips="";this.iWorldSingle=0;this.iWorldGroup=0;};HUYA.SpecialInfo.prototype._clone=function(){return new HUYA.SpecialInfo();};HUYA.SpecialInfo.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.SpecialInfo.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.SpecialInfo.prototype.writeTo=function(os){os.writeInt32(1,this.iFirstSingle);os.writeInt32(2,this.iFirstGroup);os.writeString(3,this.sFirstTips);os.writeInt32(4,this.iSecondSingle);os.writeInt32(5,this.iSecondGroup);os.writeString(6,this.sSecondTips);os.writeInt32(7,this.iThirdSingle);os.writeInt32(8,this.iThirdGroup);os.writeString(9,this.sThirdTips);os.writeInt32(10,this.iWorldSingle);os.writeInt32(11,this.iWorldGroup);};HUYA.SpecialInfo.prototype.readFrom=function(is){this.iFirstSingle=is.readInt32(1,false,this.iFirstSingle);this.iFirstGroup=is.readInt32(2,false,this.iFirstGroup);this.sFirstTips=is.readString(3,false,this.sFirstTips);this.iSecondSingle=is.readInt32(4,false,this.iSecondSingle);this.iSecondGroup=is.readInt32(5,false,this.iSecondGroup);this.sSecondTips=is.readString(6,false,this.sSecondTips);this.iThirdSingle=is.readInt32(7,false,this.iThirdSingle);this.iThirdGroup=is.readInt32(8,false,this.iThirdGroup);this.sThirdTips=is.readString(9,false,this.sThirdTips);this.iWorldSingle=is.readInt32(10,false,this.iWorldSingle);this.iWorldGroup=is.readInt32(11,false,this.iWorldGroup);};HUYA.GetWebdbUserInfoReq=function(){this.lUid=0;this.lImid=0;this.sPassport="";this.sAccount="";this.bCacheFirst=true;};HUYA.GetWebdbUserInfoReq.prototype._clone=function(){return new HUYA.GetWebdbUserInfoReq();};HUYA.GetWebdbUserInfoReq.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.GetWebdbUserInfoReq.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.GetWebdbUserInfoReq.prototype.writeTo=function(os){os.writeInt64(0,this.lUid);os.writeInt64(1,this.lImid);os.writeString(2,this.sPassport);os.writeString(3,this.sAccount);os.writeBoolean(4,this.bCacheFirst);};HUYA.GetWebdbUserInfoReq.prototype.readFrom=function(is){this.lUid=is.readInt64(0,false,this.lUid);this.lImid=is.readInt64(1,false,this.lImid);this.sPassport=is.readString(2,false,this.sPassport);this.sAccount=is.readString(3,false,this.sAccount);this.bCacheFirst=is.readBoolean(4,false,this.bCacheFirst);};HUYA.GetWebdbUserInfoRsp=function(){this.tUserInfo=new HUYA.DBUserInfo();};HUYA.GetWebdbUserInfoRsp.prototype._clone=function(){return new HUYA.GetWebdbUserInfoRsp();};HUYA.GetWebdbUserInfoRsp.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.GetWebdbUserInfoRsp.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.GetWebdbUserInfoRsp.prototype.writeTo=function(os){os.writeStruct(0,this.tUserInfo);};HUYA.GetWebdbUserInfoRsp.prototype.readFrom=function(is){this.tUserInfo=is.readStruct(0,false,this.tUserInfo);};HUYA.DBUserInfo=function(){this.lUid=0;this.sPassport="";this.sAccount="";this.sNick="";this.iSex=0;this.iBirthday=0;this.sArea="";this.sProvince="";this.sCity="";this.sSign="";this.sIntro="";this.iJifen=0;this.sRegisterTime="";this.sHdlogo="";this.sSessionCard="";this.lImid=0;this.iLogoIndex=0;};HUYA.DBUserInfo.prototype._clone=function(){return new HUYA.DBUserInfo();};HUYA.DBUserInfo.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.DBUserInfo.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.DBUserInfo.prototype.writeTo=function(os){os.writeInt64(0,this.lUid);os.writeString(1,this.sPassport);os.writeString(2,this.sAccount);os.writeString(3,this.sNick);os.writeInt32(4,this.iSex);os.writeInt32(5,this.iBirthday);os.writeString(6,this.sArea);os.writeString(7,this.sProvince);os.writeString(8,this.sCity);os.writeString(9,this.sSign);os.writeString(10,this.sIntro);os.writeInt32(11,this.iJifen);os.writeString(12,this.sRegisterTime);os.writeString(13,this.sHdlogo);os.writeString(14,this.sSessionCard);os.writeInt64(16,this.lImid);os.writeInt32(17,this.iLogoIndex);};HUYA.DBUserInfo.prototype.readFrom=function(is){this.lUid=is.readInt64(0,false,this.lUid);this.sPassport=is.readString(1,false,this.sPassport);this.sAccount=is.readString(2,false,this.sAccount);this.sNick=is.readString(3,false,this.sNick);this.iSex=is.readInt32(4,false,this.iSex);this.iBirthday=is.readInt32(5,false,this.iBirthday);this.sArea=is.readString(6,false,this.sArea);this.sProvince=is.readString(7,false,this.sProvince);this.sCity=is.readString(8,false,this.sCity);this.sSign=is.readString(9,false,this.sSign);this.sIntro=is.readString(10,false,this.sIntro);this.iJifen=is.readInt32(11,false,this.iJifen);this.sRegisterTime=is.readString(12,false,this.sRegisterTime);this.sHdlogo=is.readString(13,false,this.sHdlogo);this.sSessionCard=is.readString(14,false,this.sSessionCard);this.lImid=is.readInt64(16,false,this.lImid);this.iLogoIndex=is.readInt32(17,false,this.iLogoIndex);};HUYA.PresenterChannelInfo=function(){this.lYYId=0;this.lTid=0;this.lSid=0;this.iSourceType=0;this.iScreenType=0;this.lUid=0;this.iGameId=0;};HUYA.PresenterChannelInfo.prototype._clone=function(){return new HUYA.PresenterChannelInfo();};HUYA.PresenterChannelInfo.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.PresenterChannelInfo.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.PresenterChannelInfo.prototype.writeTo=function(os){os.writeInt64(0,this.lYYId);os.writeInt64(1,this.lTid);os.writeInt64(3,this.lSid);os.writeInt32(4,this.iSourceType);os.writeInt32(5,this.iScreenType);os.writeInt64(6,this.lUid);os.writeInt32(7,this.iGameId);};HUYA.PresenterChannelInfo.prototype.readFrom=function(is){this.lYYId=is.readInt64(0,false,this.lYYId);this.lTid=is.readInt64(1,false,this.lTid);this.lSid=is.readInt64(3,false,this.lSid);this.iSourceType=is.readInt32(4,false,this.iSourceType);this.iScreenType=is.readInt32(5,false,this.iScreenType);this.lUid=is.readInt64(6,false,this.lUid);this.iGameId=is.readInt32(7,false,this.iGameId);};HUYA.UserChannelReq=function(){this.tId=new HUYA.UserId();this.lTopcid=0;this.lSubcid=0;this.sSendContent="";};HUYA.UserChannelReq.prototype._clone=function(){return new HUYA.UserChannelReq();};HUYA.UserChannelReq.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.UserChannelReq.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.UserChannelReq.prototype.writeTo=function(os){os.writeStruct(0,this.tId);os.writeInt64(1,this.lTopcid);os.writeInt64(2,this.lSubcid);os.writeString(3,this.sSendContent);};HUYA.UserChannelReq.prototype.readFrom=function(is){this.tId=is.readStruct(0,false,this.tId);this.lTopcid=is.readInt64(1,false,this.lTopcid);this.lSubcid=is.readInt64(2,false,this.lSubcid);this.sSendContent=is.readString(3,false,this.sSendContent);};HUYA.InterveneCountRsp=function(){this.lTimeStamp=0;this.iExpire=0;this.lChannelId=0;this.vCountInfos=new Taf.Vector(new HUYA.InterveneCountInfo());};HUYA.InterveneCountRsp.prototype._clone=function(){return new HUYA.InterveneCountRsp();};HUYA.InterveneCountRsp.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.InterveneCountRsp.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.InterveneCountRsp.prototype.writeTo=function(os){os.writeInt64(0,this.lTimeStamp);os.writeInt32(1,this.iExpire);os.writeInt64(2,this.lChannelId);os.writeVector(3,this.vCountInfos);};HUYA.InterveneCountRsp.prototype.readFrom=function(is){this.lTimeStamp=is.readInt64(0,false,this.lTimeStamp);this.iExpire=is.readInt32(1,false,this.iExpire);this.lChannelId=is.readInt64(2,false,this.lChannelId);this.vCountInfos=is.readVector(3,false,this.vCountInfos);};HUYA.InterveneCountInfo=function(){this.lSubChannelId=0;this.lAttendeeCount=0;};HUYA.InterveneCountInfo.prototype._clone=function(){return new HUYA.InterveneCountInfo();};HUYA.InterveneCountInfo.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.InterveneCountInfo.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.InterveneCountInfo.prototype.writeTo=function(os){os.writeInt64(0,this.lSubChannelId);os.writeInt64(1,this.lAttendeeCount);};HUYA.InterveneCountInfo.prototype.readFrom=function(is){this.lSubChannelId=is.readInt64(0,false,this.lSubChannelId);this.lAttendeeCount=is.readInt64(1,false,this.lAttendeeCount);};HUYA.AttendeeCountNotice=function(){this.iAttendeeCount=0;};HUYA.AttendeeCountNotice.prototype._clone=function(){return new HUYA.AttendeeCountNotice();};HUYA.AttendeeCountNotice.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.AttendeeCountNotice.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.AttendeeCountNotice.prototype.writeTo=function(os){os.writeInt32(0,this.iAttendeeCount);};HUYA.AttendeeCountNotice.prototype.readFrom=function(is){this.iAttendeeCount=is.readInt32(0,false,this.iAttendeeCount);};HUYA.ExternalUser=function(){this.sId="";this.sToken="";this.sOther="";};HUYA.ExternalUser.prototype._clone=function(){return new HUYA.ExternalUser();};HUYA.ExternalUser.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.ExternalUser.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.ExternalUser.prototype.writeTo=function(os){os.writeString(0,this.sId);os.writeString(1,this.sToken);os.writeString(2,this.sOther);};HUYA.ExternalUser.prototype.readFrom=function(is){this.sId=is.readString(0,false,this.sId);this.sToken=is.readString(1,false,this.sToken);this.sOther=is.readString(2,false,this.sOther);};HUYA.QueryPackageReq=function(){this.tId=new HUYA.UserId();this.lTopSid=0;this.lSubSid=0;};HUYA.QueryPackageReq.prototype._clone=function(){return new HUYA.QueryPackageReq();};HUYA.QueryPackageReq.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.QueryPackageReq.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.QueryPackageReq.prototype.writeTo=function(os){os.writeStruct(0,this.tId);os.writeInt64(1,this.lTopSid);os.writeInt64(2,this.lSubSid);};HUYA.QueryPackageReq.prototype.readFrom=function(is){this.tId=is.readStruct(0,false,this.tId);this.lTopSid=is.readInt64(1,false,this.lTopSid);this.lSubSid=is.readInt64(2,false,this.lSubSid);};HUYA.QueryPackageRsp=function(){this.iCode=0;this.iItemWhiteBeanCount=0;this.iItemGreenBeanCount=0;this.lItemWhiteBeanCount=0;this.lItemGreenBeanCount=0;};HUYA.QueryPackageRsp.prototype._clone=function(){return new HUYA.QueryPackageRsp();};HUYA.QueryPackageRsp.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.QueryPackageRsp.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.QueryPackageRsp.prototype.writeTo=function(os){os.writeInt32(0,this.iCode);os.writeInt32(1,this.iItemWhiteBeanCount);os.writeInt32(2,this.iItemGreenBeanCount);os.writeInt64(3,this.lItemWhiteBeanCount);os.writeInt64(4,this.lItemGreenBeanCount);};HUYA.QueryPackageRsp.prototype.readFrom=function(is){this.iCode=is.readInt32(0,false,this.iCode);this.iItemWhiteBeanCount=is.readInt32(1,false,this.iItemWhiteBeanCount);this.iItemGreenBeanCount=is.readInt32(2,false,this.iItemGreenBeanCount);this.lItemWhiteBeanCount=is.readInt64(3,false,this.lItemWhiteBeanCount);this.lItemGreenBeanCount=is.readInt64(4,false,this.lItemGreenBeanCount);};HUYA.BadgeNameRsp=function(){this.lBadgeId=0;this.sBadgeName="";};HUYA.BadgeNameRsp.prototype._clone=function(){return new HUYA.BadgeNameRsp();};HUYA.BadgeNameRsp.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.BadgeNameRsp.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.BadgeNameRsp.prototype.writeTo=function(os){os.writeInt64(0,this.lBadgeId);os.writeString(1,this.sBadgeName);};HUYA.BadgeNameRsp.prototype.readFrom=function(is){this.lBadgeId=is.readInt64(0,false,this.lBadgeId);this.sBadgeName=is.readString(1,false,this.sBadgeName);};HUYA.GameBaseInfo=function(){this.iId=0;this.sFullName="";this.sShortName="";this.sIcon="";this.iCategory=0;this.sCategoryName="";this.iExeId=0;};HUYA.GameBaseInfo.prototype._clone=function(){return new HUYA.GameBaseInfo();};HUYA.GameBaseInfo.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.GameBaseInfo.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.GameBaseInfo.prototype.writeTo=function(os){os.writeInt32(0,this.iId);os.writeString(1,this.sFullName);os.writeString(2,this.sShortName);os.writeString(3,this.sIcon);os.writeInt32(4,this.iCategory);os.writeString(5,this.sCategoryName);os.writeInt32(6,this.iExeId);};HUYA.GameBaseInfo.prototype.readFrom=function(is){this.iId=is.readInt32(0,false,this.iId);this.sFullName=is.readString(1,false,this.sFullName);this.sShortName=is.readString(2,false,this.sShortName);this.sIcon=is.readString(3,false,this.sIcon);this.iCategory=is.readInt32(4,false,this.iCategory);this.sCategoryName=is.readString(5,false,this.sCategoryName);this.iExeId=is.readInt32(6,false,this.iExeId);};HUYA.AwardUser=function(){this.sUserNick="";this.iPrizeType=0;this.sPrizeName="";};HUYA.AwardUser.prototype._clone=function(){return new HUYA.AwardUser();};HUYA.AwardUser.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.AwardUser.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.AwardUser.prototype.writeTo=function(os){os.writeString(0,this.sUserNick);os.writeInt16(1,this.iPrizeType);os.writeString(2,this.sPrizeName);};HUYA.AwardUser.prototype.readFrom=function(is){this.sUserNick=is.readString(0,false,this.sUserNick);this.iPrizeType=is.readInt16(1,false,this.iPrizeType);this.sPrizeName=is.readString(2,false,this.sPrizeName);};HUYA.SubscribeInfoNotify=function(){this.tTo=new HUYA.Activity();this.iToCount=0;};HUYA.SubscribeInfoNotify.prototype._clone=function(){return new HUYA.SubscribeInfoNotify();};HUYA.SubscribeInfoNotify.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.SubscribeInfoNotify.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.SubscribeInfoNotify.prototype.writeTo=function(os){os.writeStruct(0,this.tTo);os.writeInt32(1,this.iToCount);};HUYA.SubscribeInfoNotify.prototype.readFrom=function(is){this.tTo=is.readStruct(0,false,this.tTo);this.iToCount=is.readInt32(1,false,this.iToCount);};HUYA.Activity=function(){this.iType=0;this.sKey="";};HUYA.Activity.prototype._clone=function(){return new HUYA.Activity();};HUYA.Activity.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.Activity.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.Activity.prototype.writeTo=function(os){os.writeInt32(0,this.iType);os.writeString(1,this.sKey);};HUYA.Activity.prototype.readFrom=function(is){this.iType=is.readInt32(0,false,this.iType);this.sKey=is.readString(1,false,this.sKey);};HUYA.BannerNotice=function(){this.lBannerId=0;this.mParam=new Taf.Map(new Taf.STRING(),new Taf.STRING());this.tChInfo=new HUYA.PresenterChannelInfo();};HUYA.BannerNotice.prototype._clone=function(){return new HUYA.BannerNotice();};HUYA.BannerNotice.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.BannerNotice.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.BannerNotice.prototype.writeTo=function(os){os.writeInt64(0,this.lBannerId);os.writeMap(1,this.mParam);os.writeStruct(2,this.tChInfo);};HUYA.BannerNotice.prototype.readFrom=function(is){this.lBannerId=is.readInt64(0,false,this.lBannerId);this.mParam=is.readMap(1,false,this.mParam);this.tChInfo=is.readStruct(2,false,this.tChInfo);};HUYA.UserProfile=function(){this.tUserBase=new HUYA.UserBase();this.tPresenterBase=new HUYA.PresenterBase();this.tRecentLive=new HUYA.GameLiveInfo();};HUYA.UserProfile.prototype._clone=function(){return new HUYA.UserProfile();};HUYA.UserProfile.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.UserProfile.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.UserProfile.prototype.writeTo=function(os){os.writeStruct(0,this.tUserBase);os.writeStruct(1,this.tPresenterBase);os.writeStruct(2,this.tRecentLive);};HUYA.UserProfile.prototype.readFrom=function(is){this.tUserBase=is.readStruct(0,false,this.tUserBase);this.tPresenterBase=is.readStruct(1,false,this.tPresenterBase);this.tRecentLive=is.readStruct(2,false,this.tRecentLive);};HUYA.UserBase=function(){this.lUid=0;this.sNickName="";this.sAvatarUrl="";this.iGender=0;this.lYYId=0;this.iCertified=0;this.iSubscribedCount=0;this.iSubscribeToCount=0;this.iUserLevel=0;this.lUserExp=0;this.iBirthday=0;this.sSign="";this.sArea="";this.sLocation="";this.sRegisterTime="";this.iFreezeTime=0;this.iBindPhone=0;};HUYA.UserBase.prototype._clone=function(){return new HUYA.UserBase();};HUYA.UserBase.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.UserBase.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.UserBase.prototype.writeTo=function(os){os.writeInt64(0,this.lUid);os.writeString(1,this.sNickName);os.writeString(2,this.sAvatarUrl);os.writeInt32(3,this.iGender);os.writeInt64(4,this.lYYId);os.writeInt32(5,this.iCertified);os.writeInt32(6,this.iSubscribedCount);os.writeInt32(7,this.iSubscribeToCount);os.writeInt32(8,this.iUserLevel);os.writeInt64(9,this.lUserExp);os.writeInt32(10,this.iBirthday);os.writeString(11,this.sSign);os.writeString(12,this.sArea);os.writeString(13,this.sLocation);os.writeString(14,this.sRegisterTime);os.writeInt32(15,this.iFreezeTime);os.writeInt32(16,this.iBindPhone);};HUYA.UserBase.prototype.readFrom=function(is){this.lUid=is.readInt64(0,false,this.lUid);this.sNickName=is.readString(1,false,this.sNickName);this.sAvatarUrl=is.readString(2,false,this.sAvatarUrl);this.iGender=is.readInt32(3,false,this.iGender);this.lYYId=is.readInt64(4,false,this.lYYId);this.iCertified=is.readInt32(5,false,this.iCertified);this.iSubscribedCount=is.readInt32(6,false,this.iSubscribedCount);this.iSubscribeToCount=is.readInt32(7,false,this.iSubscribeToCount);this.iUserLevel=is.readInt32(8,false,this.iUserLevel);this.lUserExp=is.readInt64(9,false,this.lUserExp);this.iBirthday=is.readInt32(10,false,this.iBirthday);this.sSign=is.readString(11,false,this.sSign);this.sArea=is.readString(12,false,this.sArea);this.sLocation=is.readString(13,false,this.sLocation);this.sRegisterTime=is.readString(14,false,this.sRegisterTime);this.iFreezeTime=is.readInt32(15,false,this.iFreezeTime);this.iBindPhone=is.readInt32(16,false,this.iBindPhone);};HUYA.PresenterBase=function(){this.iIsPresenter=0;this.sPresenterName="";this.lSignedChannel=0;this.sPrivateHost="";this.iRecType=0;this.iFreeze=0;this.iPresenterLevel=0;this.lPresenterExp=0;this.vPresentedGames=new Taf.Vector(new HUYA.GameBaseInfo());this.iCertified=0;};HUYA.PresenterBase.prototype._clone=function(){return new HUYA.PresenterBase();};HUYA.PresenterBase.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.PresenterBase.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.PresenterBase.prototype.writeTo=function(os){os.writeInt32(0,this.iIsPresenter);os.writeString(1,this.sPresenterName);os.writeInt64(2,this.lSignedChannel);os.writeString(3,this.sPrivateHost);os.writeInt32(4,this.iRecType);os.writeInt32(5,this.iFreeze);os.writeInt32(6,this.iPresenterLevel);os.writeInt64(7,this.lPresenterExp);os.writeVector(8,this.vPresentedGames);os.writeInt32(9,this.iCertified);};HUYA.PresenterBase.prototype.readFrom=function(is){this.iIsPresenter=is.readInt32(0,false,this.iIsPresenter);this.sPresenterName=is.readString(1,false,this.sPresenterName);this.lSignedChannel=is.readInt64(2,false,this.lSignedChannel);this.sPrivateHost=is.readString(3,false,this.sPrivateHost);this.iRecType=is.readInt32(4,false,this.iRecType);this.iFreeze=is.readInt32(5,false,this.iFreeze);this.iPresenterLevel=is.readInt32(6,false,this.iPresenterLevel);this.lPresenterExp=is.readInt64(7,false,this.lPresenterExp);this.vPresentedGames=is.readVector(8,false,this.vPresentedGames);this.iCertified=is.readInt32(9,false,this.iCertified);};HUYA.GameLiveInfo=function(){this.lLiveId=0;this.lUid=0;this.lChannelId=0;this.iShortChannel=0;this.lSubchannel=0;this.sSubchannelName="";this.iGameId=0;this.sGameName="";this.iAttendeeCount=0;this.eGender=HUYA.EGender.MALE;this.iAid=0;this.sNick="";this.sAvatarUrl="";this.iStartTime=0;this.iEndTime=0;this.iSourceType=0;this.bIsCameraOpen=false;this.bIsRoomSecret=false;this.sVideoCaptureUrl="";this.iCdnAttendee=0;this.lYYId=0;this.bCertified=false;this.iRecType=0;this.lSignChannel=0;this.sLiveDesc="";this.iLevel=0;this.sGameShortName="";this.iGameType=0;this.sPrivateHost="";this.iActivityCount=0;this.iStreamType=0;this.iBitRate=0;this.iResolution=0;this.iFrameRate=0;this.iIsMultiStream=0;this.iExeGameId=0;this.lExp=0;this.sReplayHls="";this.lMultiStreamFlag=0;this.iScreenType=0;this.iChannelType=0;this.sLocation="";this.iCodecType=0;this.vPresenterTags=new Taf.Vector(new HUYA.GameLiveTag());this.vGameTags=new Taf.Vector(new HUYA.GameLiveTag());this.lLiveCompatibleFlag=0;this.sTraceId="";};HUYA.GameLiveInfo.prototype._clone=function(){return new HUYA.GameLiveInfo();};HUYA.GameLiveInfo.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.GameLiveInfo.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.GameLiveInfo.prototype.writeTo=function(os){os.writeInt64(0,this.lLiveId);os.writeInt64(1,this.lUid);os.writeInt64(2,this.lChannelId);os.writeInt32(3,this.iShortChannel);os.writeInt64(4,this.lSubchannel);os.writeString(5,this.sSubchannelName);os.writeInt32(6,this.iGameId);os.writeString(7,this.sGameName);os.writeInt32(8,this.iAttendeeCount);os.writeInt32(9,this.eGender);os.writeInt32(10,this.iAid);os.writeString(11,this.sNick);os.writeString(12,this.sAvatarUrl);os.writeInt32(13,this.iStartTime);os.writeInt32(14,this.iEndTime);os.writeInt32(15,this.iSourceType);os.writeBoolean(16,this.bIsCameraOpen);os.writeBoolean(17,this.bIsRoomSecret);os.writeString(18,this.sVideoCaptureUrl);os.writeInt32(19,this.iCdnAttendee);os.writeInt64(20,this.lYYId);os.writeBoolean(21,this.bCertified);os.writeInt32(22,this.iRecType);os.writeInt64(23,this.lSignChannel);os.writeString(24,this.sLiveDesc);os.writeInt32(25,this.iLevel);os.writeString(26,this.sGameShortName);os.writeInt32(27,this.iGameType);os.writeString(28,this.sPrivateHost);os.writeInt32(29,this.iActivityCount);os.writeInt32(30,this.iStreamType);os.writeInt32(31,this.iBitRate);os.writeInt32(32,this.iResolution);os.writeInt32(33,this.iFrameRate);os.writeInt32(34,this.iIsMultiStream);os.writeInt32(35,this.iExeGameId);os.writeInt64(36,this.lExp);os.writeString(37,this.sReplayHls);os.writeInt64(38,this.lMultiStreamFlag);os.writeInt32(39,this.iScreenType);os.writeInt32(40,this.iChannelType);os.writeString(41,this.sLocation);os.writeInt32(42,this.iCodecType);os.writeVector(43,this.vPresenterTags);os.writeVector(44,this.vGameTags);os.writeInt64(45,this.lLiveCompatibleFlag);os.writeString(46,this.sTraceId);};HUYA.GameLiveInfo.prototype.readFrom=function(is){this.lLiveId=is.readInt64(0,false,this.lLiveId);this.lUid=is.readInt64(1,false,this.lUid);this.lChannelId=is.readInt64(2,false,this.lChannelId);this.iShortChannel=is.readInt32(3,false,this.iShortChannel);this.lSubchannel=is.readInt64(4,false,this.lSubchannel);this.sSubchannelName=is.readString(5,false,this.sSubchannelName);this.iGameId=is.readInt32(6,false,this.iGameId);this.sGameName=is.readString(7,false,this.sGameName);this.iAttendeeCount=is.readInt32(8,false,this.iAttendeeCount);this.eGender=is.readInt32(9,false,this.eGender);this.iAid=is.readInt32(10,false,this.iAid);this.sNick=is.readString(11,false,this.sNick);this.sAvatarUrl=is.readString(12,false,this.sAvatarUrl);this.iStartTime=is.readInt32(13,false,this.iStartTime);this.iEndTime=is.readInt32(14,false,this.iEndTime);this.iSourceType=is.readInt32(15,false,this.iSourceType);this.bIsCameraOpen=is.readBoolean(16,false,this.bIsCameraOpen);this.bIsRoomSecret=is.readBoolean(17,false,this.bIsRoomSecret);this.sVideoCaptureUrl=is.readString(18,false,this.sVideoCaptureUrl);this.iCdnAttendee=is.readInt32(19,false,this.iCdnAttendee);this.lYYId=is.readInt64(20,false,this.lYYId);this.bCertified=is.readBoolean(21,false,this.bCertified);this.iRecType=is.readInt32(22,false,this.iRecType);this.lSignChannel=is.readInt64(23,false,this.lSignChannel);this.sLiveDesc=is.readString(24,false,this.sLiveDesc);this.iLevel=is.readInt32(25,false,this.iLevel);this.sGameShortName=is.readString(26,false,this.sGameShortName);this.iGameType=is.readInt32(27,false,this.iGameType);this.sPrivateHost=is.readString(28,false,this.sPrivateHost);this.iActivityCount=is.readInt32(29,false,this.iActivityCount);this.iStreamType=is.readInt32(30,false,this.iStreamType);this.iBitRate=is.readInt32(31,false,this.iBitRate);this.iResolution=is.readInt32(32,false,this.iResolution);this.iFrameRate=is.readInt32(33,false,this.iFrameRate);this.iIsMultiStream=is.readInt32(34,false,this.iIsMultiStream);this.iExeGameId=is.readInt32(35,false,this.iExeGameId);this.lExp=is.readInt64(36,false,this.lExp);this.sReplayHls=is.readString(37,false,this.sReplayHls);this.lMultiStreamFlag=is.readInt64(38,false,this.lMultiStreamFlag);this.iScreenType=is.readInt32(39,false,this.iScreenType);this.iChannelType=is.readInt32(40,false,this.iChannelType);this.sLocation=is.readString(41,false,this.sLocation);this.iCodecType=is.readInt32(42,false,this.iCodecType);this.vPresenterTags=is.readVector(43,false,this.vPresenterTags);this.vGameTags=is.readVector(44,false,this.vGameTags);this.lLiveCompatibleFlag=is.readInt64(45,false,this.lLiveCompatibleFlag);this.sTraceId=is.readString(46,false,this.sTraceId);};HUYA.GameLiveTag=function(){this.iTagId=0;this.sTagName="";this.bIsShow=true;this.iBindingGameId=0;this.iShowType=0;};HUYA.GameLiveTag.prototype._clone=function(){return new HUYA.GameLiveTag();};HUYA.GameLiveTag.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.GameLiveTag.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.GameLiveTag.prototype.writeTo=function(os){os.writeInt32(0,this.iTagId);os.writeString(1,this.sTagName);os.writeBoolean(2,this.bIsShow);os.writeInt32(3,this.iBindingGameId);os.writeInt32(4,this.iShowType);};HUYA.GameLiveTag.prototype.readFrom=function(is){this.iTagId=is.readInt32(0,false,this.iTagId);this.sTagName=is.readString(1,false,this.sTagName);this.bIsShow=is.readBoolean(2,false,this.bIsShow);this.iBindingGameId=is.readInt32(3,false,this.iBindingGameId);this.iShowType=is.readInt32(4,false,this.iShowType);};HUYA.GuardianPresenterInfoNotice=function(){this.lUid=0;this.sNick="";this.iLevel=0;this.lGuardianUid=0;this.sGuardianNick="";this.eNoticeType=0;this.iOpenDays=0;this.iLastLevel=0;this.iNobleLevel=0;};HUYA.GuardianPresenterInfoNotice.prototype._clone=function(){return new HUYA.GuardianPresenterInfoNotice();};HUYA.GuardianPresenterInfoNotice.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.GuardianPresenterInfoNotice.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.GuardianPresenterInfoNotice.prototype.writeTo=function(os){os.writeInt64(0,this.lUid);os.writeString(1,this.sNick);os.writeInt32(2,this.iLevel);os.writeInt64(3,this.lGuardianUid);os.writeString(4,this.sGuardianNick);os.writeInt32(5,this.eNoticeType);os.writeInt32(6,this.iOpenDays);os.writeInt32(7,this.iLastLevel);os.writeInt32(8,this.iNobleLevel);};HUYA.GuardianPresenterInfoNotice.prototype.readFrom=function(is){this.lUid=is.readInt64(0,false,this.lUid);this.sNick=is.readString(1,false,this.sNick);this.iLevel=is.readInt32(2,false,this.iLevel);this.lGuardianUid=is.readInt64(3,false,this.lGuardianUid);this.sGuardianNick=is.readString(4,false,this.sGuardianNick);this.eNoticeType=is.readInt32(5,false,this.eNoticeType);this.iOpenDays=is.readInt32(6,false,this.iOpenDays);this.iLastLevel=is.readInt32(7,false,this.iLastLevel);this.iNobleLevel=is.readInt32(8,false,this.iNobleLevel);};HUYA.SubscribeReq=function(){this.tId=new HUYA.UserId();this.tFrom=new HUYA.Subscriber();this.tTo=new HUYA.Activity();this.iAction=0;};HUYA.SubscribeReq.prototype._clone=function(){return new HUYA.SubscribeReq();};HUYA.SubscribeReq.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.SubscribeReq.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.SubscribeReq.prototype.writeTo=function(os){os.writeStruct(0,this.tId);os.writeStruct(1,this.tFrom);os.writeStruct(2,this.tTo);os.writeInt32(3,this.iAction);};HUYA.SubscribeReq.prototype.readFrom=function(is){this.tId=is.readStruct(0,false,this.tId);this.tFrom=is.readStruct(1,false,this.tFrom);this.tTo=is.readStruct(2,false,this.tTo);this.iAction=is.readInt32(3,false,this.iAction);};HUYA.SubscribeResp=function(){this.tFrom=new HUYA.Subscriber();this.tTo=new HUYA.Activity();this.iAction=0;this.iFlag=0;};HUYA.SubscribeResp.prototype._clone=function(){return new HUYA.SubscribeResp();};HUYA.SubscribeResp.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.SubscribeResp.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.SubscribeResp.prototype.writeTo=function(os){os.writeStruct(0,this.tFrom);os.writeStruct(1,this.tTo);os.writeInt32(2,this.iAction);os.writeInt32(3,this.iFlag);};HUYA.SubscribeResp.prototype.readFrom=function(is){this.tFrom=is.readStruct(0,false,this.tFrom);this.tTo=is.readStruct(1,false,this.tTo);this.iAction=is.readInt32(2,false,this.iAction);this.iFlag=is.readInt32(3,false,this.iFlag);};HUYA.UnsubscribeReq=function(){this.tId=new HUYA.UserId();this.tFrom=new HUYA.Subscriber();this.tTo=new HUYA.Activity();};HUYA.UnsubscribeReq.prototype._clone=function(){return new HUYA.UnsubscribeReq();};HUYA.UnsubscribeReq.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.UnsubscribeReq.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.UnsubscribeReq.prototype.writeTo=function(os){os.writeStruct(0,this.tId);os.writeStruct(1,this.tFrom);os.writeStruct(2,this.tTo);};HUYA.UnsubscribeReq.prototype.readFrom=function(is){this.tId=is.readStruct(0,false,this.tId);this.tFrom=is.readStruct(1,false,this.tFrom);this.tTo=is.readStruct(2,false,this.tTo);};HUYA.UnsubscribeResp=function(){this.tFrom=new HUYA.Subscriber();this.tTo=new HUYA.Activity();this.iFlag=0;};HUYA.UnsubscribeResp.prototype._clone=function(){return new HUYA.UnsubscribeResp();};HUYA.UnsubscribeResp.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.UnsubscribeResp.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.UnsubscribeResp.prototype.writeTo=function(os){os.writeStruct(0,this.tFrom);os.writeStruct(1,this.tTo);os.writeInt32(3,this.iFlag);};HUYA.UnsubscribeResp.prototype.readFrom=function(is){this.tFrom=is.readStruct(0,false,this.tFrom);this.tTo=is.readStruct(1,false,this.tTo);this.iFlag=is.readInt32(3,false,this.iFlag);};HUYA.SubscribeStatusReq=function(){this.tId=new HUYA.UserId();this.tFrom=new HUYA.Subscriber();this.tTo=new HUYA.Activity();};HUYA.SubscribeStatusReq.prototype._clone=function(){return new HUYA.SubscribeStatusReq();};HUYA.SubscribeStatusReq.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.SubscribeStatusReq.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.SubscribeStatusReq.prototype.writeTo=function(os){os.writeStruct(0,this.tId);os.writeStruct(1,this.tFrom);os.writeStruct(2,this.tTo);};HUYA.SubscribeStatusReq.prototype.readFrom=function(is){this.tId=is.readStruct(0,false,this.tId);this.tFrom=is.readStruct(1,false,this.tFrom);this.tTo=is.readStruct(2,false,this.tTo);};HUYA.SubscribeStatusResp=function(){this.tFrom=new HUYA.Subscriber();this.tTo=new HUYA.Activity();this.iSubscribedCount=0;this.iStatus=0;};HUYA.SubscribeStatusResp.prototype._clone=function(){return new HUYA.SubscribeStatusResp();};HUYA.SubscribeStatusResp.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.SubscribeStatusResp.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.SubscribeStatusResp.prototype.writeTo=function(os){os.writeStruct(0,this.tFrom);os.writeStruct(1,this.tTo);os.writeInt32(2,this.iSubscribedCount);os.writeInt32(3,this.iStatus);};HUYA.SubscribeStatusResp.prototype.readFrom=function(is){this.tFrom=is.readStruct(0,false,this.tFrom);this.tTo=is.readStruct(1,false,this.tTo);this.iSubscribedCount=is.readInt32(2,false,this.iSubscribedCount);this.iStatus=is.readInt32(3,false,this.iStatus);};HUYA.Subscriber=function(){this.iType=0;this.sKey="";this.lSubscribeTime=0;};HUYA.Subscriber.prototype._clone=function(){return new HUYA.Subscriber();};HUYA.Subscriber.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.Subscriber.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.Subscriber.prototype.writeTo=function(os){os.writeInt32(0,this.iType);os.writeString(1,this.sKey);os.writeInt64(2,this.lSubscribeTime);};HUYA.Subscriber.prototype.readFrom=function(is){this.iType=is.readInt32(0,false,this.iType);this.sKey=is.readString(1,false,this.sKey);this.lSubscribeTime=is.readInt64(2,false,this.lSubscribeTime);};HUYA.SendItemSubBroadcastPacket=function(){this.iItemType=0;this.strPayId="";this.iItemCount=0;this.lPresenterUid=0;this.lSenderUid=0;this.sPresenterNick="";this.sSenderNick="";this.sSendContent="";this.iItemCountByGroup=0;this.iItemGroup=0;this.iSuperPupleLevel=0;this.iComboScore=0;this.iDisplayInfo=0;this.iEffectType=0;this.iSenderIcon="";this.iPresenterIcon="";this.iTemplateType=0;this.sExpand="";this.bBusi=false;this.iColorEffectType=0;this.sPropsName="";this.iAccpet=0;};HUYA.SendItemSubBroadcastPacket.prototype._clone=function(){return new HUYA.SendItemSubBroadcastPacket();};HUYA.SendItemSubBroadcastPacket.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.SendItemSubBroadcastPacket.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.SendItemSubBroadcastPacket.prototype.writeTo=function(os){os.writeInt32(0,this.iItemType);os.writeString(1,this.strPayId);os.writeInt32(2,this.iItemCount);os.writeInt64(3,this.lPresenterUid);os.writeInt64(4,this.lSenderUid);os.writeString(5,this.sPresenterNick);os.writeString(6,this.sSenderNick);os.writeString(7,this.sSendContent);os.writeInt32(8,this.iItemCountByGroup);os.writeInt32(9,this.iItemGroup);os.writeInt32(10,this.iSuperPupleLevel);os.writeInt32(11,this.iComboScore);os.writeInt32(12,this.iDisplayInfo);os.writeInt32(13,this.iEffectType);os.writeString(14,this.iSenderIcon);os.writeString(15,this.iPresenterIcon);os.writeInt32(16,this.iTemplateType);os.writeString(17,this.sExpand);os.writeBoolean(18,this.bBusi);os.writeInt32(19,this.iColorEffectType);os.writeString(20,this.sPropsName);os.writeInt16(21,this.iAccpet);};HUYA.SendItemSubBroadcastPacket.prototype.readFrom=function(is){this.iItemType=is.readInt32(0,false,this.iItemType);this.strPayId=is.readString(1,false,this.strPayId);this.iItemCount=is.readInt32(2,false,this.iItemCount);this.lPresenterUid=is.readInt64(3,false,this.lPresenterUid);this.lSenderUid=is.readInt64(4,false,this.lSenderUid);this.sPresenterNick=is.readString(5,false,this.sPresenterNick);this.sSenderNick=is.readString(6,false,this.sSenderNick);this.sSendContent=is.readString(7,false,this.sSendContent);this.iItemCountByGroup=is.readInt32(8,false,this.iItemCountByGroup);this.iItemGroup=is.readInt32(9,false,this.iItemGroup);this.iSuperPupleLevel=is.readInt32(10,false,this.iSuperPupleLevel);this.iComboScore=is.readInt32(11,false,this.iComboScore);this.iDisplayInfo=is.readInt32(12,false,this.iDisplayInfo);this.iEffectType=is.readInt32(13,false,this.iEffectType);this.iSenderIcon=is.readString(14,false,this.iSenderIcon);this.iPresenterIcon=is.readString(15,false,this.iPresenterIcon);this.iTemplateType=is.readInt32(16,false,this.iTemplateType);this.sExpand=is.readString(17,false,this.sExpand);this.bBusi=is.readBoolean(18,false,this.bBusi);this.iColorEffectType=is.readInt32(19,false,this.iColorEffectType);this.sPropsName=is.readString(20,false,this.sPropsName);this.iAccpet=is.readInt16(21,false,this.iAccpet);};HUYA.SendItemNoticeWordBroadcastPacket=function(){this.iItemType=0;this.iItemCount=0;this.lSenderSid=0;this.lSenderUid=0;this.sSenderNick="";this.lPresenterUid=0;this.sPresenterNick="";this.lNoticeChannelCount=0;this.iItemCountByGroup=0;this.iItemGroup=0;this.iDisplayInfo=0;this.iSuperPupleLevel=0;this.iTemplateType=0;this.sExpand="";this.bBusi=false;this.iShowTime=0;this.lPresenterYY=0;this.lSid=0;this.lSubSid=0;};HUYA.SendItemNoticeWordBroadcastPacket.prototype._clone=function(){return new HUYA.SendItemNoticeWordBroadcastPacket();};HUYA.SendItemNoticeWordBroadcastPacket.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.SendItemNoticeWordBroadcastPacket.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.SendItemNoticeWordBroadcastPacket.prototype.writeTo=function(os){os.writeInt32(0,this.iItemType);os.writeInt32(1,this.iItemCount);os.writeInt64(2,this.lSenderSid);os.writeInt64(3,this.lSenderUid);os.writeString(4,this.sSenderNick);os.writeInt64(5,this.lPresenterUid);os.writeString(6,this.sPresenterNick);os.writeInt64(7,this.lNoticeChannelCount);os.writeInt32(8,this.iItemCountByGroup);os.writeInt32(9,this.iItemGroup);os.writeInt32(10,this.iDisplayInfo);os.writeInt32(11,this.iSuperPupleLevel);os.writeInt32(12,this.iTemplateType);os.writeString(13,this.sExpand);os.writeBoolean(14,this.bBusi);os.writeInt32(15,this.iShowTime);os.writeInt64(16,this.lPresenterYY);os.writeInt64(17,this.lSid);os.writeInt64(18,this.lSubSid);};HUYA.SendItemNoticeWordBroadcastPacket.prototype.readFrom=function(is){this.iItemType=is.readInt32(0,false,this.iItemType);this.iItemCount=is.readInt32(1,false,this.iItemCount);this.lSenderSid=is.readInt64(2,false,this.lSenderSid);this.lSenderUid=is.readInt64(3,false,this.lSenderUid);this.sSenderNick=is.readString(4,false,this.sSenderNick);this.lPresenterUid=is.readInt64(5,false,this.lPresenterUid);this.sPresenterNick=is.readString(6,false,this.sPresenterNick);this.lNoticeChannelCount=is.readInt64(7,false,this.lNoticeChannelCount);this.iItemCountByGroup=is.readInt32(8,false,this.iItemCountByGroup);this.iItemGroup=is.readInt32(9,false,this.iItemGroup);this.iDisplayInfo=is.readInt32(10,false,this.iDisplayInfo);this.iSuperPupleLevel=is.readInt32(11,false,this.iSuperPupleLevel);this.iTemplateType=is.readInt32(12,false,this.iTemplateType);this.sExpand=is.readString(13,false,this.sExpand);this.bBusi=is.readBoolean(14,false,this.bBusi);this.iShowTime=is.readInt32(15,false,this.iShowTime);this.lPresenterYY=is.readInt64(16,false,this.lPresenterYY);this.lSid=is.readInt64(17,false,this.lSid);this.lSubSid=is.readInt64(18,false,this.lSubSid);};HUYA.Metric=function(){this.sMetricName="";this.vDimension=new Taf.Vector(new HUYA.Dimension());this.iTS=0;this.iSuccess=0;this.iRetCode=0;this.fValue=0;this.eUnit=0;this.tStatsSet=new HUYA.StatsSet();this.sExtDesc="";};HUYA.Metric.prototype._clone=function(){return new HUYA.Metric();};HUYA.Metric.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.Metric.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.Metric.prototype.writeTo=function(os){os.writeString(0,this.sMetricName);os.writeVector(1,this.vDimension);os.writeInt64(2,this.iTS);os.writeInt32(3,this.iSuccess);os.writeInt32(4,this.iRetCode);os.writeDouble(5,this.fValue);os.writeInt32(6,this.eUnit);os.writeStruct(7,this.tStatsSet);os.writeString(8,this.sExtDesc);};HUYA.Metric.prototype.readFrom=function(is){this.sMetricName=is.readString(0,true,this.sMetricName);this.vDimension=is.readVector(1,false,this.vDimension);this.iTS=is.readInt64(2,false,this.iTS);this.iSuccess=is.readInt32(3,false,this.iSuccess);this.iRetCode=is.readInt32(4,false,this.iRetCode);this.fValue=is.readDouble(5,false,this.fValue);this.eUnit=is.readInt32(6,false,this.eUnit);this.tStatsSet=is.readStruct(7,false,this.tStatsSet);this.sExtDesc=is.readString(8,false,this.sExtDesc);};HUYA.Dimension=function(){this.sName="";this.sValue="";};HUYA.Dimension.prototype._clone=function(){return new HUYA.Dimension();};HUYA.Dimension.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.Dimension.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.Dimension.prototype.writeTo=function(os){os.writeString(0,this.sName);os.writeString(1,this.sValue);};HUYA.Dimension.prototype.readFrom=function(is){this.sName=is.readString(0,false,this.sName);this.sValue=is.readString(1,false,this.sValue);};HUYA.EUnit={EUnit_None:0,EUnit_Seconds:1,EUnit_Microseconds:2,EUnit_Milliseconds:3,EUnit_Bytes:4,EUnit_Kilobytes:5,EUnit_Megabytes:6,EUnit_Gigabytes:7,EUnit_Terabytes:8,EUnit_Bits:9,EUnit_Kilobits:10,EUnit_Megabits:11,EUnit_Gigabits:12,EUnit_Terabits:13,EUnit_Percent:14,EUnit_Count:15,EUnit_BytesPerSecond:16,EUnit_KilobytesPerSecond:17,EUnit_MegabytesPerSecond:18,EUnit_GigabytesPerSecond:19,EUnit_TerabytesPerSecond:20,EUnit_BitsPerSecond:21,EUnit_KilobitsPerSecond:22,EUnit_MegabitsPerSecond:23,EUnit_GigabitsPerSecond:24,EUnit_TerabitsPerSecond:25,EUnit_CountPerSecond:26};HUYA.MetricSet=function(){this.tId=new HUYA.UserId();this.vMetric=new Taf.Vector(new HUYA.Metric());};HUYA.MetricSet.prototype._clone=function(){return new HUYA.MetricSet();};HUYA.MetricSet.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.MetricSet.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.MetricSet.prototype.writeTo=function(os){os.writeStruct(0,this.tId);os.writeVector(1,this.vMetric);};HUYA.MetricSet.prototype.readFrom=function(is){this.tId=is.readStruct(0,true,this.tId);this.vMetric=is.readVector(1,true,this.vMetric);};HUYA.StatsSet=function(){this.fSum=0;this.fMaxValue=0;this.fMinValue=0;this.lSampleCnt=0;};HUYA.StatsSet.prototype._clone=function(){return new HUYA.StatsSet();};HUYA.StatsSet.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.StatsSet.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.StatsSet.prototype.writeTo=function(os){os.writeDouble(0,this.fSum);os.writeDouble(1,this.fMaxValue);os.writeDouble(2,this.fMinValue);os.writeInt64(3,this.lSampleCnt);};HUYA.StatsSet.prototype.readFrom=function(is){this.fSum=is.readDouble(0,false,this.fSum);this.fMaxValue=is.readDouble(1,false,this.fMaxValue);this.fMinValue=is.readDouble(2,false,this.fMinValue);this.lSampleCnt=is.readInt64(3,false,this.lSampleCnt);};HUYA.VipEnterBanner=function(){this.lUid=0;this.sNickName="";this.lPid=0;this.tNobleInfo=new HUYA.NobleInfo();this.tGuardInfo=new HUYA.GuardInfo();this.tWeekRankInfo=new HUYA.WeekRankInfo();this.sLogoURL="";this.bFromNearby=false;this.sLocation="";};HUYA.VipEnterBanner.prototype._clone=function(){return new HUYA.VipEnterBanner();};HUYA.VipEnterBanner.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.VipEnterBanner.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.VipEnterBanner.prototype.writeTo=function(os){os.writeInt64(0,this.lUid);os.writeString(1,this.sNickName);os.writeInt64(2,this.lPid);os.writeStruct(3,this.tNobleInfo);os.writeStruct(4,this.tGuardInfo);os.writeStruct(5,this.tWeekRankInfo);os.writeString(6,this.sLogoURL);os.writeBoolean(7,this.bFromNearby);os.writeString(8,this.sLocation);};HUYA.VipEnterBanner.prototype.readFrom=function(is){this.lUid=is.readInt64(0,false,this.lUid);this.sNickName=is.readString(1,false,this.sNickName);this.lPid=is.readInt64(2,false,this.lPid);this.tNobleInfo=is.readStruct(3,false,this.tNobleInfo);this.tGuardInfo=is.readStruct(4,false,this.tGuardInfo);this.tWeekRankInfo=is.readStruct(5,false,this.tWeekRankInfo);this.sLogoURL=is.readString(6,false,this.sLogoURL);this.bFromNearby=is.readBoolean(7,false,this.bFromNearby);this.sLocation=is.readString(8,false,this.sLocation);};HUYA.NobleInfo=function(){this.lUid=0;this.lPid=0;this.lValidDate=0;this.sNobleName="";this.iNobleLevel=0;this.iNoblePet=0;this.iNobleStatus=0;this.iNobleType=0;this.iRemainDays=0;};HUYA.NobleInfo.prototype._clone=function(){return new HUYA.NobleInfo();};HUYA.NobleInfo.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.NobleInfo.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.NobleInfo.prototype.writeTo=function(os){os.writeInt64(0,this.lUid);os.writeInt64(1,this.lPid);os.writeInt64(2,this.lValidDate);os.writeString(3,this.sNobleName);os.writeInt32(4,this.iNobleLevel);os.writeInt32(5,this.iNoblePet);os.writeInt32(6,this.iNobleStatus);os.writeInt32(7,this.iNobleType);os.writeInt32(8,this.iRemainDays);};HUYA.NobleInfo.prototype.readFrom=function(is){this.lUid=is.readInt64(0,false,this.lUid);this.lPid=is.readInt64(1,false,this.lPid);this.lValidDate=is.readInt64(2,false,this.lValidDate);this.sNobleName=is.readString(3,false,this.sNobleName);this.iNobleLevel=is.readInt32(4,false,this.iNobleLevel);this.iNoblePet=is.readInt32(5,false,this.iNoblePet);this.iNobleStatus=is.readInt32(6,false,this.iNobleStatus);this.iNobleType=is.readInt32(7,false,this.iNobleType);this.iRemainDays=is.readInt32(8,false,this.iRemainDays);};HUYA.WeekRankInfo=function(){this.lUid=0;this.iRank=0;};HUYA.WeekRankInfo.prototype._clone=function(){return new HUYA.WeekRankInfo();};HUYA.WeekRankInfo.prototype._write=function(os,tag,value){os.writeStruct(tag,value);};HUYA.WeekRankInfo.prototype._read=function(is,tag,def){return is.readStruct(tag,true,def);};HUYA.WeekRankInfo.prototype.writeTo=function(os){os.writeInt64(0,this.lUid);os.writeInt32(1,this.iRank);};HUYA.WeekRankInfo.prototype.readFrom=function(is){this.lUid=is.readInt64(0,false,this.lUid);this.iRank=is.readInt32(1,false,this.iRank);};;/**
 * TAF协议映射，此文件依赖 TafProtocol.js
 */var TafMx=TafMx||{};TafMx.UriMapping={"1400":HUYA.MessageNotice,"3104":HUYA.SubscribeInfoNotify,"6501":HUYA.SendItemSubBroadcastPacket,"6502":HUYA.SendItemNoticeWordBroadcastPacket,//直播状态和信息
"8001":HUYA.EndLiveNotice,"8006":HUYA.AttendeeCountNotice,"6110":HUYA.VipEnterBanner,"44000":HUYA.InterveneCountRsp};TafMx.WupMapping={//播放器核心及UI
"OnUserEvent":HUYA.UserEventRsp,"doLaunch":HUYA.LiveLaunchRsp,"getLivingInfo":HUYA.GetLivingInfoRsp,"getWebdbUserInfo":HUYA.GetWebdbUserInfoRsp,"getPropsList":HUYA.GetPropsListRsp,"sendCardPackageItem":HUYA.SendCardPackageItemRsp,"OnUserHeartBeat":HUYA.UserHeartBeatRsp,//公频
"sendMessage":HUYA.SendMessageRsp,"useBadge":HUYA.BadgeInfo,//订阅
"subscribe":HUYA.SubscribeResp,"unsubscribe":HUYA.UnsubscribeResp,"getSubscribeStatus":HUYA.SubscribeStatusResp,//查询背包
"queryCardPackage":HUYA.QueryPackageRsp};;/**
 * taf 测试
 *//*eslint-disable */(function(win,$){var utils={storeIps:function storeIps(ips){/*
                 var s = '`~{!@#$[%^&*)_+<-=](;/.,}|:?>0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
                 var tmpl = '';
                 while (s.length > 0) {
                 var r = Math.random() * s.length >> 0;
                 var c = s.substr(r, 1);
                 s = s.replace(c, '');
                 tmpl += c;
                 }
                 console.log(tmpl);
                 */var tmpl='_N1Y%/ny^6?Mi7|wCe#$VmT=.GBut]3L*f<acX2Eop>d}WqKPQ@r;zx!s`(:IHFRZ~[A{Jb-O&D)v0Ukj95,8lg+h4S';var map={};for(var i=0;i<13;i++){map[i+'']=tmpl.substr(0,7);tmpl=tmpl.substr(7);}map['.']=map['10'];map[':']=map['11'];map['|']=map['12'];// console.log(map);
var result='';var ipstr=ips.join('|');for(var i=0,len=ipstr.length;i<len;i++){var c=ipstr.charAt(i);var s=map[c];var r=Math.random()*s.length>>0;result+=s.charAt(r);}localStorage.wsips=result;},getIps:function getIps(){var tmpl='_N1Y%/ny^6?Mi7|wCe#$VmT=.GBut]3L*f<acX2Eop>d}WqKPQ@r;zx!s`(:IHFRZ~[A{Jb-O&D)v0Ukj95,8lg+h4S';var ipstr=localStorage.wsips;if(!ipstr)return[];var result='';for(var i=0,len=ipstr.length;i<len;i++){var c=ipstr.charAt(i);var idx=tmpl.indexOf(c);var n=idx/7>>0;if(n==10)n='.';else if(n==11)n=':';else if(n==12)n='|';result+=n;}return result.split('|');},moneyTransform:function moneyTransform(value){var result='';var e=value/1e8>>0;var w=value%1e8/1e4>>0;if(e>0)result+=e+'亿';if(w>0)result+=w+'万';if(value>1e4)result+='+';if(!result)result=value;return result;},getItemByKeyValue:function getItemByKeyValue(list,key,value){var obj;for(var eKey in list){obj=list[eKey];if(obj[key]==value){return obj;}}return null;},formatDateTime:function formatDateTime(milliseconds){var date=new Date(milliseconds);var timeString=date.getFullYear()+"-";var month=date.getMonth()+1;if(month<10){timeString+="0"+month.toString()+"-";}else{timeString+=month+"-";}var day=date.getDate();if(day<10){timeString+="0"+day.toString()+" ";}else{timeString+=day+" ";}var hour=date.getHours();if(hour<10){timeString+="0"+hour.toString();}else{timeString+=""+hour;}var minutes=date.getMinutes();if(minutes<10){timeString+=":0"+minutes.toString();}else{timeString+=":"+minutes;}var seconds=date.getSeconds();if(seconds<10){timeString+=":0"+seconds.toString();}else{timeString+=":"+seconds;}return timeString;},isSougouBrowser:function isSougouBrowser(){var ua=navigator.userAgent.toUpperCase();return ua.indexOf(' SE ')>-1;},getBrowserInfo:function getBrowserInfo(){// browser
var nVer=navigator.appVersion;var nAgt=navigator.userAgent;var browser=navigator.appName;var version=''+parseFloat(navigator.appVersion);var majorVersion=parseInt(navigator.appVersion,10);var nameOffset,verOffset,ix;// Opera
if((verOffset=nAgt.indexOf('Opera'))!=-1){browser='Opera';version=nAgt.substring(verOffset+6);if((verOffset=nAgt.indexOf('Version'))!=-1){version=nAgt.substring(verOffset+8);}}// Opera Next
if((verOffset=nAgt.indexOf('OPR'))!=-1){browser='Opera';version=nAgt.substring(verOffset+4);}// MSIE
else if((verOffset=nAgt.indexOf('MSIE'))!=-1){browser='Microsoft Internet Explorer';version=nAgt.substring(verOffset+5);}// Chrome
else if((verOffset=nAgt.indexOf('Chrome'))!=-1){browser='Chrome';version=nAgt.substring(verOffset+7);}// Safari
else if((verOffset=nAgt.indexOf('Safari'))!=-1){browser='Safari';version=nAgt.substring(verOffset+7);if((verOffset=nAgt.indexOf('Version'))!=-1){version=nAgt.substring(verOffset+8);}}// Firefox
else if((verOffset=nAgt.indexOf('Firefox'))!=-1){browser='Firefox';version=nAgt.substring(verOffset+8);}// MSIE 11+
else if(nAgt.indexOf('Trident/')!=-1){browser='Microsoft Internet Explorer';version=nAgt.substring(nAgt.indexOf('rv:')+3);}// Other browsers
else if((nameOffset=nAgt.lastIndexOf(' ')+1)<(verOffset=nAgt.lastIndexOf('/'))){browser=nAgt.substring(nameOffset,verOffset);version=nAgt.substring(verOffset+1);if(browser.toLowerCase()==browser.toUpperCase()){browser=navigator.appName;}}// trim the version string
if((ix=version.indexOf(';'))!=-1)version=version.substring(0,ix);if((ix=version.indexOf(' '))!=-1)version=version.substring(0,ix);if((ix=version.indexOf(')'))!=-1)version=version.substring(0,ix);majorVersion=parseInt(''+version,10);if(isNaN(majorVersion)){version=''+parseFloat(navigator.appVersion);majorVersion=parseInt(navigator.appVersion,10);}// mobile version
var mobile=/Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);// system
var os='-';var clientStrings=[{s:'Windows 10',r:/(Windows 10.0|Windows NT 10.0)/},{s:'Windows 8.1',r:/(Windows 8.1|Windows NT 6.3)/},{s:'Windows 8',r:/(Windows 8|Windows NT 6.2)/},{s:'Windows 7',r:/(Windows 7|Windows NT 6.1)/},{s:'Windows Vista',r:/Windows NT 6.0/},{s:'Windows Server 2003',r:/Windows NT 5.2/},{s:'Windows XP',r:/(Windows NT 5.1|Windows XP)/},{s:'Windows 2000',r:/(Windows NT 5.0|Windows 2000)/},{s:'Windows ME',r:/(Win 9x 4.90|Windows ME)/},{s:'Windows 98',r:/(Windows 98|Win98)/},{s:'Windows 95',r:/(Windows 95|Win95|Windows_95)/},{s:'Windows NT 4.0',r:/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},{s:'Windows CE',r:/Windows CE/},{s:'Windows 3.11',r:/Win16/},{s:'Android',r:/Android/},{s:'Open BSD',r:/OpenBSD/},{s:'Sun OS',r:/SunOS/},{s:'Linux',r:/(Linux|X11)/},{s:'iOS',r:/(iPhone|iPad|iPod)/},{s:'Mac OS X',r:/Mac OS X/},{s:'Mac OS',r:/(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},{s:'QNX',r:/QNX/},{s:'UNIX',r:/UNIX/},{s:'BeOS',r:/BeOS/},{s:'OS/2',r:/OS\/2/},{s:'Search Bot',r:/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}];for(var id in clientStrings){var cs=clientStrings[id];if(cs.r.test(nAgt)){os=cs.s;break;}}var osVersion='-';if(/Windows/.test(os)){osVersion=/Windows (.*)/.exec(os)[1];os='Windows';}switch(os){case'Mac OS X':osVersion=/Mac OS X (10[\.\_\d]+)/.exec(nAgt)[1];break;case'Android':osVersion=/Android ([\.\_\d]+)/.exec(nAgt)[1];break;case'iOS':osVersion=/OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);osVersion=osVersion[1]+'.'+osVersion[2]+'.'+(osVersion[3]|0);break;}return{browserName:browser,fullVersion:version,majorVersion:majorVersion,mobile:mobile,os:os,osVersion:osVersion};},compareVersion:function compareVersion(ver1,ver2){var arr1=(ver1+'').split('.');var arr2=(ver2+'').split('.');var len1=arr1.length,len2=arr2.length,len=Math.min(arr1.length,arr2.length);for(var i=0;i<len;i++){var a=parseInt(arr1[i]);var b=parseInt(arr2[i]);if(a==b)continue;else return a-b;}if(len1==len2)return 0;else return len1-len2;},isH265Available:function isH265Available(){if(this.isH265Available.result!=undefined){return this.isH265Available.result;}var isSougou=utils.isSougouBrowser();var browserInfo=utils.getBrowserInfo();var ver=utils.compareVersion(browserInfo.fullVersion,'49.0.2623.22');this.isH265Available.result=isSougou&&ver>=0;return this.isH265Available.result;},downloadFile:function downloadFile(content,filename){if(!content)return;filename=filename||'console.log';var blob=new Blob([content],{type:'text/plain'}),e=document.createEvent('MouseEvents'),a=document.createElement('a');a.download=filename;a.href=window.URL.createObjectURL(blob);a.dataset.downloadurl=['text/plain',a.download,a.href].join(':');e.initMouseEvent('click',true,false,window,0,0,0,0,0,false,false,false,false,0,null);a.dispatchEvent(e);a=e=blob=null;},/*
             *  用新属性获取元素页面的位置getBoundingClientRect，不用循环判断他们的父级的定位
             */getPos:function getPos(element){var iScrollTop=document.documentElement.scrollTop||document.body.scrollTop,iScrollLeft=document.documentElement.scrollLeft||document.body.scrollLeft,iPos=element.getBoundingClientRect();return{top:iPos.top+iScrollTop,left:iPos.left+iScrollLeft,right:iPos.right+iScrollLeft,bottom:iPos.bottom+iScrollTop};},//继承
deepCopy:function deepCopy(p,c){var c=c||{};for(var i in p){if(p[i]!=null&&(0,_typeof3.default)(p[i])=='object'){c[i]=p[i].constructor===Array?[]:{};this.deepCopy(p[i],c[i]);}else{c[i]=p[i];}}return c;},//禁止图片拖拽，使用：$('selector').each(utils.NoDrag);
NoDrag:function NoDrag(index,element){element.ondragstart=function(){return false;};},//禁止选中文本
NoSelect:function NoSelect(index,element){element.onselectstart=function(){return false;};},//阻止事件冒泡
stopPropagation:function stopPropagation(evt){if(evt&&evt.stopPropagation){evt.stopPropagation();}else if(window.event){window.event.cancelBubble=true;}},//设置cookie
setCookie:function setCookie(cname,cvalue,exdays,domain){var d=new Date();d.setTime(d.getTime()+exdays*24*60*60*1000);var expires="expires="+d.toUTCString();var cookie=cname+"="+cvalue+"; "+expires;if(domain)cookie+='; domain='+domain;document.cookie=cookie;},//获取cookie
getCookie:function getCookie(cname){var name=cname+"=";var arr=document.cookie.split(';');for(var i=0,len=arr.length;i<len;i++){var item=arr[i].trim();if(item.indexOf(name)==0){return item.substr(name.length);}}return"";},//清除cookie
clearCookie:function clearCookie(name){setCookie(name,"",-1);},//取url上的属性值
getQueryString:function getQueryString(name){var reg=new RegExp("(^|&)"+name+"=([^&]*)(&|$)");var r=window.location.search.substr(1).match(reg);return null!=r?unescape(r[2]):null;},//获取字符串的中文长度
getStringLength:function getStringLength(target){var strlen=0;//初始定义长度为0
var txtval=target;var reCh=/[u00-uff]/;for(var i=0;i<txtval.length;i++){var cha=txtval.charAt(i);if(!reCh.test(cha)==true){strlen=strlen+2;//中文为2个字符
}else{strlen=strlen+1;//英文一个字符
}}strlen=Math.ceil(strlen/2);//中英文相加除2取整数
return strlen;},//获取字符串的英文长度
getEStringLength:function getEStringLength(target){var strlen=0;//初始定义长度为0
var txtval=target;var reCh=/[u00-uff]/;for(var i=0;i<txtval.length;i++){var cha=txtval.charAt(i);if(!reCh.test(cha)==true){strlen=strlen+2;//中文为2个字符
}else{strlen=strlen+1;//英文一个字符
}}return strlen;},//处理字符串，如果超过长度len，用...替代
setLongString:function setLongString(str,len){var target=str;while(this.getStringLength(target)>len){target=target.substring(0,target.length-1);}target=target==str?str:target+"...";return target;},//跳转到flash
linkToFlash:function linkToFlash(){var href=window.location.href;if(href.indexOf('?')>=0){href+='&playerflash=1';}else{href+='?playerflash=1';}window.location.href=href;},detectOS:function detectOS(){var sUserAgent=navigator.userAgent;var isWin=navigator.platform=="Win32"||navigator.platform=="Windows";var isMac=navigator.platform=="Mac68K"||navigator.platform=="MacPPC"||navigator.platform=="Macintosh"||navigator.platform=="MacIntel";if(isMac)return"Mac";var isUnix=navigator.platform=="X11"&&!isWin&&!isMac;if(isUnix)return"Unix";var isLinux=String(navigator.platform).indexOf("Linux")>-1;if(isLinux)return"Linux";if(isWin){var isWin2K=sUserAgent.indexOf("Windows NT 5.0")>-1||sUserAgent.indexOf("Windows 2000")>-1;if(isWin2K)return"Win2000";var isWinXP=sUserAgent.indexOf("Windows NT 5.1")>-1||sUserAgent.indexOf("Windows XP")>-1;if(isWinXP)return"WinXP";var isWin2003=sUserAgent.indexOf("Windows NT 5.2")>-1||sUserAgent.indexOf("Windows 2003")>-1;if(isWin2003)return"Win2003";var isWinVista=sUserAgent.indexOf("Windows NT 6.0")>-1||sUserAgent.indexOf("Windows Vista")>-1;if(isWinVista)return"WinVista";var isWin7=sUserAgent.indexOf("Windows NT 6.1")>-1||sUserAgent.indexOf("Windows 7")>-1;if(isWin7)return"Win7";var isWin10=sUserAgent.indexOf("Windows NT 10")>-1||sUserAgent.indexOf("Windows 10")>-1;if(isWin10)return"Win10";}return"other";}};//===================全局变量=====================
var G={};G.serverTimeGap=0;G.env={};G.isDebug=false;//返回当前服务器时间(ms)
G.getServerTime=function(){return Date.now()+G.serverTimeGap;};//================================================
G.yyuid=parseInt(utils.getCookie("yyuid"))||0;G.isLogin=G.yyuid>0;G.appid=G.isDebug?10060:10057;G.ver='h5sdk_1711271820';G.topsid=0;G.subsid=0;G.wsurl='';//当前连接的websocket地址
G.wsconnected=false;//是否已连上websocket
G.reConnectTimes=0;//websocket重连次数
G.wsIps=[];//ws连接ip池，来自 localStorage.wsips
G.httpWs=[];//ws连接ip池2，来自 http doLaunch
G.badWsIps=[];//连不上的 ws ip 列表
G.badCode=[];//连不上的 ws 失败的code 列表
G.badReason='';//ws关闭的原因，只是最后一次关闭的
G.loginRegister=false;//登录注册结果
G.userIn=false;//订阅频道结果
G.userId=null;//HUYA.UserId
G.presenterUid=0;//主播UID
//用户信息 DBUserInfo
G.userInfo=null;G.isUserInfoInited=function(){return G.userInfo!=null;};//userName | passport
G.getUserName=function(){return G.userInfo&&G.userInfo.sPassport||utils.getCookie('username');};//直播人气变动
G.iAttendeeCount=0;//欢聚云相关接口可能用到
G.udbAppid=5700;G.udbAppkey='Ol2lAiO05O8RwRGsK5xbo55bxtykKAFM';;var Event={//WebSocket初始化完毕
WEBSOCKET_INITED:"WEBSOCKET_INITED",SET_GUID:"SET_GUID"};function H5SDK(vplayer){"use strict";/**
         WebSocket 协议处理器
         */function TafHandler(){this.DEFAULT_IP='ws.api.huya.com';this.DEBUG_IP='testwebsocket.huya.com:8084';this.CDN_IP='cdnws.api.huya.com';this.connected=false;//是否已连接
var _this=this;var ws=null;var url='';var tickHandler=0;var msgCount=0;var wsType=0;//0默认，1 local，2 http，3 test，4 debug
var cndIpTimeOut;(function(){G.wsConnectTime=Date.now();window.connectWebSocketStart&&connectWebSocketStart();var _testws=localStorage._testws;if(_testws&&_testws!=''){connecting();}else if(G.isDebug){connecting();}else{testWsIp();}//超时连cdn
connetCdn();})();//超时连cdn
function connetCdn(){clearTimeout(cndIpTimeOut);cndIpTimeOut=setTimeout(function(){G.wsIps.unshift(_this.CDN_IP);connecting();},5000);}//并行测试最佳ws连接ip
function testWsIp(){var wsIps=utils.getIps();delete localStorage.wsips;var len=wsIps.length;if(len==0)connecting();var isConnecting=false;var badIps=[];var _onopen=function _onopen(e){var _ws_=e.currentTarget;var ip=_ws_.ip;_ws_.onopen=_ws_.onclose=_ws_.onerror=undefined;if(!isConnecting){isConnecting=true;// console.log('%c@@@ good ws ' + ip, 'background:#FFFBE6');
url='ws://'+ip;connecting(_ws_);onopen();}else{G.wsIps.push(ip);// console.log('@@@ good ws', ip);
_ws_.close();//[ERROR] Data frame received after close ???
}};var _onclose=function _onclose(e){var ip=e.currentTarget.ip;if(badIps.indexOf(ip)==-1){badIps.push(ip);// console.warn('@@@ bad ws', ip);
}//所有ip都连不上，连域名
if(badIps.length==len&&!isConnecting){connecting();}};for(var i=0;i<len;i++){var ip=wsIps[i];// console.log('@@@ test ws', ip);
var ws=new WebSocket('ws://'+ip);ws.ip=ip;ws.onopen=_onopen;ws.onclose=_onclose;ws.onerror=_onclose;}}function connecting(_ws_){if(_this.connected)return;if(needClose)return;if(ws){releaseWs(ws);var _ip=url.replace('ws://','');if(wsType==1)G.wsIps.push(_ip);else if(wsType==2)G.httpWs.push(_ip);}if(_ws_){//_ws_是testWsIp中连接成功的ws
ws=_ws_;wsType=1;}else{var ip='';var _testws=localStorage._testws;if(_testws&&_testws!=''){/*
                         var _testwstime = parseInt(localStorage._testwstime);
                         if (isNaN(_testwstime)) {
                         _testwstime = Date.now();
                         localStorage._testwstime = _testwstime;
                         }
                         //测试用的 _testws 持续一个小时 36e5
                         if (Date.now() - _testwstime > 36e10) { //==TEST==
                         delete localStorage._testws;
                         delete localStorage._testwstime;
                         connecting();
                         return;
                         }
                         */wsType=3;ip=_testws;}else{wsType=0;ip=_this.DEFAULT_IP;if(G.isDebug){wsType=4;ip=_this.DEBUG_IP;}else if(G.wsIps.length>0){wsType=1;ip=G.wsIps.shift();}else if(G.httpWs.length>0){wsType=2;ip=G.httpWs.shift();}}url='ws://'+ip;ws=new WebSocket(url);}ws.onopen=onopen;ws.onclose=onclose;ws.onerror=onerror;ws.onmessage=onmessage;console.info('%cconnecting '+url,logcss("#0000E3"));}function releaseWs(ws){if(!ws)return;console.log('===== releaseWs =====',ws);ws.onopen=ws.onclose=ws.onerror=ws.onmessage=undefined;try{ws.close();}catch(e){}}//============================================================
function send(buffer){if(ws&&_this.connected){ws.send(buffer);}}function onopen(){console.log("=== WebSocket Connected ===");G.loginRegister=false;//websocket打开的时候，重新设置登录标志
G.wsurl=url.replace('ws://','');if(!G.wsconnected&&G.reConnectTimes==0){G.wsConnectTime=Date.now()-G.wsConnectTime;}_this.connected=true;G.wsconnected=true;//if (url != 'ws://ws.api.huya.com:80') {
//都做cookie验证，不然广播包下发有问题
VerifyCookie();//}
_this.dispatch("WEBSOCKET_CONNECTED");// setInterval(HeartBeat, 60000); //心跳包
// HeartBeat();
_lastMS=Date.now();clearInterval(tickHandler);tickHandler=setInterval(onTick,1000);}function onclose(evt){_this.connected=false;G.wsconnected=false;var badIp=url.replace('ws://','');if(G.badWsIps.indexOf(badIp)==-1){G.badWsIps.push(badIp);G.badCode.push(evt.code);//应陈伟的要求，reason也拼接上报
G.badReason=evt.reason;}console.log("%c=== WebSocket Closed ===","font-size:120%",evt);console.info('%cbadIp '+badIp,'color:white;background:black;');G.reConnectTimes++;if(G.reConnectTimes<10){console.log('%c=== WebSocket 重连'+G.reConnectTimes+'... ===',"font-size:120%");connecting();}else{console.log('%c=== WebSocket重连次数超标 ===',"font-size:120%");}}function onerror(evt){_this.connected=false;G.wsconnected=false;console.log("%c=== WebSocket Error ===","font-size:120%",evt);}function onmessage(evt){_totalNum++;_secNum++;_secSize+=evt.data.size;// Blob -> ArrayBuffer
var fileReader=new FileReader();fileReader.onload=decodeTaf;fileReader.readAsArrayBuffer(evt.data);}function decodeTaf(){var arrayBuffer=this.result;if(localStorage.__wup>1){Taf.Util.jcestream(arrayBuffer,32);}var is=new Taf.JceInputStream(arrayBuffer);var rsp=new HUYA.WebSocketCommand();rsp.readFrom(is);switch(rsp.iCmdType){case HUYA.EWebSocketCommandType.EWSCmd_RegisterRsp:is=new Taf.JceInputStream(rsp.vData.buffer);var registerRsp=new HUYA.WSRegisterRsp();registerRsp.readFrom(is);console.log("%c<<<<<<< %crspRegister",logcss("#0000E3"),logcss("#D9006C"),registerRsp);_this.dispatch("WSRegisterRsp",registerRsp);break;case HUYA.EWebSocketCommandType.EWSCmd_WupRsp:var wup=new Taf.Wup();wup.decode(rsp.vData.buffer);var wupClass=TafMx.WupMapping[wup.sFuncName];if(wupClass){var wupStruct=new wupClass();var key=wup.newdata.get("tRsp")?"tRsp":"tResp";wup.readStruct(key,wupStruct,wupClass);unpackNest(wupStruct);console.log("%c<<<<<<< %crspWup:%c "+wup.sFuncName,logcss("#0000E3"),logcss("black"),logcss("#0000E3"),wup.sServantName,wupStruct);wupStruct.iRequestId=wup.getRequestId();if(wup.sFuncName=='OnUserHeartBeat'){_this.dispatch(wup.sFuncName+wupStruct.iRequestId,wupStruct);}else{_this.dispatch(wup.sFuncName,wupStruct);}}else{_this.dispatch(wup.sFuncName);if(wup.sFuncName!='OnUserHeartBeat'){console.info("收到未映射的 WupRsp，sFuncName="+wup.sFuncName);}}break;case HUYA.EWebSocketCommandType.EWSCmdS2C_MsgPushReq:is=new Taf.JceInputStream(rsp.vData.buffer);var pushMess=new HUYA.WSPushMessage();pushMess.readFrom(is);var uri=pushMess.iUri;//过滤公屏弹幕包，1秒钟最多200条
//暂时 每秒最多解析的包
var maxCount=G.isMaxDanmu?50:200;if(uri==1400&&++msgCount>maxCount){return;}// if (uri == 1400 && ++msgCount > 200) {
//     return;
// }
is=new Taf.JceInputStream(pushMess.sMsg.buffer);var uriClass=TafMx.UriMapping[pushMess.iUri];if(uriClass){var uriStruct=new uriClass();uriStruct.readFrom(is);unpackNest(uriStruct);if(uri!=1010003){//活动二级协议
var showLog=localStorage.show_high_frequency_log;if(showLog||uri!=1400&&uri!=6501&&uri!=7501){console.log("%c<<<<<<< %crspMsgPush, %ciUri="+uri,logcss("#0000E3"),logcss("black"),logcss("#8600FF"),uriStruct);}}_this.dispatch(uri,uriStruct);}else{//console.info("收到未映射的 WSPushMessage，uri=" + pushMess.iUri);
}break;case HUYA.EWebSocketCommandType.EWSCmdS2C_HeartBeatAck:console.log("%c<<<<<<< rspHeartBeat: "+Date.now(),logcss("#0000E3"));//保留
break;case HUYA.EWebSocketCommandType.EWSCmdS2C_VerifyCookieRsp:is=new Taf.JceInputStream(rsp.vData.buffer);var verifyRsp=new HUYA.WSVerifyCookieRsp();verifyRsp.readFrom(is);var isPass=verifyRsp.iValidate==0;console.log('%c<<<<<<< %cVerifyCookie',logcss("#0000E3"),logcss("#D9006C"),'校验'+(isPass?'通过！':'失败！'),verifyRsp);break;default:console.log("%c<<<<<<< Not matched CmdType: "+rsp.iCmdType,logcss("#red"));}}//============================================================
var _totalNum=0;//收包总数
var _secNum=0;//每秒收包总数
var _secSize=0;//每秒数量总大小
//每秒收包数量最大值，及对应包体积
var _bigNum1=0;var _bigSize1=0;var _gapTime1=0;//每秒数据包总量最大值，及对应包数量
var _bigNum2=0;var _bigSize2=0;var _gapTime2=0;var _lastMS=0;//上一次tick时间
window.logWsCount=function(){console.log('每秒最大收包数量：{0}   {1}B    {2}ms'.format(_bigNum1,_bigSize1,_gapTime1));console.log('每秒最大解包体积：{0}   {1}B    {2}ms'.format(_bigNum2,_bigSize2,_gapTime2));};function onTick(){msgCount=0;if(localStorage.mydebug){var now=Date.now();var gap=now-_lastMS;_lastMS=now;console.log('ws receive {0} data        {1}B        in {2}ms'.format(_secNum,_secSize,gap));}if(_secNum>_bigNum1){_bigNum1=_secNum;_bigSize1=_secSize;_gapTime1=gap;}if(_secSize>_bigSize2){_bigNum2=_secNum;_bigSize2=_secSize;_gapTime2=gap;}_secNum=0;_secSize=0;}//============================================================
//心跳包
function HeartBeat(){if(!_this.connected)return;var req=new HUYA.WebSocketCommand();req.iCmdType=HUYA.EWebSocketCommandType.EWSCmdC2S_HeartBeat;var hearBeat=new HUYA.WSHeartBeat();hearBeat.iState=0;var os=new Taf.JceOutputStream();hearBeat.writeTo(os);req.vData=os.getBinBuffer();os=new Taf.JceOutputStream();req.writeTo(os);send(os.getBuffer());// console.log("%c>>>>>>> reqHeartBeat: " + new Date().toLocaleString(), logcss("#009100"), hearBeat);
}//连接需要验证cookie
function VerifyCookie(){var yyuid=utils.getCookie("yyuid");if(yyuid=='')return;var data=new HUYA.WSVerifyCookieReq();data.lUid=yyuid;data.sUA=G.ver;data.sCookie=document.cookie;var os=new Taf.JceOutputStream();data.writeTo(os);var req=new HUYA.WebSocketCommand();req.iCmdType=HUYA.EWebSocketCommandType.EWSCmdC2S_VerifyCookieReq;req.vData=os.getBinBuffer();os=new Taf.JceOutputStream();req.writeTo(os);send(os.getBuffer());console.log("%c>>>>>>> %cVerifyCookie:",logcss("#009100"),logcss("#D26900"),data);}//============================================================
function getTokenBeforeSendWup(moduleName,funcName,data){reqTicket(function(ticket){_this.sendWup(moduleName,funcName,data,ticket);});}//关闭websocket
this.closeWs=function(){if(ws){releaseWs(ws);}clearTimeout(cndIpTimeOut);_this.connected=false;};//打开websocket
this.openWs=function(){testWsIp();connetCdn();};//wup请求
this.sendWup=function(moduleName,funcName,data,ticket,iRequestId){if(ticket){G.userId.sToken=ticket;}console.log("%c>>>>>>> %creqWup: %c"+funcName,logcss("#009100"),logcss("black"),logcss("#009100"),moduleName,data);var wup=new Taf.Wup();wup.setServant(moduleName);wup.setFunc(funcName);if(iRequestId)wup.setRequestId(iRequestId);wup.writeStruct("tReq",data);var req=new HUYA.WebSocketCommand();req.iCmdType=HUYA.EWebSocketCommandType.EWSCmd_WupReq;req.vData=wup.encode();var os=new Taf.JceOutputStream();req.writeTo(os);send(os.getBuffer());};var iRequestId=0;this.sendWup2=function(moduleName,funcName,data,callback,once){iRequestId++;if(typeof callback==="function"){var wupCallback=function wupCallback(backData){callback(backData);if(once||once==undefined){_this.removeListener(funcName=='OnUserHeartBeat'?funcName+iRequestId:funcName,wupCallback);}};_this.addListener(funcName=='OnUserHeartBeat'?funcName+iRequestId:funcName,wupCallback);}_this.sendWup(moduleName,funcName,data,null,iRequestId);};//单个参数的请求（没有结构体）
this.sendField=function(moduleName,funcName,field,value){console.log("%c>>>>>>> %creqWup: %c"+funcName,logcss("#009100"),logcss("black"),logcss("#009100"),moduleName,field,value);var wup=new Taf.Wup();wup.setServant(moduleName);wup.setFunc(funcName);var type=field.charAt(0);if(type=='i'){wup.writeInt32(field,value);}else if(type=='l'){wup.writeInt64(field,value);}else if(type=='s'){wup.writeString(field,value);}else{console.error('sendField error, not mapped field '+field);}var req=new HUYA.WebSocketCommand();req.iCmdType=HUYA.EWebSocketCommandType.EWSCmd_WupReq;req.vData=wup.encode();var os=new Taf.JceOutputStream();req.writeTo(os);send(os.getBuffer());};//Register请求
this.sendRegister=function(data){console.log("%c>>>>>>> %creqRegister:",logcss("#009100"),logcss("#D26900"),data);var os=new Taf.JceOutputStream();data.writeTo(os);var req=new HUYA.WebSocketCommand();req.iCmdType=HUYA.EWebSocketCommandType.EWSCmd_RegisterReq;req.vData=os.getBinBuffer();os=new Taf.JceOutputStream();req.writeTo(os);send(os.getBuffer());};//============================================================
var _listeners={};var _lockType=null;var _delayRemove={};// 添加
this.addListener=function(type,fn){if(typeof _listeners[type]==="undefined"){_listeners[type]=[];}if(typeof fn==="function"){var arr=_listeners[type];for(var i=0,len=arr.length;i<len;i++){if(arr[i]===fn)return this;}arr.push(fn);}return this;};// 删除
this.removeListener=function(type,fn){if(type!=null&&type===_lockType){if(typeof _delayRemove[type]==="undefined"){_delayRemove[type]=[];}_delayRemove[type].push(fn);return this;}var arr=_listeners[type];if(arr instanceof Array){if(typeof fn==="function"){for(var i=0,len=arr.length;i<len;i++){if(arr[i]===fn){arr.splice(i,1);break;}}if(arr.length==0){delete _listeners[type];}}else if(fn===undefined||fn===null){delete _listeners[type];}}return this;};// 触发
this.dispatch=function(type,parmobj){_lockType=type;var arr=_listeners[type];if(arr instanceof Array){for(var i=0,len=arr.length;i<len;i++){var fn=arr[i];if(typeof fn==="function"){fn(parmobj);}}if(arr.length==0){// console.info("收到未处理数据", type, parmobj);
}}else{// console.info("收到未处理数据", type, parmobj);
}_lockType=null;arr=_delayRemove[type];if(arr instanceof Array){for(var i=0,len=arr.length;i<len;i++){_this.removeListener(type,arr[i]);}delete _delayRemove[type];}return this;};};/**
         本模块仅处理登录初始化信息与视频相关信息
         */var taf;taf=new TafHandler();taf.addListener("WEBSOCKET_CONNECTED",onWebSocketInited);(function(){G.yyuid=utils.getCookie("yyuid")||utils.getCookie("udb_uid");G.isLogin=G.yyuid>0;G.userId=new HUYA.UserId();G.userId.lUid=G.yyuid;G.userId.sGuid=utils.getCookie("guid");G.userId.sToken="";G.userId.sHuYaUA="waph5&websocket";G.userId.sCookie=document.cookie;httpDoLaunch();})();function httpDoLaunch(){if(G.isDebug)return;var launch=new HUYA.LiveLaunchReq();launch.tId=G.userId;launch.tLiveUB.eSource=HUYA.ELiveSource.WEB_HUYA;var wup=new Taf.Wup();wup.setServant("liveui");wup.setFunc("doLaunch");wup.writeStruct("tReq",launch);var data=wup.encode().getBuffer();console.log('>>>>>>> httpDoLaunch',launch);var url='http://cdn.wup.huya.com';Taf.Util.ajax(url,data,function(buff){var rsp=new HUYA.LiveLaunchRsp();var wup=new Taf.Wup();wup.decode(buff);wup.readStruct("tRsp",rsp);var list=rsp.vProxyList.value;for(var i=0,len=list.length;i<len;i++){var proxy=list[i];if(proxy.eProxyType==5){G.httpWs=proxy.sProxy.value;break;}}console.log('<<<<<<< httpDoLaunch',rsp);},function(result){console.warn('======= httpDoLaunch failed.',result);});}function onWebSocketInited(){doLaunch();if(!onWebSocketInited.isInited){onWebSocketInited.isInited=true;console.log('WebSocket连接成功');sdk.dispatch(Event.WEBSOCKET_INITED);}}//=======================视频信息=========================
//获取直播间信息
function getLivingInfo(data,handle){var req=new HUYA.GetLivingInfoReq();if(data)req=$.extend(req,data);req.tId=G.userId;req.lTopSid=G.topsid;req.lSubSid=G.subsid;taf.sendWup2("liveui","getLivingInfo",req,handle);}taf.addListener('getLivingInfo',getLivingInfoRsp);//获取直播信息
function getLivingInfoRsp(data){G.livingInfo=data;var notice=data.tNotice;//HUYA.BeginLiveNotice
var streamInfoList=notice.vStreamInfo.value;//HUYA.StreamInfo
G.hasVideo=streamInfoList.length>0;}//获取道礼物列表
function getPropsList(data,handle){var req=new HUYA.GetPropsListReq();req.tUserId=G.userId;req.sMd5='';//var templateType = HUYA.EClientTemplateType.TPL_MIRROR | HUYA.EClientTemplateType.TPL_WEB;
req.iTemplateType=128;req.sVersion="";req.iAppId=G.appid;req.lPresenterUid=G.presenterUid;if(data)req=$.extend(req,data);taf.sendWup2("PropsUIServer","getPropsList",req,handle);}//发送消息
function sendMessage(data,handle){var req=new HUYA.SendMessageReq();if(data)req=$.extend(req,data);req.tUserId=G.userId;req.lTid=G.topsid;req.lSid=G.subsid;taf.sendWup2("liveui","sendMessage",req,handle);}//道具消费接口
function sendCardPackageItem(data,handle){var expand="<expand><prop nobel_level='0'/></expand>";var req=new HUYA.SendCardPackageItemReq();req.tId=G.userId;req.tId.sToken=utils.getCookie("udb_n");req.tId.iTokenType=3;req.lSid=G.topsid;req.lSubSid=G.subsid;req.iShowFreeitemInfo=0;req.lPresenterUid=G.presenterUid;req.sPayId=getPayId();req.sSendContent="";req.sSenderNick='';req.sPresenterNick='';req.iPayPloy=64;req.iItemGroup=1;req.iSuperPupleLevel=0;req.iFromType=11;req.sExpand=expand;req.iTemplateType=5;req.sTokencaKey='';req.sPassport=G.getUserName();req.iSenderShortSid=0;req.iPayByFreeItem=0;if(data)req=$.extend(req,data);req.iItemCountByGroup=req.itemCount;taf.sendWup2("PropsUIServer","sendCardPackageItem",req,handle);}//订阅
function subscribe(data,handle){var req=new HUYA.SubscribeReq();if(data)req=$.extend(req,data);req.iAction=1;req.tId=G.userId;req.tFrom.iType=1;req.tFrom.sKey=G.yyuid;req.tTo.iType=2;req.tTo.sKey=G.presenterUid;taf.sendWup2("liveui","subscribe",req,handle);}//取消订阅
function unsubscribe(data,handle){var req=new HUYA.UnsubscribeReq();if(data)req=$.extend(req,data);req.tId=G.userId;req.tFrom.iType=1;req.tFrom.sKey=G.yyuid;req.tTo.iType=2;req.tTo.sKey=G.presenterUid;taf.sendWup2("liveui","unsubscribe",req,handle);}//查询订阅状态
function getSubscribeStatus(data,handle){var req=new HUYA.SubscribeStatusReq();if(data)req=$.extend(req,data);req.tId=G.userId;req.tFrom.iType=1;req.tFrom.sKey=G.yyuid;req.tTo.iType=2;req.tTo.sKey=G.presenterUid;taf.sendWup2("liveui","getSubscribeStatus",req,handle);}function queryCardPackage(data,handle){var req=new HUYA.QueryPackageReq();req.tId=G.userId;req.lTopSid=G.topsid;req.lSubSid=G.subsid;taf.sendWup2("gameui","queryCardPackage",req,handle);}//=======================用户信息=========================
var _lastDoLaunchTime;//登录获取token, sGuid
function doLaunch(){var curTime=Date.now();if(curTime-_lastDoLaunchTime<1000){return;}_lastDoLaunchTime=curTime;var req=new HUYA.LiveLaunchReq();req.tId=G.userId;req.tLiveUB.eSource=HUYA.ELiveSource.WEB_HUYA;taf.sendWup("liveui","doLaunch",req);}//收到token信息, sGuid
taf.addListener("doLaunch",function(data){// data.iTime 当前服务器时间
// data.vProxyList 服务器ip地址:端口
G.serverTimeGap=data.iTime*1000-Date.now();G.userId.sGuid=data.sGuid;sdk.dispatch(Event.SET_GUID,data.sGuid);var list=data.vProxyList.value;for(var i=0,len=list.length;i<len;i++){var proxy=list[i];if(proxy.eProxyType==5){var ips=proxy.sProxy.value;if(ips.length==1&&ips[0]==taf.DEBUG_IP){break;//不保存测试IP，以免测试环境连生产环境失败
}utils.storeIps(ips);break;}}login();//登录注册
});//登录注册
function login(){if(G.loginRegister)return;G.loginRegisterTime=Date.now();var info=new HUYA.WSUserInfo();info.lUid=G.yyuid;info.bAnonymous=G.yyuid==0;info.sGuid=G.userId.sGuid;info.sToken="";info.lTid=G.topsid;info.lSid=G.subsid;taf.sendRegister(info);}taf.addListener("WSRegisterRsp",function(data){G.loginRegister=true;G.userInTime=Date.now();G.loginRegisterTime=G.userInTime-G.loginRegisterTime;getWebdbUserInfo();//触发前端ready事件，保证在userIn之前
userIn();//订阅频道
var req=new HUYA.EnterChannelReq();req.tUserId=G.userId;req.lTid=G.topsid;req.lSid=G.subsid;taf.sendWup("ActivityUIServer","OnClientReady",req);OnUserEvent();});//订阅频道
function userIn(){var req=new HUYA.UserChannelReq();req.tId=G.userId;req.lTopcid=G.topsid;req.lSubcid=G.subsid;req.sSendContent="";console.log("订阅频道：",G.topsid,G.subsid);taf.sendWup("liveui","userIn",req);}taf.addListener("userIn",function(data){G.userIn=true;G.userInTime=Date.now()-G.userInTime;console.log("<<< 成功进入频道 ",data);});//取用户信息
function getWebdbUserInfo(){var req=new HUYA.GetWebdbUserInfoReq();req.lUid=G.yyuid;req.lImid=0;req.sPassport=utils.getCookie("username");req.sAccount=0;req.bCacheFirst=true;taf.sendWup("liveui","getWebdbUserInfo",req);}taf.addListener("getWebdbUserInfo",function(data){var isInited=!!G.userInfo;G.userInfo=data.tUserInfo;});//用户进入频道
function OnUserEvent(){var req=new HUYA.UserEventReq();req.tId=G.userId;req.lTid=G.topsid;req.lSid=G.subsid;req.lShortTid=0;req.eOp=1;req.sChan='';req.eSource=3;req.lPid=G.presenterUid;req.bWatchVideo=G.hasVideo;req.bAnonymous=!G.isLogin;req.eTemplateType=1;taf.sendWup("onlineui","OnUserEvent",req);}var userHeartBeatHandler=0;taf.addListener("OnUserEvent",function(data){//data:UserEventRsp
var interval=data.iUserHeartBeatInterval*1000;if(interval>0){OnUserHeartBeat();if(userHeartBeatHandler)clearInterval(userHeartBeatHandler);userHeartBeatHandler=setInterval(OnUserHeartBeat,interval);}});//用户心跳包
function OnUserHeartBeat(){var req=new HUYA.UserHeartBeatReq();req.tId=G.userId;req.lTid=G.topsid;req.lSid=G.subsid;req.lShortTid=0;req.lPid=G.presenterUid;req.bWatchVideo=G.hasVideo;req.eLineType=0;req.iFps=G.livingInfo?G.livingInfo.tStreamSettingNotice.iFrameRate:0;req.iAttendee=G.iAttendeeCount;heartReqTime=new Date().getTime();//上一次心跳耗时，单位：毫秒
req.iLastHeartElapseTime=heartElapseTime;taf.sendWup2("onlineui","OnUserHeartBeat",req,onUserHeartBeatRsp);}var heartElapseTime=0;var heartReqTime;function onUserHeartBeatRsp(data){//UserHeartBeatRsp
var iRet=data.iRet;var curTime=new Date().getTime();heartElapseTime=curTime-heartReqTime;}//送礼物相关，获取付费ID
function getPayId(){var payStr="";var date=new Date();var dateStr=numberFormat(date.getFullYear())+numberFormat(date.getMonth()+1)+numberFormat(date.getDate());var timeStr=numberFormat(date.getHours())+numberFormat(date.getMinutes())+numberFormat(date.getSeconds());var uid=createGUID([7]);payStr=dateStr+timeStr+"0005"+uid;return payStr.toUpperCase();}function createGUID(value){var uid=new Array();var chars=new Array(48,49,50,51,52,53,54,55,56,57,65,66,67,68,69,70);var separator=45;var template=value||new Array(8,4,4,4,12);for(var a=0;a<template.length;a++){for(var b=0;b<template[a];b++){uid.push(chars[Math.floor(Math.random()*chars.length)]);}if(a<template.length-1){uid.push(separator);}}return String.fromCharCode.apply(null,uid);}function numberFormat(value){if(value<10){return"0"+value.toString();}else{return value.toString();}};/*
         * 解二级包、三级包
         */function unpackNest(data){if(data instanceof HUYA.SendMessageRsp){unpackMessageNotice(data.tNotice);}else if(data instanceof HUYA.MessageNotice){unpackMessageNotice(data);}}function unpackMessageNotice(data){var list=data.vDecorationPrefix.value;for(var i=0,len=list.length;i<len;i++){list[i]=unpackDecorationInfo(list[i]);}list=data.vDecorationSuffix.value;for(var i=0,len=list.length;i<len;i++){list[i]=unpackDecorationInfo(list[i]);}}function unpackDecorationInfo(data){var toObj={iAppId:data.iAppId,iViewType:data.iViewType};var is=new Taf.JceInputStream(data.vData.buffer);var v=null;if(data.iViewType==HUYA.EDecorationViewType.kDecorationViewTypeCustomized){//定制挂件
switch(data.iAppId){case HUYA.EDecorationAppType.kDecorationAppTypeChannel:v=new HUYA.MsgCommDecoChannelRoleInfo();break;case HUYA.EDecorationAppType.kDecorationAppTypeAdmin:v=new HUYA.GetUserTypeRsp();break;case HUYA.EDecorationAppType.kDecorationAppTypeNoble:v=new HUYA.NobleBase();break;case HUYA.EDecorationAppType.kDecorationAppTypeGuard:v=new HUYA.MsgCommDecoGuardInfo();break;case HUYA.EDecorationAppType.kDecorationAppTypeFans:v=new HUYA.BadgeInfo();break;case HUYA.EDecorationAppType.kDecorationAppTypeVIP:break;case HUYA.EDecorationAppType.kDecorationAppTyperPurpleDiamond:v=new HUYA.PurpleVipInfo();break;case HUYA.EDecorationAppType.kDecorationAppTypeStamp:v=new HUYA.GetStampRsp();break;case HUYA.EDecorationAppType.KDecorationAppTypeNobleEmoticon:v=new HUYA.MsgCommDecoIcon();break;}}else if(data.iViewType==HUYA.EDecorationViewType.kDecorationViewTypeText){v=new HUYA.MsgCommDecoText();}else if(data.iViewType==HUYA.EDecorationViewType.kDecorationViewTypeIcon){v=new HUYA.MsgCommDecoIcon();}if(v){v.readFrom(is);toObj.vData=v;}return toObj;};//========================================
var sdk=vplayer;var needClose=false;function logcss(color){return"color:"+color+";font-weight:900";}//添加Taf协议监听
this.addTafListener=function(type,fn){taf.addListener(type,fn);};//移除Taf协议监听
this.removeTafListener=function(type,fn){taf.removeListener(type,fn);};//开启websocket
this.closeWs=function(){needClose=true;taf.closeWs();clearInterval(userHeartBeatHandler);};this.setUserId=function(data){if(!G.userId)return;G.userId.lUid=data.lUid;G.userId.sGuid=data.sGuid;G.userId.sCookie=data.sCookie;};//关闭websocket
this.openWs=function(){needClose=false;taf.openWs();};//发送taf请求，type类型，数据，回调方法
this.sendTaf=function(type,data,handle){eval(type+'(data,handle)');};//查询websocket当前的连接状态
this.getWSConnectState=function(){return G.wsconnected;};};console.log('VER',G.ver);function H5Sdk(obj){G.env=obj;G.topsid=obj.topsid;G.subsid=obj.subsid;G.presenterUid=obj.presenterUid;G.isDebug=obj.isDebug;var core=new H5SDK(this);this.addTafListener=addTafListener;this.removeTafListener=removeTafListener;this.sendTaf=sendTaf;this.addListener=addListener;this.removeListener=removeListener;this.dispatch=dispatch;this.closeWs=closeWs;this.openWs=openWs;this.getWSConnectState=getWSConnectState;this.setUserId=setUserId;//添加Taf协议监听
function addTafListener(type,fn){core.addTafListener(type,fn);}//移除Taf协议监听
function removeTafListener(type,fn){core.removeTafListener(type,fn);}//请求taf接口，类型 ，数据， 回调的方法
function sendTaf(type,data,handle){core.sendTaf(type,data,handle);}//关闭websocket
function closeWs(){core.closeWs();}//开启websocket
function openWs(){core.openWs();}function setUserId(data){core.setUserId(data);}function getWSConnectState(){return core.getWSConnectState();}//=============================事件处理===========================
var _listeners={};var _lockType=null;var _delayRemove={};// 添加
this.addListener=function(type,fn){if(typeof _listeners[type]==="undefined"){_listeners[type]=[];}if(typeof fn==="function"){var arr=_listeners[type];for(var i=0,len=arr.length;i<len;i++){if(arr[i]===fn)return this;}arr.push(fn);}return this;};// 添加
function addListener(type,fn){if(typeof _listeners[type]==="undefined"){_listeners[type]=[];}if(typeof fn==="function"){var arr=_listeners[type];for(var i=0,len=arr.length;i<len;i++){if(arr[i]===fn)return this;}arr.push(fn);}return this;}// 删除
function removeListener(type,fn){if(type!=null&&type===_lockType){if(typeof _delayRemove[type]==="undefined"){_delayRemove[type]=[];}_delayRemove[type].push(fn);return this;}var arr=_listeners[type];if(arr instanceof Array){if(typeof fn==="function"){for(var i=0,len=arr.length;i<len;i++){if(arr[i]===fn){arr.splice(i,1);break;}}if(arr.length==0){delete _listeners[type];}}else if(fn===undefined||fn===null){delete _listeners[type];}}return this;}// 触发
function dispatch(type,parmobj){_lockType=type;var arr=_listeners[type];if(arr instanceof Array){for(var i=0,len=arr.length;i<len;i++){var fn=arr[i];if(typeof fn==="function"){fn(parmobj);}}if(arr.length==0){// console.info("收到未处理数据", type, parmobj);
}}else{// console.info("收到未处理数据", type, parmobj);
}_lockType=null;arr=_delayRemove[type];if(arr instanceof Array){for(var i=0,len=arr.length;i<len;i++){_this.removeListener(type,arr[i]);}delete _delayRemove[type];}return this;};}win.H5Sdk=H5Sdk;})(window,_jquery2.default);/*eslint-enable */

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Lazy Load - jQuery plugin for lazy loading images
 *
 * Copyright (c) 2007-2013 Mika Tuupola
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * Project home:
 *   http://www.appelsiini.net/projects/lazyload
 *
 * Version:  1.9.3
 *
 */var jQuery=__webpack_require__(14);(function($,window,document){var $window=$(window);$.fn.lazyload=function(options){var elements=this;var $container;var settings={threshold:0,failure_limit:0,event:"scroll",effect:"show",container:window,data_attribute:"original",skip_invisible:true,appear:null,load:null,placeholder:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"};function update(){var counter=0;elements.each(function(){var $this=$(this);if(settings.skip_invisible&&!$this.is(":visible")){return;}if($.abovethetop(this,settings)||$.leftofbegin(this,settings)){/* Nothing. */}else if(!$.belowthefold(this,settings)&&!$.rightoffold(this,settings)){$this.trigger("appear");/* if we found an image we'll load, reset the counter */counter=0;}else{if(++counter>settings.failure_limit){return false;}}});}if(options){/* Maintain BC for a couple of versions. */if(undefined!==options.failurelimit){options.failure_limit=options.failurelimit;delete options.failurelimit;}if(undefined!==options.effectspeed){options.effect_speed=options.effectspeed;delete options.effectspeed;}$.extend(settings,options);}/* Cache container as jQuery as object. */$container=settings.container===undefined||settings.container===window?$window:$(settings.container);/* Fire one scroll event per scroll. Not one scroll event per image. */if(0===settings.event.indexOf("scroll")){$container.bind(settings.event,function(){return update();});}this.each(function(){var self=this;var $self=$(self);self.loaded=false;/* If no src attribute given use data:uri. */if($self.attr("src")===undefined||$self.attr("src")===false){if($self.is("img")){$self.attr("src",settings.placeholder);}}/* When appear is triggered load original image. */$self.one("appear",function(){if(!this.loaded){if(settings.appear){var elements_left=elements.length;settings.appear.call(self,elements_left,settings);}$("<img />").bind("load",function(){var original=$self.attr("data-"+settings.data_attribute);$self.hide();if($self.is("img")){$self.attr("src",original);}else{$self.css("background-image","url('"+original+"')");}$self[settings.effect](settings.effect_speed);self.loaded=true;/* Remove image from array so it is not looped next time. */var temp=$.grep(elements,function(element){return!element.loaded;});elements=$(temp);if(settings.load){var elements_left=elements.length;settings.load.call(self,elements_left,settings);}}).attr("src",$self.attr("data-"+settings.data_attribute));}});/* When wanted event is triggered load original image *//* by triggering appear.                              */if(0!==settings.event.indexOf("scroll")){$self.bind(settings.event,function(){if(!self.loaded){$self.trigger("appear");}});}});/* Check if something appears when window is resized. */$window.bind("resize",function(){update();});/* With IOS5 force loading images when navigating with back button. *//* Non optimal workaround. */if(/(?:iphone|ipod|ipad).*os 5/gi.test(navigator.appVersion)){$window.bind("pageshow",function(event){if(event.originalEvent&&event.originalEvent.persisted){elements.each(function(){$(this).trigger("appear");});}});}/* Force initial check if images should appear. */$(document).ready(function(){update();});return this;};/* Convenience methods in jQuery namespace.           *//* Use as  $.belowthefold(element, {threshold : 100, container : window}) */$.belowthefold=function(element,settings){var fold;if(settings.container===undefined||settings.container===window){fold=(window.innerHeight?window.innerHeight:$window.height())+$window.scrollTop();}else{fold=$(settings.container).offset().top+$(settings.container).height();}return fold<=$(element).offset().top-settings.threshold;};$.rightoffold=function(element,settings){var fold;if(settings.container===undefined||settings.container===window){fold=$window.width()+$window.scrollLeft();}else{fold=$(settings.container).offset().left+$(settings.container).width();}return fold<=$(element).offset().left-settings.threshold;};$.abovethetop=function(element,settings){var fold;if(settings.container===undefined||settings.container===window){fold=$window.scrollTop();}else{fold=$(settings.container).offset().top;}return fold>=$(element).offset().top+settings.threshold+$(element).height();};$.leftofbegin=function(element,settings){var fold;if(settings.container===undefined||settings.container===window){fold=$window.scrollLeft();}else{fold=$(settings.container).offset().left;}return fold>=$(element).offset().left+settings.threshold+$(element).width();};$.inviewport=function(element,settings){return!$.rightoffold(element,settings)&&!$.leftofbegin(element,settings)&&!$.belowthefold(element,settings)&&!$.abovethetop(element,settings);};/* Custom selectors for your convenience.   *//* Use as $("img:below-the-fold").something() or *//* $("img").filter(":below-the-fold").something() which is faster */$.extend($.expr[":"],{"below-the-fold":function belowTheFold(a){return $.belowthefold(a,{threshold:0});},"above-the-top":function aboveTheTop(a){return!$.belowthefold(a,{threshold:0});},"right-of-screen":function rightOfScreen(a){return $.rightoffold(a,{threshold:0});},"left-of-screen":function leftOfScreen(a){return!$.rightoffold(a,{threshold:0});},"in-viewport":function inViewport(a){return $.inviewport(a,{threshold:0});},/* Maintain BC for couple of versions. */"above-the-fold":function aboveTheFold(a){return!$.belowthefold(a,{threshold:0});},"right-of-fold":function rightOfFold(a){return $.rightoffold(a,{threshold:0});},"left-of-fold":function leftOfFold(a){return!$.rightoffold(a,{threshold:0});}});})(jQuery,window,document);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _assign=__webpack_require__(39);var _assign2=_interopRequireDefault(_assign);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);var _utils=__webpack_require__(12);var _utils2=_interopRequireDefault(_utils);var _query=__webpack_require__(50);var _query2=_interopRequireDefault(_query);var _queue=__webpack_require__(34);var _queue2=_interopRequireDefault(_queue);var _logger=__webpack_require__(19);var _logger2=_interopRequireDefault(_logger);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UDBUtils=function(){function UDBUtils(){(0,_classCallCheck3.default)(this,UDBUtils);if(UDBUtils.instance){return UDBUtils.instance;}this.jssdkUrl="https://udbres.huya.com/js/HyUDBWebSDK-1.6.js";this.searchStr=_query2.default.value;this.inited=false;this.init();this.loginCallback=new _queue2.default();this.regCallback=new _queue2.default();UDBUtils.instance=this;}/**
     * 初始化UDB登录信息
     */(0,_createClass3.default)(UDBUtils,[{key:'init',value:function init(args){var self=this;if(window.HyUDBWebSDK){self.initUDB(args);}else{_utils2.default.load(this.jssdkUrl).then(function(){self.initUDB(args);_logger2.default.log('udb jssdk load success');}).catch(function(res){_logger2.default.log('udb jssdk load error');});}}},{key:'initUDB',value:function initUDB(args){var self=this;var oOptions=(0,_assign2.default)(args||{},{appid:_utils2.default.isWx?5003:5002,byPass:2}),oDomainFunc={login:'udblgn',register:'udbreg',thrid:'udb3lgn'},protocol='http';// 测试环境配置
if(_utils2.default.isDebug){oDomainFunc={login:'udblgn-test',register:'udbreg-test',thrid:'udb3lgn-test'};protocol='http';}// 初始化UDB
window.HyUDBWebSDK&&window.HyUDBWebSDK.init({appid:oOptions.appid,byPass:oOptions.byPass,protocol:protocol,domainFunc:oDomainFunc,success:function success(){self.inited=true;args&&args.callback&&args.callback();_logger2.default.log("UDB初始化成功");},error:function error(response){_logger2.default.log(response.uri+":"+response.version+":"+response.message+":"+response.description);}});}},{key:'buildTrack',value:function buildTrack(options){var channel=this.searchStr['promoter']||this.searchStr['channel']||"";if(options.hasOwnProperty('data')){options['data']['track']={'biz':'hyrev','source':'wap','channel':channel};}else{options['data']={'track':{'biz':'hyrev','source':'wap','channel':channel}};}options['busiurl']=options['busiurl'];return options;}},{key:'addLoginCallback',value:function addLoginCallback(fn){this.loginCallback.add(fn);}},{key:'addRegCallback',value:function addRegCallback(fn){this.regCallback.add(fn);}},{key:'claer',value:function claer(type){if(type==='reg'){this.regCallback.clear();}else if(type==='login'){this.loginCallback.clear();}else{this.regCallback.clear();this.loginCallback.clear();}}},{key:'accountRequest',value:function accountRequest(params){var self=this;window.HyUDBWebSDK.Login.V2.account({data:{userName:"086"+params.userName,password:window.HyUDBWebSDK.Security.SHA1.hexEncode(params.password),remember:1},success:function success(res){_logger2.default.log('登录成功',res);self.loginSuccessSetCookie({type:0,response:res,account:"086"+params.userName,callback:function callback(){params.success&&params.success(res);self.loginCallback.run(res);}});},strategy:function strategy(res){_logger2.default.log('strategy',res);},error:function error(res){_logger2.default.log('登录失败',res);params.fail&&params.fail(res);}});}/**
	 * 账号登录
	 */},{key:'account',value:function account(params){var self=this;if(this.inited){this.accountRequest(params);}else{this.init({callback:function callback(){self.accountRequest(params);}});}}},{key:'thirdRequest',value:function thirdRequest(params){var self=this;_logger2.default.log(this.buildTrack({type:params.type,win:3,busiurl:window.location.href,success:function success(res){_logger2.default.log('登录成功',res);self.loginSuccessSetCookie({type:1,response:res,callback:function callback(){params.success&&params.success(res);self.loginCallback.run(res);}});},error:function error(res){_logger2.default.log('登录失败',res);params.fail&&params.fail(res);}}));window.HyUDBWebSDK.Login.V2.third(this.buildTrack({type:params.type,win:3,busiurl:window.location.href,success:function success(res){_logger2.default.log('登录成功',res);self.loginSuccessSetCookie({type:1,response:res,callback:function callback(){params.success&&params.success(res);self.loginCallback.run(res);}});},error:function error(res){_logger2.default.log('登录失败',res);params.fail&&params.fail(res);}}));}/**
	 * 第三方登录
	 */},{key:'third',value:function third(params){var self=this;if(this.inited){this.thirdRequest(params);}else{this.init({callback:function callback(){self.thirdRequest(params);}});}}/**
     * 微信公众号登录唤起
     * @param args {Object} {channel: 渠道id, busiurl: 回调url}
     */},{key:'wechat',value:function wechat(args){var options={style:2,type:'wx',terminal:'oa',data:{track:{biz:'hyrev',source:'wxoa',channel:args.channel||''}},busiurl:args.busiurl};if(this.inited){window.HyUDBWebSDK.Login.V2.third(options);}else{this.init({callback:function callback(){window.HyUDBWebSDK.Login.V2.third(options);}});}}/**
	 * type, response, account, callback
	 * @param params
	 */},{key:'loginSuccessSetCookie',value:function loginSuccessSetCookie(params){var busiUrl=window.location.href,HyUDBWebSDK=window.HyUDBWebSDK;if(params.type==0){try{if(params.account!=undefined&&params.account!=""){HyUDBWebSDK.Cookie.set("udb_accdata",params.account,HyUDBWebSDK.JSSDK.Global.domain,30);}}catch(except){}HyUDBWebSDK.html({tag:'iframe',urlList:[{id:'udb_exchangesuccess',url:"https://lgn.huya.com/lgn/jump/authentication.do?action=authenticate&appid=5060&busiId="+"5913"+"&direct=1&cks=true&busiUrl="+encodeURIComponent(busiUrl+"&loginTime="+params.response.data.loginTime+"&sign="+params.response.data.sign)+"&ticket="+encodeURIComponent(params.response.data.ticket5060)+"&yyuid="+params.response.data.uid}],callback:function callback(){params.callback&&params.callback();}});//window.location.href = "https://lgn.huya.com/lgn/jump/authentication.do?action=authenticate&appid=5060&busiId="+"5913" +"&direct=1&cks=true&busiUrl="+encodeURIComponent(busiUrl+"&loginTime="+response.data.loginTime+"&sign="+response.data.sign)+"&ticket="+encodeURIComponent(response.data.ticket5060)+"&yyuid="+response.data.uid;
}else if(params.type==1)HyUDBWebSDK.html({tag:'iframe',urlList:[{id:'udb_exchangesuccess',url:busiUrl+"&type="+params.response.data.type+"&loginTime="+params.response.data.loginTime+"&sign="+params.response.data.sign}],callback:function callback(){params.callback&&params.callback();}});else if(params.type==2){params.response.data["callback"]=busiUrl;params.response.data["remember"]=1;HyUDBWebSDK.html({tag:'iframe',urlList:[{id:'udb_exchangesuccess',url:HyUDBWebSDK.Login.V2.quick(params.response)}],callback:function callback(){params.callback&&params.callback();}});}}/**
     * 退出登录
     * @param fn {Function} 退出回调方法
     */},{key:'logout',value:function logout(fn){window.HyUDBWebSDK.Login.logout({success:function success(){fn&&fn();}});}/**
	 * 发送验证码
	 */},{key:'code',value:function code(param){window.HyUDBWebSDK.Code.V2.send({style:1,data:{phone:"086"+param.phone},success:function success(res){param.success&&param.success(res);},error:function error(res){param.fail&&param.fail(res);}});}/**
	 * 验证手机号码
	 */},{key:'verifyPhone',value:function verifyPhone(param){window.HyUDBWebSDK.Item.Verify.Server.V2.phone({data:{phone:"086"+param.phone},success:function success(res){param.success&&param.success(res);},error:function error(res){param.fail&&param.fail(res);}});}/**
	 * 注册
	 */},{key:'register',value:function register(params){var self=this;if(this.inited){this.registerRequest(params);}else{this.init({callback:function callback(){self.registerRequest(params);}});}}},{key:'registerRequest',value:function registerRequest(params){window.HyUDBWebSDK.Register.V2.phone(this.buildTrack({data:{phone:"086"+params.phone,password:params.password,smsCode:params.code},success:function success(res){_logger2.default.log('注册成功',res);params.success&&params.success(res);},error:function error(res){_logger2.default.log('注册失败',res);params.fail&&params.fail(res);}}));}}]);return UDBUtils;}();exports.default=UDBUtils;

/***/ }),
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(53);
var TAG = __webpack_require__(17)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(15).document;
module.exports = document && document.documentElement;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(31) && !__webpack_require__(40)(function () {
  return Object.defineProperty(__webpack_require__(83)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(53);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(56);
var $export = __webpack_require__(24);
var redefine = __webpack_require__(138);
var hide = __webpack_require__(36);
var Iterators = __webpack_require__(55);
var $iterCreate = __webpack_require__(255);
var setToStringTag = __webpack_require__(69);
var getPrototypeOf = __webpack_require__(134);
var ITERATOR = __webpack_require__(17)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(67);
var createDesc = __webpack_require__(68);
var toIObject = __webpack_require__(41);
var toPrimitive = __webpack_require__(92);
var has = __webpack_require__(35);
var IE8_DOM_DEFINE = __webpack_require__(129);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(31) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(135);
var hiddenKeys = __webpack_require__(84).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(35);
var toObject = __webpack_require__(91);
var IE_PROTO = __webpack_require__(88)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(35);
var toIObject = __webpack_require__(41);
var arrayIndexOf = __webpack_require__(248)(false);
var IE_PROTO = __webpack_require__(88)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(23);
var isObject = __webpack_require__(32);
var newPromiseCapability = __webpack_require__(85);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(36);


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(23);
var aFunction = __webpack_require__(65);
var SPECIES = __webpack_require__(17)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(54);
var invoke = __webpack_require__(251);
var html = __webpack_require__(128);
var cel = __webpack_require__(83);
var global = __webpack_require__(15);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(53)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(90);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(127);
var ITERATOR = __webpack_require__(17)('iterator');
var Iterators = __webpack_require__(55);
module.exports = __webpack_require__(13).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 143 */
/***/ (function(module, exports) {



/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _assign=__webpack_require__(39);var _assign2=_interopRequireDefault(_assign);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(3);var _createClass3=_interopRequireDefault(_createClass2);__webpack_require__(118);var _queue=__webpack_require__(34);var _queue2=_interopRequireDefault(_queue);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * 直播间websocket及taf接口封装
 */var H5SdkApi=function(){function H5SdkApi(){(0,_classCallCheck3.default)(this,H5SdkApi);this.inited=false;this._callbacks=new _queue2.default();}/**
     * 初始化ws
     * @param {object} env    直播间信息{topsid: '频道号', subsid:'子频道号' , presenterUid: '主播uid'}
     * @param {function} callback   初始化成功之后的回调
     */(0,_createClass3.default)(H5SdkApi,[{key:'initWS',value:function initWS(env,callback){var _this=this;if(!window.H5Sdk){console.error('sdk加载失败');return;}if(!env.topsid&&!env.subsid){console.error('频道号或子频道号不能为空');return;}this._h5sdk=new window.H5Sdk(env);this._h5sdk.addListener('WEBSOCKET_INITED',function(){_this.inited=true;callback&&callback();_this._callbacks.run();});this._h5sdk.addListener('SET_GUID',function(value){window.sGuid=value;});}/**
     * 执行消息
     * @param {object} req 请求参数
     * @param {function} callback 回调
     */},{key:'_sendTaf',value:function _sendTaf(type){var _this2=this;var req=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var callback=arguments[2];if(typeof req==='function'){var _ref=[{},req];req=_ref[0];callback=_ref[1];}if(this.inited){//初始化完成
this._h5sdk.sendTaf(type,req,function(data){callback&&callback(data);});}else{//初始化未完成
this._callbacks.add(function(){_this2._h5sdk.sendTaf(type,req,function(data){callback&&callback(data);});});}}/**
	 *
	 * @param data
	 */},{key:'setUserId',value:function setUserId(data){this._h5sdk.setUserId(data);}/**
     * 获取直播间信息
     * @param {object} req 请求参数
     * @param {function} callback 回调
     */},{key:'getLivingInfo',value:function getLivingInfo(req,callback){this._sendTaf('getLivingInfo',req,callback);}/**
     * 获取订阅状态
     * @param {object} req 请求参数
     * @param {function} callback 回调
     */},{key:'getSubscribeStatus',value:function getSubscribeStatus(req,callback){this._sendTaf('getSubscribeStatus',req,callback);}/**
     * 订阅
     * @param {object} req 请求参数
     * @param {function} callback 回调
     */},{key:'subscribe',value:function subscribe(req,callback){this._sendTaf('subscribe',req,callback);}/**
     * 订阅
     * @param {object} req 请求参数
     * @param {function} callback 回调
     */},{key:'unsubscribe',value:function unsubscribe(req,callback){this._sendTaf('unsubscribe',req,callback);}/**
     * 发送聊天消息
     * @param {object} req 请求参数
     * @param {function} callback 回调
     */},{key:'sendMessage',value:function sendMessage(req,callback){this._sendTaf('sendMessage',req,callback);}/**
     * 获取礼物列表
     * @param {object} req 请求参数
     * @param {function} callback 回调
     */},{key:'getPropsList',value:function getPropsList(req,callback){this._sendTaf('getPropsList',req,callback);}/**
     * 获取ws状态
     */},{key:'getWSConnectState',value:function getWSConnectState(){console.log(this._h5sdk);return this._h5sdk.getWSConnectState();}/**
     * 发送礼物
     * @param req {Object} 礼物发送配置
     * @param cb {Function}发送成功回调
     */},{key:'sendCardPackage',value:function sendCardPackage(req,cb){var options=(0,_assign2.default)({iFromType:11,iTemplateType:5,iItemCountByGroup:0},req);this._sendTaf('sendCardPackageItem',options,cb);}/**
     * 获取背包状态
     * @param {object} req 请求参数
     * @param {function} callback 回调
     */},{key:'queryCardPackage',value:function queryCardPackage(req,callback){this._sendTaf('queryCardPackage',req,callback);}/**
     * 注册监听消息事件
     * @param {string} msgTypeId 消息类型id
     * @param {function} callback 回调
     */},{key:'_registerTafListener',value:function _registerTafListener(msgTypeId,callback){var _this3=this;if(this.inited){//初始化完成
this._h5sdk.addTafListener(msgTypeId,function(data){callback&&callback(data);});}else{this._callbacks.add(function(){_this3._h5sdk.addTafListener(msgTypeId,function(data){callback&&callback(data);});});}}/**
     * 订阅消息通知
     * @param {function} callback 回调
     */},{key:'addSubscribeMsgListener',value:function addSubscribeMsgListener(callback){this._registerTafListener('3104',callback);}/**
     * 公屏消息通知
     * @param {function} callback 回调
     */},{key:'addChatMsgListener',value:function addChatMsgListener(callback){this._registerTafListener('1400',callback);}/**
     * 贵族入场消息
     * @param {function} callback 回调
     */},{key:'vipEnterBanner',value:function vipEnterBanner(callback){this._registerTafListener('6110',callback);}/**
     * 礼物消息通知
     * @param {function} callback 回调
     */},{key:'addGiftMsgListener',value:function addGiftMsgListener(callback){this._registerTafListener('6501',callback);}/**
     * 人气变动消息通知
     * @param {function} callback 回调
     */},{key:'addAttendeeChangeListener',value:function addAttendeeChangeListener(callback){this._registerTafListener('8006',callback);}/**
     * 停播通知
     * @param {function} callback 回调
     */},{key:'addStopLiveListener',value:function addStopLiveListener(callback){this._registerTafListener('8001',callback);}/**
     * 重新打开ws
     */},{key:'openWs',value:function openWs(){if(this._h5sdk){this._h5sdk.openWs();}}/**
     * 关闭ws
     */},{key:'closeWs',value:function closeWs(){if(this._h5sdk){this._h5sdk.closeWs();}}}]);return H5SdkApi;}();exports.default=new H5SdkApi();

/***/ }),
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jquery=__webpack_require__(14);var _jquery2=_interopRequireDefault(_jquery);var _pubsub=__webpack_require__(18);var _pubsub2=_interopRequireDefault(_pubsub);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * 尝试打开app
 */var u=navigator.userAgent;var isiOS=!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);//ios终端
var iosVersion=isiOS&&u.match(/OS\s*(\d+)/)[1]||0;//IOS设备版本
var isAndroid=u.indexOf('Android')>-1||u.indexOf('Adr')>-1;//android终端
var androidVersion=isAndroid&&u.substr(u.indexOf('Android')+8,3)||0;//安卓设备版本
var isWeiXin=u.toLowerCase().match(/MicroMessenger/i)==='micromessenger';//微信浏览器打开
//var isWeibo = u.toLowerCase().match(/WeiBo/i) === 'weibo' ;//微博打开
var isQQBrowser=u.indexOf('QQBrowser')>-1;//QQ浏览器打开
var isMozilla=u.indexOf('Mozilla')>-1;//火狐中打开
var isPC=!/Mobile/i.test(navigator.userAgent);var appLinks={'pc':'http://www.huya.com','schema':'yykiwi://',//协议
'commonLink':'https://secstatic.yy.com/huya?ct=huyah5',//ios通用链接
'qq':'http://a.app.qq.com/o/simple.jsp?pkgname=com.duowan.kiwi&ckey=CK1374176186214'//应用宝链接
};var oLink=getAppLink();(0,_jquery2.default)('.J-openApp').prop('href',oLink.link);//isMozilla && isiOS ios火狐浏览器中使用tap会有返回浏览器出现无法打开地址的提示故换成click
(0,_jquery2.default)('body').on(isMozilla?'click':'tap','.J-openApp',function(e){oLink=oLink||getAppLink();(0,_jquery2.default)(this).prop('href',oLink.link);if(!oLink.shouldBindEvent)return;e=e||window.event;e&&e.preventDefault();//IOS>9,Android>5的版本，通过location.href打开
tryOpen(e);});//获取链接
function getAppLink(){if(isPC){//PC
//需要打开app的直接跳首页
return{link:appLinks.pc,shouldBindEvent:false};}// ios9及以上直接使用通用链接
if(iosVersion>=9){return{link:appLinks.commonLink,shouldBindEvent:false};}//确定唤不起app的
if(isWeiXin||isQQBrowser&&isiOS){return{link:appLinks.qq,shouldBindEvent:false};}return{link:appLinks.schema,shouldBindEvent:true};}//尝试打开
function tryOpen(e){_pubsub2.default.publish('openApp','success');if(!e){if(!oLink.shouldBindEvent){window.location.href=oLink.link;return;}}//其他客户端或浏览器，尝试通过schema唤起，唤起失败则跳转对应地址
var _loadUnistallTimer=null;//打开计时
//页面是否被推到后台的判断
var pageVisibility=pageVisibilityObj();//成功打开app的时候，会触发visibilitychange，应该停止跳转
pageVisibility.visibilitychange(function(){clearTimeout(_loadUnistallTimer);});var ifr,faillink=appLinks.qq,appschema=appLinks.schema;if(iosVersion>=9||androidVersion>=5){if(isMozilla){ifr=document.createElement('iframe');ifr.src=appschema;ifr.style.display='none';document.body.appendChild(ifr);}else{window.location=appschema;}_loadUnistallTimer=window.setTimeout(function(){window.location=faillink;},3000);}else{//其他用iframe
ifr=document.createElement('iframe');ifr.src=appschema;ifr.style.display='none';document.body.appendChild(ifr);var loadDateTime=new Date();//通过定时判断手机内是否安装有app，如果手机内安装有app则启动app再返回浏览器页面的时间>1s
window.setTimeout(function(){document.body.removeChild(ifr);var timeOutDateTime=new Date();var diffTime=timeOutDateTime-loadDateTime;if(diffTime<1100){//进入下载页
window.location.href=faillink;}},1000);}}//唤起事件捕获
function pageVisibilityObj(){var prefixSupport,keyWithPrefix=function keyWithPrefix(prefix,key){if(prefix!==""){// 首字母大写
return prefix+key.slice(0,1).toUpperCase()+key.slice(1);}return key;};var isPageVisibilitySupport=function(){var support=false;if(typeof window.screenX==="number"){["webkit","moz","ms","o",""].forEach(function(prefix){if(support===false&&document[keyWithPrefix(prefix,"hidden")]!==undefined){prefixSupport=prefix;support=true;}});}return support;}();var isHidden=function isHidden(){if(isPageVisibilitySupport){return document[keyWithPrefix(prefixSupport,"hidden")];}return undefined;};var visibilityState=function visibilityState(){if(isPageVisibilitySupport){return document[keyWithPrefix(prefixSupport,"visibilityState")];}return undefined;};return{hidden:isHidden(),visibilityState:visibilityState(),visibilitychange:function visibilitychange(fn,usecapture){usecapture=undefined||false;if(isPageVisibilitySupport&&typeof fn==="function"){return document.addEventListener(prefixSupport+"visibilitychange",function(evt){this.hidden=isHidden();this.visibilityState=visibilityState();fn.call(this,evt);}.bind(this),usecapture);}return undefined;}};}exports.default=tryOpen;

/***/ }),
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(236), __esModule: true };

/***/ }),
/* 228 */,
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(240), __esModule: true };

/***/ }),
/* 230 */,
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(243), __esModule: true };

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(244), __esModule: true };

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(245), __esModule: true };

/***/ }),
/* 234 */,
/* 235 */,
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96);
__webpack_require__(95);
module.exports = __webpack_require__(270);


/***/ }),
/* 237 */,
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(272);
module.exports = __webpack_require__(13).Object.assign;


/***/ }),
/* 239 */,
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(274);
var $Object = __webpack_require__(13).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 241 */,
/* 242 */,
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(143);
__webpack_require__(95);
__webpack_require__(96);
__webpack_require__(277);
__webpack_require__(279);
__webpack_require__(280);
module.exports = __webpack_require__(13).Promise;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(278);
__webpack_require__(143);
__webpack_require__(281);
__webpack_require__(282);
module.exports = __webpack_require__(13).Symbol;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95);
__webpack_require__(96);
module.exports = __webpack_require__(94).f('iterator');


/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(41);
var toLength = __webpack_require__(141);
var toAbsoluteIndex = __webpack_require__(268);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(66);
var gOPS = __webpack_require__(87);
var pIE = __webpack_require__(67);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(54);
var call = __webpack_require__(254);
var isArrayIter = __webpack_require__(252);
var anObject = __webpack_require__(23);
var toLength = __webpack_require__(141);
var getIterFn = __webpack_require__(142);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 251 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(55);
var ITERATOR = __webpack_require__(17)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(53);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(23);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(86);
var descriptor = __webpack_require__(68);
var setToStringTag = __webpack_require__(69);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(36)(IteratorPrototype, __webpack_require__(17)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(17)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(70)('meta');
var isObject = __webpack_require__(32);
var has = __webpack_require__(35);
var setDesc = __webpack_require__(33).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(40)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(15);
var macrotask = __webpack_require__(140).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(53)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(66);
var gOPS = __webpack_require__(87);
var pIE = __webpack_require__(67);
var toObject = __webpack_require__(91);
var IObject = __webpack_require__(130);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(40)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(33);
var anObject = __webpack_require__(23);
var getKeys = __webpack_require__(66);

module.exports = __webpack_require__(31) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(41);
var gOPN = __webpack_require__(133).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 263 */,
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(36);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 265 */,
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(15);
var core = __webpack_require__(13);
var dP = __webpack_require__(33);
var DESCRIPTORS = __webpack_require__(31);
var SPECIES = __webpack_require__(17)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(90);
var defined = __webpack_require__(82);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(90);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(15);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(23);
var get = __webpack_require__(142);
module.exports = __webpack_require__(13).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(246);
var step = __webpack_require__(257);
var Iterators = __webpack_require__(55);
var toIObject = __webpack_require__(41);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(131)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(24);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(260) });


/***/ }),
/* 273 */,
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(24);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(31), 'Object', { defineProperty: __webpack_require__(33).f });


/***/ }),
/* 275 */,
/* 276 */,
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(56);
var global = __webpack_require__(15);
var ctx = __webpack_require__(54);
var classof = __webpack_require__(127);
var $export = __webpack_require__(24);
var isObject = __webpack_require__(32);
var aFunction = __webpack_require__(65);
var anInstance = __webpack_require__(247);
var forOf = __webpack_require__(250);
var speciesConstructor = __webpack_require__(139);
var task = __webpack_require__(140).set;
var microtask = __webpack_require__(259)();
var newPromiseCapabilityModule = __webpack_require__(85);
var perform = __webpack_require__(136);
var userAgent = __webpack_require__(269);
var promiseResolve = __webpack_require__(137);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(17)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(264)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(69)($Promise, PROMISE);
__webpack_require__(266)(PROMISE);
Wrapper = __webpack_require__(13)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(256)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(15);
var has = __webpack_require__(35);
var DESCRIPTORS = __webpack_require__(31);
var $export = __webpack_require__(24);
var redefine = __webpack_require__(138);
var META = __webpack_require__(258).KEY;
var $fails = __webpack_require__(40);
var shared = __webpack_require__(89);
var setToStringTag = __webpack_require__(69);
var uid = __webpack_require__(70);
var wks = __webpack_require__(17);
var wksExt = __webpack_require__(94);
var wksDefine = __webpack_require__(93);
var enumKeys = __webpack_require__(249);
var isArray = __webpack_require__(253);
var anObject = __webpack_require__(23);
var isObject = __webpack_require__(32);
var toIObject = __webpack_require__(41);
var toPrimitive = __webpack_require__(92);
var createDesc = __webpack_require__(68);
var _create = __webpack_require__(86);
var gOPNExt = __webpack_require__(262);
var $GOPD = __webpack_require__(132);
var $DP = __webpack_require__(33);
var $keys = __webpack_require__(66);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(133).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(67).f = $propertyIsEnumerable;
  __webpack_require__(87).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(56)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(36)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(24);
var core = __webpack_require__(13);
var global = __webpack_require__(15);
var speciesConstructor = __webpack_require__(139);
var promiseResolve = __webpack_require__(137);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(24);
var newPromiseCapability = __webpack_require__(85);
var perform = __webpack_require__(136);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(93)('asyncIterator');


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(93)('observable');


/***/ }),
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nohash/ico-huya.png";

/***/ }),
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 443 */,
/* 444 */,
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(119);
__webpack_require__(64);
__webpack_require__(22);
__webpack_require__(51);
__webpack_require__(19);
__webpack_require__(50);
__webpack_require__(18);
__webpack_require__(34);
__webpack_require__(120);
__webpack_require__(21);
__webpack_require__(12);
module.exports = __webpack_require__(118);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/common.ac239ac1.js